function numeralFemaleEnding(condition) {
    return condition + "-";
}
function numeralMaleEnding(condition) {
    return condition + "-";
}
function numeralNeuterEnding(condition) {
    return condition + "-";
}
function plural(count, parameters) {
    var m10 = count % 10;
    var m100 = count % 100;
    if (m10 === 1 && m100 !== 11) {
        return parameters[0];
    }
    if (m10 >= 2 && m10 <= 4 && (m100 < 10 || m100 >= 20)) {
        return parameters[1];
    }
    return parameters[2];
}
function signed(condition) {
    if (condition === 0) {
        return '0';
    }
    var num = Number.parseFloat(condition.toFixed(2));
    if (condition > 0) {
        return '+' + num.toString();
    }
    return num.toString();
}
function europeanHandicapCondition(condition) {
    if (condition < 0) {
        return "0:" + Math.abs(condition);
    }
    else {
        return Math.abs(condition) + ":0";
    }
}
var bo_b1 = function (match, outcome) { return 'Fora'; };
var bo_c1 = function (match, outcome) { return 'O\'yinning jami hisobi'; };
var bo_d1 = function (match, outcome) { return "Jami hisob: ".concat(match.homeTeam); };
var bo_e1 = function (match, outcome) { return "Jami hisob: ".concat(match.awayTeam); };
var bo_f1 = function (match, outcome) { return 'O\'yinning jami hisobi juft/toq'; };
var bo_g1 = function (match, outcome) { return "".concat(match.homeTeam, " - ").concat(match.awayTeam); };
var bo_h1 = function (match, outcome) { return "".concat(outcome.teamOne, " - ").concat(outcome.teamTwo); };
var bo_i1 = function (match, outcome) { return "".concat(outcome.teamOne); };
var bo_j1 = function (match, outcome) { return 'Birinchi setdagi Fora'; };
var bo_k1 = function (match, outcome) { return 'Ikkinchi setdagi Fora'; };
var bo_l1 = function (match, outcome) { return 'Uchinchi setdagi Fora'; };
var bo_m1 = function (match, outcome) { return 'Birinchi setdagi jami hisob'; };
var bo_n1 = function (match, outcome) { return 'Ikkinchi setdagi jami hisob'; };
var bo_o1 = function (match, outcome) { return 'Uchinchi setdagi jami hisob'; };
var bo_p1 = function (match, outcome) { return 'O\'yindagi jami setlar soni'; };
var bo_q1 = function (match, outcome) { return 'O\'yin hisobi'; };
var bo_r1 = function (match, outcome) { return 'Birinchi set natijasi'; };
var bo_s1 = function (match, outcome) { return 'Ikkinchi set natijasi'; };
var bo_t1 = function (match, outcome) { return 'Uchinchi set natijasi'; };
var bo_u1 = function (match, outcome) { return "Birinchi setda ".concat(match.homeTeam, " ning jami hisobi"); };
var bo_v1 = function (match, outcome) { return "Ikkinchi setda ".concat(match.homeTeam, " ning jami hisobi"); };
var bo_w1 = function (match, outcome) { return "Uchinchi setda ".concat(match.homeTeam, " ning jami hisobi"); };
var bo_x1 = function (match, outcome) { return "Birinchi setda ".concat(match.awayTeam, " ning jami hisobi"); };
var bo_y1 = function (match, outcome) { return "Ikkinchi setda ".concat(match.awayTeam, " ning jami hisobi"); };
var bo_z1 = function (match, outcome) { return "Uchinchi setda ".concat(match.awayTeam, " ning jami hisobi"); };
var bo_a2 = function (match, outcome) { return "".concat(match.homeTeam, " birinchi setda ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " farq bilan g'alaba qozonadi"); };
var bo_b2 = function (match, outcome) { return "".concat(match.homeTeam, " ikkinchi setda ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " farq bilan g'alaba qozonadi"); };
var bo_c2 = function (match, outcome) { return "".concat(match.homeTeam, " uchinchi setda ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " farq bilan g'alaba qozonadi"); };
var bo_d2 = function (match, outcome) { return "".concat(match.awayTeam, " birinchi setda ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " farq bilan g'alaba qozonadi"); };
var bo_e2 = function (match, outcome) { return "".concat(match.awayTeam, " ikkinchi setda ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " farq bilan g'alaba qozonadi"); };
var bo_f2 = function (match, outcome) { return "".concat(match.awayTeam, " uchinchi setda ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " farq bilan g'alaba qozonadi"); };
var bo_g2 = function (match, outcome) { return "1-setda kim birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_h2 = function (match, outcome) { return "2-setda kim birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_i2 = function (match, outcome) { return "3-setda kim birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_j2 = function (match, outcome) { return "Kim birinchi setda ".concat(numeralNeuterEnding(outcome.condition), " ochko yutadi"); };
var bo_k2 = function (match, outcome) { return "Kim ikkinchi setda ".concat(numeralNeuterEnding(outcome.condition), " ochko yutadi"); };
var bo_l2 = function (match, outcome) { return "Kim uchinchi setda ".concat(numeralNeuterEnding(outcome.condition), " ochko yutadi"); };
var bo_m2 = function (match, outcome) { return 'Birinchi setning 10 ochkogacha bo\'lgan minisetida g\'alaba'; };
var bo_n2 = function (match, outcome) { return 'Ikkinchi setning 10 ochkogacha bo\'lgan minisetida g\'alaba'; };
var bo_o2 = function (match, outcome) { return 'Uchinchi setning 10 ochkogacha bo\'lgan minisetida g\'alaba'; };
var bo_p2 = function (match, outcome) { return 'Birinchi setning 10 ochkogacha bo\'lgan minisetida fora'; };
var bo_q2 = function (match, outcome) { return 'Ikkinchi setning 10 ochkogacha bo\'lgan minisetida fora'; };
var bo_r2 = function (match, outcome) { return 'Uchinchi setning 10 ochkogacha bo\'lgan minisetida fora'; };
var bo_s2 = function (match, outcome) { return 'Birinchi setning 10 ochkogacha bo\'lgan minisetida jami hisob'; };
var bo_t2 = function (match, outcome) { return 'Ikkinchi setning 10 ochkogacha bo\'lgan minisetida jami hisob'; };
var bo_u2 = function (match, outcome) { return 'Uchinchi setning 10 ochkogacha bo\'lgan minisetida jami hisob'; };
var bo_v2 = function (match, outcome) { return 'Birinchi setning 15 ochkogacha bo\'lgan minisetida g\'alaba'; };
var bo_w2 = function (match, outcome) { return 'Ikkinchi setning 15 ochkogacha bo\'lgan minisetida g\'alaba'; };
var bo_x2 = function (match, outcome) { return 'Uchinchi setning 15 ochkogacha bo\'lgan minisetida g\'alaba'; };
var bo_y2 = function (match, outcome) { return 'Birinchi setning 15 ochkogacha bo\'lgan minisetida fora'; };
var bo_z2 = function (match, outcome) { return 'Ikkinchi setning 15 ochkogacha bo\'lgan minisetida fora'; };
var bo_a3 = function (match, outcome) { return 'Uchinchi setning 15 ochkogacha bo\'lgan minisetida fora'; };
var bo_b3 = function (match, outcome) { return 'Birinchi setning 15 ochkogacha bo\'lgan minisetida jami hisob'; };
var bo_c3 = function (match, outcome) { return 'Ikkinchi setning 15 ochkogacha bo\'lgan minisetida jami hisob'; };
var bo_d3 = function (match, outcome) { return 'Uchinchi setning 15 ochkogacha bo\'lgan minisetida jami hisob'; };
var bo_e3 = function (match, outcome) { return "".concat(match.homeTeam, " ning birinchi bo'limdagi jami hisobi"); };
var bo_f3 = function (match, outcome) { return 'Birinchi bo\'limda fora'; };
var bo_g3 = function (match, outcome) { return 'Birinchi bo\'lim natijasi'; };
var bo_h3 = function (match, outcome) { return "".concat(match.awayTeam, " ning birinchi bo'limdagi jami hisobi"); };
var bo_i3 = function (match, outcome) { return "Kim ".concat(numeralMaleEnding(outcome.condition), " chi golni kiritadi?"); };
var bo_j3 = function (match, outcome) { return 'Ikkilangan natija'; };
var bo_k3 = function (match, outcome) { return 'Birinchi bo\'lim jami hisobi'; };
var bo_l3 = function (match, outcome) { return "G'alaba va o'yinning jami hisobi ".concat(outcome.condition); };
var bo_m3 = function (match, outcome) { return "".concat(match.homeTeam, " jamoasi ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " farqi bilan g'alaba qozonadi"); };
var bo_n3 = function (match, outcome) { return "".concat(match.awayTeam, " jamoasi ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " farqi bilan g'alaba qozonadi"); };
var bo_o3 = function (match, outcome) { return 'O\'yinning aniq jami hisobi'; };
var bo_p3 = function (match, outcome) { return 'Nechta jamoa to\'p kiritadi'; };
var bo_q3 = function (match, outcome) { return 'Aniq hisob'; };
var bo_r3 = function (match, outcome) { return 'Osiyocha fora'; };
var bo_s3 = function (match, outcome) { return 'Fora birinchi chorakda'; };
var bo_t3 = function (match, outcome) { return 'Fora ikkinchi chorakda'; };
var bo_u3 = function (match, outcome) { return 'Fora uchinchi chorakda'; };
var bo_v3 = function (match, outcome) { return 'Fora to\'rtinchi chorakda'; };
var bo_w3 = function (match, outcome) { return 'Birinchi chorakning jami hisobi'; };
var bo_x3 = function (match, outcome) { return 'Ikkinchi chorakning jami hisobi'; };
var bo_y3 = function (match, outcome) { return 'Uchinchi chorakning jami hisobi'; };
var bo_z3 = function (match, outcome) { return 'To\'rtinchi chorakning jami hisobi'; };
var bo_a4 = function (match, outcome) { return 'Birinchi chorak natijasi'; };
var bo_b4 = function (match, outcome) { return 'Ikkinchi chorak natijasi'; };
var bo_c4 = function (match, outcome) { return 'Uchinchi chorak natijasi'; };
var bo_d4 = function (match, outcome) { return 'To\'rtinchi chorak natijasi'; };
var bo_e4 = function (match, outcome) { return "".concat(match.homeTeam, " ning birinchi chorakdagi jami hisobi"); };
var bo_f4 = function (match, outcome) { return "".concat(match.homeTeam, " ning ikkinchi chorakdagi jami hisobi"); };
var bo_g4 = function (match, outcome) { return "".concat(match.homeTeam, " ning uchinchi chorakdagi jami hisobi"); };
var bo_h4 = function (match, outcome) { return "".concat(match.homeTeam, " ning to'rtinchi chorakdagi jami hisobi"); };
var bo_i4 = function (match, outcome) { return "".concat(match.awayTeam, " ning birinchi chorakdagi jami hisobi"); };
var bo_j4 = function (match, outcome) { return "".concat(match.awayTeam, " ning ikkinchi chorakdagi jami hisobi"); };
var bo_k4 = function (match, outcome) { return "".concat(match.awayTeam, " ning uchinchi chorakdagi jami hisobi"); };
var bo_l4 = function (match, outcome) { return "".concat(match.awayTeam, " ning to'rtinchi chorakdagi jami hisobi"); };
var bo_m4 = function (match, outcome) { return 'O\'yin birinchi yarimining jami hisobi'; };
var bo_n4 = function (match, outcome) { return 'O\'yin ikkinchi yarimining natijasi'; };
var bo_o4 = function (match, outcome) { return 'O\'yin ikkinchi yarimining jami hisobi'; };
var bo_p4 = function (match, outcome) { return 'O\'yin birinchi yarimida fora bilan g\'alaba qozonadi'; };
var bo_q4 = function (match, outcome) { return 'O\'yin ikkinchi yarimida fora bilan g\'alaba qozonadi'; };
var bo_r4 = function (match, outcome) { return 'O\'yin birinchi yarimining natijasi'; };
var bo_s4 = function (match, outcome) { return "O'yin birinchi yarimida ".concat(match.homeTeam, " ning jami hisobi"); };
var bo_t4 = function (match, outcome) { return "O'yin ikkinchi yarimida ".concat(match.homeTeam, " ning jami hisobi"); };
var bo_u4 = function (match, outcome) { return "O'yin birinchi yarimida ".concat(match.awayTeam, " ning jami hisobi"); };
var bo_v4 = function (match, outcome) { return "O'yin ikkinchi yarimida ".concat(match.awayTeam, " ning jami hisobi"); };
var bo_w4 = function (match, outcome) { return "1-chorakda kim birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_x4 = function (match, outcome) { return "2-chorakda kim birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_y4 = function (match, outcome) { return "3-chorakda kim birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_z4 = function (match, outcome) { return "4-chorakda kim birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_a5 = function (match, outcome) { return 'O\'yindagi aniq jami hisob'; };
var bo_b5 = function (match, outcome) { return 'Birinchi chorakdagi aniq jami hisob'; };
var bo_c5 = function (match, outcome) { return 'Ikkinchi chorakdagi aniq jami hisob'; };
var bo_d5 = function (match, outcome) { return 'Uchinchi chorakdagi aniq jami hisob'; };
var bo_e5 = function (match, outcome) { return 'To\'rtinchi chorakdagi aniq jami hisob'; };
var bo_f5 = function (match, outcome) { return "".concat(match.homeTeam, " ochkolar farqi bilan g'alaba qozonadi"); };
var bo_g5 = function (match, outcome) { return "".concat(match.awayTeam, " ochkolar farqi bilan g'alaba qozonadi"); };
var bo_h5 = function (match, outcome) { return 'O\'tish'; };
var bo_i5 = function (match, outcome) { return "".concat(match.homeTeam, " barcha choraklarda g'alaba qozonadi"); };
var bo_j5 = function (match, outcome) { return "".concat(match.awayTeam, " barcha choraklarda g'alaba qozonadi"); };
var bo_k5 = function (match, outcome) { return "".concat(match.homeTeam, " o'yinning ikkala yarmida ham g'alaba qozonadi"); };
var bo_l5 = function (match, outcome) { return "".concat(match.awayTeam, " o'yinning ikkala yarmida ham g'alaba qozonadi"); };
var bo_m5 = function (match, outcome) { return 'Eng sermahsul o\'yinning yarmi'; };
var bo_n5 = function (match, outcome) { return 'Eng sermahsul o\'yin choragi'; };
var bo_o5 = function (match, outcome) { return 'Eng sermahsul chorakning jami hisobi'; };
var bo_p5 = function (match, outcome) { return 'Eng sermahsul bo\'lmagan chorakning jami hisobi'; };
var bo_q5 = function (match, outcome) { return "".concat(match.homeTeam, " birinchi chorakda va o'yinda g'alaba qozonadi"); };
var bo_r5 = function (match, outcome) { return "".concat(match.awayTeam, " birinchi chorakda va o'yinda g'alaba qozonadi"); };
var bo_s5 = function (match, outcome) { return "".concat(match.homeTeam, " o'yinning birinchi yarmida va o'yinda g'alaba qozonadi"); };
var bo_t5 = function (match, outcome) { return "".concat(match.awayTeam, " o'yinning birinchi yarmida va o'yinda g'alaba qozonadi"); };
var bo_u5 = function (match, outcome) { return 'Overtime bo\'ladimi'; };
var bo_v5 = function (match, outcome) { return 'O\'yinda ochko farqi bilan g\'alaba'; };
var bo_w5 = function (match, outcome) { return 'Birinchi chorakda ochko farqi bilan g\'alaba'; };
var bo_x5 = function (match, outcome) { return 'Ikkinchi chorakda ochko farqi bilan g\'alaba'; };
var bo_y5 = function (match, outcome) { return 'Uchinchi chorakda ochko farqi bilan g\'alaba'; };
var bo_z5 = function (match, outcome) { return 'To\'rtinchi chorakda ochko farqi bilan g\'alaba'; };
var bo_a6 = function (match, outcome) { return "Jami hisob: ".concat(outcome.playerName, " (").concat(match.homeTeam, ")"); };
var bo_b6 = function (match, outcome) { return "Jami hisob: ".concat(outcome.playerName, " (").concat(match.awayTeam, ")"); };
var bo_c6 = function (match, outcome) { return 'Jami hisob: 3 ochkolik to\'p otishlar'; };
var bo_d6 = function (match, outcome) { return 'Jami hisob: 2 ochkolik to\'p otishlar'; };
var bo_e6 = function (match, outcome) { return "Jami hisob: ".concat(match.homeTeam, " ning 3 ochkolik to'p otishlari"); };
var bo_f6 = function (match, outcome) { return "Jami hisob: ".concat(match.awayTeam, " ning 3 ochkolik to'p otishlari"); };
var bo_g6 = function (match, outcome) { return "Jami hisob: ".concat(match.homeTeam, " ning 2 ochkolik to'p otishlari"); };
var bo_h6 = function (match, outcome) { return "Jami hisob: ".concat(match.awayTeam, " ning 2 ochkolik to'p otishlari"); };
var bo_i6 = function (match, outcome) { return 'Fora 3 ochkolik to\'p otishlari'; };
var bo_j6 = function (match, outcome) { return 'Fora 2 ochkolik to\'p otishlari'; };
var bo_k6 = function (match, outcome) { return '3 ochkolik to\'p otishlari bo\'yicha natija'; };
var bo_l6 = function (match, outcome) { return '2 ochkolik to\'p otishlari bo\'yicha natija'; };
var bo_m6 = function (match, outcome) { return 'Eng sermahsul bo\'lmagan chorak'; };
var bo_n6 = function (match, outcome) { return 'O\'yindagi jami uzatmalar soni'; };
var bo_o6 = function (match, outcome) { return "".concat(match.homeTeam, " o'yindagi jami uzatmalar soni"); };
var bo_p6 = function (match, outcome) { return "".concat(match.awayTeam, " o'yindagi jami uzatmalar soni"); };
var bo_q6 = function (match, outcome) { return 'O\'yindagi uzatmalar sonida fora'; };
var bo_r6 = function (match, outcome) { return 'O\'yindagi uzatmalar soni bo\'yicha g\'alaba'; };
var bo_s6 = function (match, outcome) { return 'O\'yindagi birinchi 2 ochkolik to\'p otish'; };
var bo_t6 = function (match, outcome) { return 'O\'yindagi birinchi 3 ochkolik to\'p otish'; };
var bo_u6 = function (match, outcome) { return 'O\'yindagi birinchi jarimadan to\'p otilishi'; };
var bo_v6 = function (match, outcome) { return 'Qaysi biri oldin bo\'ladi'; };
var bo_w6 = function (match, outcome) { return 'Choraklardagi eng ko\'p ochko'; };
var bo_x6 = function (match, outcome) { return "O'yinda kim birinchi ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " yig'adi"); };
var bo_y6 = function (match, outcome) { return 'O\'yindagi jami triple-double soni'; };
var bo_z6 = function (match, outcome) { return 'O\'yindagi jami double-double soni'; };
var bo_a7 = function (match, outcome) { return "Birinchi chorakda kim birinchi ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_b7 = function (match, outcome) { return "Ikkinchi chorakda kim birinchi ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_c7 = function (match, outcome) { return "Uchinchi chorakda kim birinchi ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_d7 = function (match, outcome) { return "To'rtinchi chorakda kim birinchi ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_e7 = function (match, outcome) { return 'O\'yindagi ochkolar farqi'; };
var bo_f7 = function (match, outcome) { return 'Birinchi chorakdagi ochkolar farqi'; };
var bo_g7 = function (match, outcome) { return 'Ikkinchi chorakdagi ochkolar farqi'; };
var bo_h7 = function (match, outcome) { return 'Uchinchi chorakdagi ochkolar farqi'; };
var bo_i7 = function (match, outcome) { return 'To\'rtinchi chorakdagi ochkolar farqi'; };
var bo_j7 = function (match, outcome) { return 'O\'yinning birinchi yarimida fora'; };
var bo_k7 = function (match, outcome) { return 'O\'yinning ikkinchi yarimida fora'; };
var bo_l7 = function (match, outcome) { return 'O\'yinning birinchi yarimi natijasi'; };
var bo_m7 = function (match, outcome) { return 'O\'yinning ikkinchi yarimi natijasi'; };
var bo_n7 = function (match, outcome) { return 'O\'yinning birinchi yarimi jami hisobi'; };
var bo_o7 = function (match, outcome) { return 'O\'yinning ikkinchi yarimi jami hisobi'; };
var bo_p7 = function (match, outcome) { return 'O\'yinning birinchi yarimi aniq natijasi'; };
var bo_q7 = function (match, outcome) { return 'O\'yinning ikkinchi yarimi aniq natijasi'; };
var bo_r7 = function (match, outcome) { return 'O\'yinning birinchi yarimida ochko farqi bilan g\'alaba'; };
var bo_s7 = function (match, outcome) { return 'O\'yinning ikkinchi yarimida ochko farqi bilan g\'alaba'; };
var bo_t7 = function (match, outcome) { return "O'yinning birinchi yarimida kim birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_u7 = function (match, outcome) { return "O'yinning ikkinchi yarimida kim birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_v7 = function (match, outcome) { return "O'yinda kim birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_w7 = function (match, outcome) { return 'O\'yinning eng sermahsul yarmi'; };
var bo_x7 = function (match, outcome) { return 'O\'yinning eng sermahsul yarmi jami hisobi'; };
var bo_y7 = function (match, outcome) { return 'O\'yinning eng sermahsul bo\'lmagan yarmi jami hisobi'; };
var bo_z7 = function (match, outcome) { return "".concat(match.homeTeam, " o'yinning birinchi yarmida ham g'alaba qozonadi"); };
var bo_a8 = function (match, outcome) { return "".concat(match.awayTeam, " o'yinning birinchi yarmida ham g'alaba qozonadi"); };
var bo_b8 = function (match, outcome) { return "".concat(match.homeTeam, " ning o'yin birinchi yarmidagi jami hisobi"); };
var bo_c8 = function (match, outcome) { return "".concat(match.homeTeam, " ning o'yin ikkinchi yarmidagi jami hisobi"); };
var bo_d8 = function (match, outcome) { return "".concat(match.awayTeam, " ning o'yin birinchi yarmidagi jami hisobi"); };
var bo_e8 = function (match, outcome) { return "".concat(match.awayTeam, " ning o'yin ikkinchi yarmidagi jami hisobi"); };
var bo_f8 = function (match, outcome) { return "O'yinning birinchi yarmida kim birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_g8 = function (match, outcome) { return "O'yinning ikkinchi yarmida kim birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_h8 = function (match, outcome) { return 'Birinchi davr jami hisobi'; };
var bo_i8 = function (match, outcome) { return 'Ikkinchi davr jami hisobi'; };
var bo_j8 = function (match, outcome) { return 'Uchinchi davr jami hisobi'; };
var bo_k8 = function (match, outcome) { return 'Birinchi davr natijasi'; };
var bo_l8 = function (match, outcome) { return 'Ikkinchi davr natijasi'; };
var bo_m8 = function (match, outcome) { return 'Uchinchi davr natijasi'; };
var bo_n8 = function (match, outcome) { return 'Penaltini hisobga olgandagi g\'alaba'; };
var bo_o8 = function (match, outcome) { return 'Farq bilan g\'alaba 1'; };
var bo_p8 = function (match, outcome) { return 'Farq bilan g\'alaba 2'; };
var bo_q8 = function (match, outcome) { return '1-davrda nechta jamoa gol uradi?'; };
var bo_r8 = function (match, outcome) { return '2-davrda nechta jamoa gol uradi?'; };
var bo_s8 = function (match, outcome) { return '3-davrda nechta jamoa gol uradi?'; };
var bo_t8 = function (match, outcome) { return 'Davr-o\'yin'; };
var bo_u8 = function (match, outcome) { return 'Overtime jami hisobi'; };
var bo_v8 = function (match, outcome) { return 'Overtime natijasi'; };
var bo_w8 = function (match, outcome) { return 'Overtime da fora'; };
var bo_x8 = function (match, outcome) { return 'Birinchi davrda fora'; };
var bo_y8 = function (match, outcome) { return 'Ikkinchi davrda fora'; };
var bo_z8 = function (match, outcome) { return 'Uchinchi davrda fora'; };
var bo_a9 = function (match, outcome) { return 'Birinchi davr aniq hisobi'; };
var bo_b9 = function (match, outcome) { return 'Ikkinchi davr aniq hisobi'; };
var bo_c9 = function (match, outcome) { return 'Uchinchi davr aniq hisobi'; };
var bo_d9 = function (match, outcome) { return "Kim ".concat(numeralMaleEnding(outcome.condition), "-golni kiritadi?"); };
var bo_e9 = function (match, outcome) { return 'Birinchi setda Fora'; };
var bo_f9 = function (match, outcome) { return 'Ikkinchi setda Fora'; };
var bo_g9 = function (match, outcome) { return 'Uchinchi setda Fora'; };
var bo_h9 = function (match, outcome) { return 'Birinchi set jami hisobi'; };
var bo_i9 = function (match, outcome) { return 'Ikkinchi set jami hisobi'; };
var bo_j9 = function (match, outcome) { return 'Uchinchi set jami hisobi'; };
var bo_k9 = function (match, outcome) { return 'O\'yindagi jami setlar hisobi'; };
var bo_l9 = function (match, outcome) { return 'O\'yin jami hisobining juft/tuq'; };
var bo_m9 = function (match, outcome) { return "".concat(match.homeTeam, " ning birinchi setdagi jami hisobi"); };
var bo_n9 = function (match, outcome) { return "".concat(match.homeTeam, " ning ikkinchi setdagi jami hisobi"); };
var bo_o9 = function (match, outcome) { return "".concat(match.homeTeam, " ning uchinchi setdagi jami hisobi"); };
var bo_p9 = function (match, outcome) { return "".concat(match.awayTeam, " ning birinchi setdagi jami hisobi"); };
var bo_q9 = function (match, outcome) { return "".concat(match.awayTeam, " ning ikkinchi setdagi jami hisobi"); };
var bo_r9 = function (match, outcome) { return "".concat(match.awayTeam, " ning uchinchi setdagi jami hisobi"); };
var bo_s9 = function (match, outcome) { return 'O\'yin partiyalari bo\'yicha fora'; };
var bo_t9 = function (match, outcome) { return 'Birinchi setning aniq jami hisobi'; };
var bo_u9 = function (match, outcome) { return 'Ikkinchi setning aniq jami hisobi'; };
var bo_v9 = function (match, outcome) { return 'Uchinchi setning aniq jami hisobi'; };
var bo_w9 = function (match, outcome) { return "".concat(match.homeTeam, " birinchi setda farq bilan g'alaba qozonadi"); };
var bo_x9 = function (match, outcome) { return "".concat(match.homeTeam, " ikkinchi setda farq bilan g'alaba qozonadi"); };
var bo_y9 = function (match, outcome) { return "".concat(match.homeTeam, " uchinchi setda farq bilan g'alaba qozonadi"); };
var bo_z9 = function (match, outcome) { return "".concat(match.awayTeam, " birinchi setda farq bilan g'alaba qozonadi"); };
var bo_a10 = function (match, outcome) { return "".concat(match.awayTeam, " ikkinchi setda farq bilan g'alaba qozonadi"); };
var bo_b10 = function (match, outcome) { return "".concat(match.awayTeam, " uchinchi setda farq bilan g'alaba qozonadi"); };
var bo_c10 = function (match, outcome) { return 'Birinchi set juft/toq'; };
var bo_d10 = function (match, outcome) { return 'Ikkinchi set juft/toq'; };
var bo_e10 = function (match, outcome) { return 'Uchinchi set juft/toq'; };
var bo_f10 = function (match, outcome) { return "Birinchi set g'alaba va ".concat(outcome.condition, " jami hisob"); };
var bo_g10 = function (match, outcome) { return "Ikkinchi set g'alaba va ".concat(outcome.condition, " jami hisob"); };
var bo_h10 = function (match, outcome) { return "Uchinchi set g'alaba va ".concat(outcome.condition, " jami hisob"); };
var bo_i10 = function (match, outcome) { return 'Birinchi setning 10 ochkogacha bo\'lgan kichik setida g\'alaba'; };
var bo_j10 = function (match, outcome) { return 'Ikkinchi setning 10 ochkogacha bo\'lgan kichik setida g\'alaba'; };
var bo_k10 = function (match, outcome) { return 'Birinchi setning 10 ochkogacha bo\'lgan kichik setida fora'; };
var bo_l10 = function (match, outcome) { return 'Ikkinchi setning 10 ochkogacha bo\'lgan kichik setida fora'; };
var bo_m10 = function (match, outcome) { return 'Birinchi setning 10 ochkogacha bo\'lgan kichik setida jami hisob'; };
var bo_n10 = function (match, outcome) { return 'Ikkinchi setning 10 ochkogacha bo\'lgan kichik setida jami hisob'; };
var bo_o10 = function (match, outcome) { return 'Birinchi setning 15 ochkogacha bo\'lgan kichik setida g\'alaba'; };
var bo_p10 = function (match, outcome) { return 'Ikkinchi setning 15 ochkogacha bo\'lgan kichik setida g\'alaba'; };
var bo_q10 = function (match, outcome) { return 'Birinchi setning 15 ochkogacha bo\'lgan kichik setida fora'; };
var bo_r10 = function (match, outcome) { return 'Ikkinchi setning 15 ochkogacha bo\'lgan kichik setida fora'; };
var bo_s10 = function (match, outcome) { return 'Birinchi setning 15 ochkogacha bo\'lgan kichik setida jami hisob'; };
var bo_t10 = function (match, outcome) { return 'Ikkinchi setning 15 ochkogacha bo\'lgan kichik setida jami hisob'; };
var bo_u10 = function (match, outcome) { return "Birinchi setda kim ".concat(numeralNeuterEnding(outcome.condition), " ochkoni ni yutadi"); };
var bo_v10 = function (match, outcome) { return "Ikkinchi setda kim ".concat(numeralNeuterEnding(outcome.condition), " ochkoni ni yutadi"); };
var bo_w10 = function (match, outcome) { return "Uchinchi setda kim ".concat(numeralNeuterEnding(outcome.condition), " ochkoni ni yutadi"); };
var bo_x10 = function (match, outcome) { return "O'yin jami hisobi ".concat(outcome.condition, " va g'alaba"); };
var bo_y10 = function (match, outcome) { return 'Birinchi setda farq bilan g\'alaba'; };
var bo_z10 = function (match, outcome) { return 'Ikkinchi setda farq bilan g\'alaba'; };
var bo_a11 = function (match, outcome) { return 'Uchinchi setda farq bilan g\'alaba'; };
var bo_b11 = function (match, outcome) { return 'Birinchi otish marrasidagi jami hisob'; };
var bo_c11 = function (match, outcome) { return 'Ikkinchi otish marrasidagi jami hisob'; };
var bo_d11 = function (match, outcome) { return 'Uchinchi otish marrasidagi jami hisob'; };
var bo_e11 = function (match, outcome) { return 'To\'rtinchi otish marrasidagi jami hisob'; };
var bo_f11 = function (match, outcome) { return 'Beshinchi otish marrasidagi jami hisob'; };
var bo_g11 = function (match, outcome) { return 'Oltinchi otish marrasidagi jami hisob'; };
var bo_h11 = function (match, outcome) { return 'Yettinchi otish marrasidagi jami hisob'; };
var bo_i11 = function (match, outcome) { return 'Sakkizinchi otish marrasidagi jami hisob'; };
var bo_j11 = function (match, outcome) { return "Birinchi otish marrasidagi ".concat(match.homeTeam, " jami hisobi"); };
var bo_k11 = function (match, outcome) { return "Ikkinchi otish marrasidagi ".concat(match.homeTeam, " jami hisobi"); };
var bo_l11 = function (match, outcome) { return "Uchinchi otish marrasidagi ".concat(match.homeTeam, " jami hisobi"); };
var bo_m11 = function (match, outcome) { return "To'rtinchi otish marrasidagi ".concat(match.homeTeam, " jami hisobi"); };
var bo_n11 = function (match, outcome) { return "Beshinchi otish marrasidagi ".concat(match.homeTeam, " jami hisobi"); };
var bo_o11 = function (match, outcome) { return "Oltinchi otish marrasidagi ".concat(match.homeTeam, " jami hisobi"); };
var bo_p11 = function (match, outcome) { return "Yettinchi otish marrasidagi ".concat(match.homeTeam, " jami hisobi"); };
var bo_q11 = function (match, outcome) { return "Sakkizinchi otish marrasidagi ".concat(match.homeTeam, " jami hisobi"); };
var bo_r11 = function (match, outcome) { return "Birinchi otish marrasidagi ".concat(match.awayTeam, " jami hisobi"); };
var bo_s11 = function (match, outcome) { return "Ikkinchi otish marrasidagi ".concat(match.awayTeam, " jami hisobi"); };
var bo_t11 = function (match, outcome) { return "Uchinchi otish marrasidagi ".concat(match.awayTeam, " jami hisobi"); };
var bo_u11 = function (match, outcome) { return "To'rtinchi otish marrasidagi ".concat(match.awayTeam, " jami hisobi"); };
var bo_v11 = function (match, outcome) { return "Beshinchi otish marrasidagi ".concat(match.awayTeam, " jami hisobi"); };
var bo_w11 = function (match, outcome) { return "Oltinchi otish marrasidagi ".concat(match.awayTeam, " jami hisobi"); };
var bo_x11 = function (match, outcome) { return "Yettinchi otish marrasidagi ".concat(match.awayTeam, " jami hisobi"); };
var bo_y11 = function (match, outcome) { return "Sakkizinchi otish marrasidagi ".concat(match.awayTeam, " jami hisobi"); };
var bo_z11 = function (match, outcome) { return 'Birinchi otish marrasidagi fora'; };
var bo_a12 = function (match, outcome) { return 'Ikkinchi otish marrasidagi fora'; };
var bo_b12 = function (match, outcome) { return 'Uchinchi otish marrasidagi fora'; };
var bo_c12 = function (match, outcome) { return 'To\'rtinchi otish marrasidagi fora'; };
var bo_d12 = function (match, outcome) { return 'Beshinchi otish marrasidagi fora'; };
var bo_e12 = function (match, outcome) { return 'Oltinchi otish marrasidagi fora'; };
var bo_f12 = function (match, outcome) { return 'Yettinchi otish marrasidagi fora'; };
var bo_g12 = function (match, outcome) { return 'Sakkinzinchi otish marrasidagi fora'; };
var bo_h12 = function (match, outcome) { return 'Birinchi otish marrasi natijasi'; };
var bo_i12 = function (match, outcome) { return 'Ikkinchi otish marrasi natijasi'; };
var bo_j12 = function (match, outcome) { return 'Uchinchi otish marrasi natijasi'; };
var bo_k12 = function (match, outcome) { return 'To\'rtinchi otish marrasi natijasi'; };
var bo_l12 = function (match, outcome) { return 'Beshinchi otish marrasi natijasi'; };
var bo_m12 = function (match, outcome) { return 'Oltinchi otish marrasi natijasi'; };
var bo_n12 = function (match, outcome) { return 'Yettinchi otish marrasi natijasi'; };
var bo_o12 = function (match, outcome) { return 'Sakkizinchi otish marrasi natijasi'; };
var bo_p12 = function (match, outcome) { return 'Birinchi otish marrasida aniq jami hisob'; };
var bo_q12 = function (match, outcome) { return 'Ikkinchi otish marrasida aniq jami hisob'; };
var bo_r12 = function (match, outcome) { return 'Uchinchi otish marrasida aniq jami hisob'; };
var bo_s12 = function (match, outcome) { return 'To\'rtinchi otish marrasida aniq jami hisob'; };
var bo_t12 = function (match, outcome) { return 'Beshinchi otish marrasida aniq jami hisob'; };
var bo_u12 = function (match, outcome) { return 'Oltinchi otish marrasida aniq jami hisob'; };
var bo_v12 = function (match, outcome) { return 'Yettinchi otish marrasida aniq jami hisob'; };
var bo_w12 = function (match, outcome) { return 'Sakkizinchi otish marrasida aniq jami hisob'; };
var bo_x12 = function (match, outcome) { return 'Muddatidan avval g\'alaba bo\'ladimi?'; };
var bo_y12 = function (match, outcome) { return 'Jangdagi g\'alaba usullari'; };
var bo_z12 = function (match, outcome) { return 'Jangdagi g\'alaba'; };
var bo_a13 = function (match, outcome) { return "Kim ".concat(outcome.condition, " raundda g'alaba qozonadi?"); };
var bo_b13 = function (match, outcome) { return 'FirstBlood'; };
var bo_c13 = function (match, outcome) { return "FirstBlood ".concat(outcome.condition, " raundda"); };
var bo_d13 = function (match, outcome) { return "Kim ".concat(outcome.condition, " xaritasida g'alaba qozonadi?"); };
var bo_e13 = function (match, outcome) { return "FirstBlood ".concat(outcome.condition, " xaritasida"); };
var bo_f13 = function (match, outcome) { return "Kim birinchi bo'lib 1-xaritada ".concat(outcome.condition, " ta o'ldirishlarni amalga oshiradi"); };
var bo_g13 = function (match, outcome) { return "Kim birinchi bo'lib 2-xaritada ".concat(outcome.condition, " ta o'ldirishlarni amalga oshiradi"); };
var bo_h13 = function (match, outcome) { return "Kim birinchi bo'lib 3-xaritada ".concat(outcome.condition, " ta o'ldirishlarni amalga oshiradi"); };
var bo_i13 = function (match, outcome) { return "Kim birinchi bo'lib 4-xaritada ".concat(outcome.condition, " ta o'ldirishlarni amalga oshiradi"); };
var bo_j13 = function (match, outcome) { return "Kim birinchi bo'lib 5-xaritada ".concat(outcome.condition, " ta o'ldirishlarni amalga oshiradi"); };
var bo_k13 = function (match, outcome) { return 'O\'yin natijasi'; };
var bo_l13 = function (match, outcome) { return 'Birinchi xaritada g\'alaba'; };
var bo_m13 = function (match, outcome) { return 'Ikkinchi xaritada g\'alaba'; };
var bo_n13 = function (match, outcome) { return 'Uchinchi xaritada g\'alaba'; };
var bo_o13 = function (match, outcome) { return 'To\'rtinchi xaritada g\'alaba'; };
var bo_p13 = function (match, outcome) { return 'Beshinchi xaritada g\'alaba'; };
var bo_q13 = function (match, outcome) { return 'Birinchi xaritada First blood'; };
var bo_r13 = function (match, outcome) { return 'Ikkinchi xaritada First blood'; };
var bo_s13 = function (match, outcome) { return 'Uchinchi xaritada First blood'; };
var bo_t13 = function (match, outcome) { return 'To\'rtinchi xaritada First blood'; };
var bo_u13 = function (match, outcome) { return 'Beshinchi xaritada First blood'; };
var bo_v13 = function (match, outcome) { return 'Bullitlarni hisobga olgandagi g\'alaba'; };
var bo_w13 = function (match, outcome) { return "".concat(match.homeTeam, " ikkala o'yinda ham g'alaba qozonadi"); };
var bo_x13 = function (match, outcome) { return "".concat(match.awayTeam, " ikkala o'yinda ham g'alaba qozonadi"); };
var bo_y13 = function (match, outcome) { return "".concat(outcome.conditionTwo, " ta va undan ko'p gol urgan jamoalar (ularning jamisi)"); };
var bo_z13 = function (match, outcome) { return 'Eng sermahsul jamoa (uning jamisi)'; };
var bo_a14 = function (match, outcome) { return 'Eng sermahsul bo\'lim (jami)'; };
var bo_b14 = function (match, outcome) { return "Ikkala bo'lim ham ".concat(outcome.condition, " dan kam"); };
var bo_c14 = function (match, outcome) { return "Ikkala bo'lim ham ".concat(outcome.condition, " dan ko'p"); };
var bo_d14 = function (match, outcome) { return 'Birinchi bo\'lim juft/toq'; };
var bo_e14 = function (match, outcome) { return 'Ikkinchi bo\'lim juft/toq'; };
var bo_f14 = function (match, outcome) { return "".concat(match.homeTeam, " birinchi bo'limda nechta gol kiritadi?"); };
var bo_g14 = function (match, outcome) { return "".concat(match.homeTeam, " ikkinchi bo'limda nechta gol kiritadi?"); };
var bo_h14 = function (match, outcome) { return "".concat(match.awayTeam, "  birinchi bo'limda nechta gol kiritadi?"); };
var bo_i14 = function (match, outcome) { return "".concat(match.awayTeam, " ikkinchi bo'limda nechta gol kiritadi?"); };
var bo_j14 = function (match, outcome) { return "".concat(match.homeTeam, " o'yinda nechta to'p kiritadi?"); };
var bo_k14 = function (match, outcome) { return "".concat(match.awayTeam, " o'yinda nechta to'p kiritadi?"); };
var bo_l14 = function (match, outcome) { return 'Eng sermahsul bo\'lmagan jamoa (uning jamisi)'; };
var bo_m14 = function (match, outcome) { return "".concat(match.homeTeam, " faqat birinchi bo'limda to'p kiritadimi?"); };
var bo_n14 = function (match, outcome) { return "".concat(match.awayTeam, " faqat birinchi bo'limda to'p kiritadimi?"); };
var bo_o14 = function (match, outcome) { return "".concat(match.homeTeam, " faqat ikkinchi bo'limda to'p kiritadimi?"); };
var bo_p14 = function (match, outcome) { return "".concat(match.awayTeam, " faqat ikkinchi bo'limda to'p kiritadimi?"); };
var bo_q14 = function (match, outcome) { return 'Birinchi bo\'limda nechta to\'p kiritadi'; };
var bo_r14 = function (match, outcome) { return 'Ikkinchi bo\'limda nechta to\'p kiritadi'; };
var bo_s14 = function (match, outcome) { return "Nechta jamoalar ".concat(outcome.condition, " dan ko'p ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " urishadi"); };
var bo_t14 = function (match, outcome) { return 'Birinchi gol qanday kiritiladi?'; };
var bo_u14 = function (match, outcome) { return 'Keyingi davraga o\'tish'; };
var bo_v14 = function (match, outcome) { return 'Kim maydon markazidan boshlaydi?'; };
var bo_w14 = function (match, outcome) { return 'Bir jamoa tomonidan ketma-ket ikkita to\'p'; };
var bo_x14 = function (match, outcome) { return "".concat(match.homeTeam, " jamoasi irodali g'alabaga erishadi"); };
var bo_y14 = function (match, outcome) { return "Kim ".concat(numeralFemaleEnding(outcome.condition), " SK oladi"); };
var bo_z14 = function (match, outcome) { return "".concat(match.awayTeam, " jamoasi irodali g'alabaga erishadi"); };
var bo_a15 = function (match, outcome) { return 'O\'yinda oldin nima sodir bo\'ladi?'; };
var bo_b15 = function (match, outcome) { return 'Dubl'; };
var bo_c15 = function (match, outcome) { return 'Xet-trik'; };
var bo_d15 = function (match, outcome) { return "Kim ".concat(numeralMaleEnding(outcome.condition), " burchak to'pini oshirib beradi"); };
var bo_e15 = function (match, outcome) { return "Aniq ".concat(outcome.conditionTwo, " ta ").concat(plural(outcome.conditionTwo, ['gol', 'gol', 'gol']), " kiritgan jamoalar jami soni"); };
var bo_f15 = function (match, outcome) { return "O'yinda aniq  ".concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " kiritiladimi"); };
var bo_g15 = function (match, outcome) { return 'Kim oxirgi golni kiritadi'; };
var bo_h15 = function (match, outcome) { return 'Avtogol'; };
var bo_i15 = function (match, outcome) { return 'Zahiradan maydonga tushgan o\'yinchi gol uradimi?'; };
var bo_j15 = function (match, outcome) { return 'Oxirgi gol vaqti'; };
var bo_k15 = function (match, outcome) { return 'Kubok sohibi'; };
var bo_l15 = function (match, outcome) { return 'Superkubok sohibi'; };
var bo_m15 = function (match, outcome) { return "Qaysi bo'limda ".concat(numeralMaleEnding(outcome.condition), " gol kiritiladi?"); };
var bo_n15 = function (match, outcome) { return '1-daqiqadan 15-daqiqagacha ikkilangan natija'; };
var bo_o15 = function (match, outcome) { return '16-daqiqadan 30-daqiqagacha ikkilangan natija'; };
var bo_p15 = function (match, outcome) { return '31-daqiqadan tanaffusgacha ikkilangan natija'; };
var bo_q15 = function (match, outcome) { return '46-daqiqadan 60-daqiqagacha ikkilangan natija'; };
var bo_r15 = function (match, outcome) { return '61-daqiqadan 75-daqiqagacha ikkilangan natija'; };
var bo_s15 = function (match, outcome) { return '76-daqiqadan o\'yin oxirigacha ikkilangan natija'; };
var bo_t15 = function (match, outcome) { return "".concat(match.homeTeam, " jamoasi ").concat(numeralMaleEnding(outcome.condition), " penaltini amalga oshiradimi (penaltilar seriyasida)?"); };
var bo_u15 = function (match, outcome) { return "".concat(match.awayTeam, " jamoasi ").concat(numeralMaleEnding(outcome.condition), " penaltini amalga oshiradimi (penaltilar seriyasida)?"); };
var bo_v15 = function (match, outcome) { return "".concat(match.homeTeam, " o'zining ").concat(numeralMaleEnding(outcome.condition), "-chi golini kiritadi"); };
var bo_w15 = function (match, outcome) { return "".concat(match.awayTeam, " o'zining ").concat(numeralMaleEnding(outcome.condition), "-chi golini kiritadi"); };
var bo_x15 = function (match, outcome) { return 'Birinchi bo\'limdagi jami burchak to\'p oshirilishlari soni'; };
var bo_y15 = function (match, outcome) { return 'Birinchi bo\'limdagi jami SK soni'; };
var bo_z15 = function (match, outcome) { return 'O\'yin davomidagi burchak zarbalari bo\'yicha  fora'; };
var bo_a16 = function (match, outcome) { return 'Birinchi bo\'lim uchun burchak zarbalari bo\'yicha fora'; };
var bo_b16 = function (match, outcome) { return 'Sariq kartochkalar bo\'yicha fora'; };
var bo_c16 = function (match, outcome) { return 'Birinchi bo\'lim uchun sariq kartochkalar bo\'yicha fora'; };
var bo_d16 = function (match, outcome) { return 'Burchak zarbalari bo\'yicha natija'; };
var bo_e16 = function (match, outcome) { return 'Burchak zarbalari bo\'yicha birinchi bo\'lim natijasi'; };
var bo_f16 = function (match, outcome) { return 'Sariq kartochkalar bo\'yicha natija'; };
var bo_g16 = function (match, outcome) { return 'Sariq kartochkalar bo\'yicha birinchi bo\'lim natijasi'; };
var bo_h16 = function (match, outcome) { return "Kim birinchi ".concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " kiritadi"); };
var bo_i16 = function (match, outcome) { return "".concat(numeralMaleEnding(outcome.condition), "- penalti aniq amalga oshiriladimi?"); };
var bo_j16 = function (match, outcome) { return 'O\'yinda kiritilgan to\'plar jamisi'; };
var bo_k16 = function (match, outcome) { return 'Ikkitalik natija'; };
var bo_l16 = function (match, outcome) { return 'Yon tomondan to\'p oshirilishlar jamisi'; };
var bo_m16 = function (match, outcome) { return 'Bo\'lim-o\'yin'; };
var bo_n16 = function (match, outcome) { return 'O\'yin hisobi jamisi (Osiyo)'; };
var bo_o16 = function (match, outcome) { return 'O\'yin hisobining aniq jamisi'; };
var bo_p16 = function (match, outcome) { return 'Jami burchak to\'plari'; };
var bo_q16 = function (match, outcome) { return 'O\'yin qanday tugaydi?'; };
var bo_r16 = function (match, outcome) { return 'Penaltilar (jami)'; };
var bo_s16 = function (match, outcome) { return 'Jami qizil kartochkalar'; };
var bo_t16 = function (match, outcome) { return 'Birinchi gol vaqti'; };
var bo_u16 = function (match, outcome) { return 'Gollar yig\'indisi'; };
var bo_v16 = function (match, outcome) { return "Jami: ".concat(match.homeTeam); };
var bo_w16 = function (match, outcome) { return "Jami: ".concat(match.awayTeam); };
var bo_x16 = function (match, outcome) { return 'Birinchi bo\'lim jamisi'; };
var bo_y16 = function (match, outcome) { return 'Ikkinchi bo\'lim jamisi'; };
var bo_z16 = function (match, outcome) { return 'Birinchi bo\'lim uchun fora'; };
var bo_a17 = function (match, outcome) { return 'Ikkinchi bo\'lim uchun fora'; };
var bo_b17 = function (match, outcome) { return 'Darvoza tomon zarbalar'; };
var bo_c17 = function (match, outcome) { return "G'alaba va ".concat(outcome.condition, " jami hisob"); };
var bo_d17 = function (match, outcome) { return 'Jami sariq kartochkalar'; };
var bo_e17 = function (match, outcome) { return 'Ikkinchi bo\'lim natijasi'; };
var bo_f17 = function (match, outcome) { return 'O\'yinning 1-daqiqasidan 15-daqiqasigacha fora'; };
var bo_g17 = function (match, outcome) { return 'O\'yinning 16-daqiqasidan 30-daqiqasigacha fora'; };
var bo_h17 = function (match, outcome) { return 'O\'yinning 31-daqiqasidan tanaffusgacha fora'; };
var bo_i17 = function (match, outcome) { return 'O\'yinning 46-daqiqasidan 60-daqiqasigacha fora'; };
var bo_j17 = function (match, outcome) { return 'O\'yinning 61-daqiqasidan 75-daqiqasigacha fora'; };
var bo_k17 = function (match, outcome) { return 'O\'yinning 76-daqiqasidan o\'yin yakuniga qadar fora'; };
var bo_l17 = function (match, outcome) { return "".concat(match.homeTeam, " gollar"); };
var bo_m17 = function (match, outcome) { return "".concat(match.awayTeam, " gollar"); };
var bo_n17 = function (match, outcome) { return 'Jami o\'zgartirishlar'; };
var bo_o17 = function (match, outcome) { return 'Jami hisob Juft/Toq'; };
var bo_p17 = function (match, outcome) { return '1-dan 15-daqaqiqagacha jami hisob'; };
var bo_q17 = function (match, outcome) { return '16-dan 30-daqaqiqagacha jami hisob'; };
var bo_r17 = function (match, outcome) { return '31-daqiqadan tanaffusgacha jami hisob'; };
var bo_s17 = function (match, outcome) { return '46-dan 60-daqaqiqagacha jami hisob'; };
var bo_t17 = function (match, outcome) { return '61-dan 75-daqaqiqagacha jami hisob'; };
var bo_u17 = function (match, outcome) { return '76-daqiqadan o\'yin yakunigacha jami hisob'; };
var bo_v17 = function (match, outcome) { return "1-dan 15-daqiqagacha ".concat(match.homeTeam, " ning jami hisobi"); };
var bo_w17 = function (match, outcome) { return "16-dan 30-daqiqagacha ".concat(match.homeTeam, " ning jami hisobi"); };
var bo_x17 = function (match, outcome) { return "31-daqiqadan tanaffusgacha ".concat(match.homeTeam, " ning jami hisobi"); };
var bo_y17 = function (match, outcome) { return "46-dan 60-daqiqagacha ".concat(match.homeTeam, " ning jami hisobi"); };
var bo_z17 = function (match, outcome) { return "61-dan 75-daqiqagacha ".concat(match.homeTeam, " ning jami hisobi"); };
var bo_a18 = function (match, outcome) { return "76-daqiqadan o'yin yakunigacha ".concat(match.homeTeam, " ning jami hisobi"); };
var bo_b18 = function (match, outcome) { return "1-dan 15-daqiqagacha ".concat(match.awayTeam, " ning jami hisobi"); };
var bo_c18 = function (match, outcome) { return "16-dan 30-daqiqagacha ".concat(match.awayTeam, " ning jami hisobi"); };
var bo_d18 = function (match, outcome) { return "31-daqiqadan tanaffusgacha ".concat(match.awayTeam, " ning jami hisobi"); };
var bo_e18 = function (match, outcome) { return "46-dan 60-daqiqagacha ".concat(match.awayTeam, " ning jami hisobi"); };
var bo_f18 = function (match, outcome) { return "61-dan 75-daqiqagacha ".concat(match.awayTeam, " ning jami hisobi"); };
var bo_g18 = function (match, outcome) { return "76-daqiqadan o'yin yakunigacha ".concat(match.awayTeam, " ning jami hisobi"); };
var bo_h18 = function (match, outcome) { return 'Birinchi bo\'limning aniq jami hisobi'; };
var bo_i18 = function (match, outcome) { return 'Ikkinchi bo\'limning aniq jami hisobi'; };
var bo_j18 = function (match, outcome) { return "".concat(match.homeTeam, " g'alaba qozonadi va yutqazmaydi"); };
var bo_k18 = function (match, outcome) { return "".concat(match.awayTeam, " g'alaba qozonadi va yutqazmaydi"); };
var bo_l18 = function (match, outcome) { return "".concat(match.homeTeam, " aniq ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " kiritadi"); };
var bo_m18 = function (match, outcome) { return "".concat(match.awayTeam, " aniq ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " kiritadi"); };
var bo_n18 = function (match, outcome) { return 'Birinchi bo\'limning aniq hisobi'; };
var bo_o18 = function (match, outcome) { return 'Ikkinchi bo\'limning aniq hisobi'; };
var bo_p18 = function (match, outcome) { return 'Jami kiritilmagan penaltilar soni'; };
var bo_q18 = function (match, outcome) { return "Ikkala jamoa ham ".concat(outcome.condition, " tadan kam to'p kiritishadi"); };
var bo_r18 = function (match, outcome) { return "Ikkala jamoa ham ".concat(outcome.condition, " tadan ko'p to'p kiritishadi"); };
var bo_s18 = function (match, outcome) { return 'Bo\'limlarni taqqoslash (gollar)'; };
var bo_t18 = function (match, outcome) { return '1-dan 15-daqiqagacha g\'alaba'; };
var bo_u18 = function (match, outcome) { return '16-dan 30-daqiqagacha g\'alaba'; };
var bo_v18 = function (match, outcome) { return '31-daqiqadan tanaffusgacha g\'alaba'; };
var bo_w18 = function (match, outcome) { return '46-dan 60-daqiqagacha g\'alaba'; };
var bo_x18 = function (match, outcome) { return '61-dan 75-daqiqagacha g\'alaba'; };
var bo_y18 = function (match, outcome) { return '76-daqiqadan o\'yin yakunigacha g\'alaba'; };
var bo_z18 = function (match, outcome) { return "".concat(match.homeTeam, " jamoasi ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " farqi bilan g'alaba qozonadi"); };
var bo_a19 = function (match, outcome) { return "".concat(match.awayTeam, " jamoasi ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " farqi bilan g'alaba qozonadi"); };
var bo_b19 = function (match, outcome) { return "".concat(match.homeTeam, " bitta bo'limda g'alaba qozonadi"); };
var bo_c19 = function (match, outcome) { return "".concat(match.awayTeam, " bitta bo'limda g'alaba qozonadi"); };
var bo_d19 = function (match, outcome) { return "".concat(outcome.conditionTwo, " tadan ").concat(outcome.conditionThree, " gacha to'p kiritgan jamoalarining jami soni"); };
var bo_e19 = function (match, outcome) { return "Jami: ".concat(match.homeTeam, " uchun birinchi bo'lim"); };
var bo_f19 = function (match, outcome) { return "Jami: ".concat(match.homeTeam, " uchun ikkinchi bo'lim"); };
var bo_g19 = function (match, outcome) { return "Jami: ".concat(match.awayTeam, " uchun birinchi bo'lim"); };
var bo_h19 = function (match, outcome) { return "Jami: ".concat(match.awayTeam, " uchun ikkinchi bo'lim"); };
var bo_i19 = function (match, outcome) { return "(".concat(match.homeTeam, ") jamoasidagi ").concat(outcome.playerName, " to'p kiritadimi?"); };
var bo_j19 = function (match, outcome) { return "(".concat(match.awayTeam, ") jamoasidagi ").concat(outcome.playerName, " to'p kiritadimi?"); };
var bo_k19 = function (match, outcome) { return 'O\'yin forasi'; };
var bo_l19 = function (match, outcome) { return 'O\'yin jami hisobi'; };
var bo_m19 = function (match, outcome) { return 'Mezbonlar jami hisobi'; };
var bo_n19 = function (match, outcome) { return 'Mehmonlar jami hisobi'; };
var bo_o19 = function (match, outcome) { return 'Eng sermahsul o\'yin jami hisobi'; };
var bo_p19 = function (match, outcome) { return 'Eng sermahsul bo\'lmagan o\'yin jami hisobi'; };
var bo_q19 = function (match, outcome) { return 'Golsiz o\'yinlar jami hisobi'; };
var bo_r19 = function (match, outcome) { return 'Mezbonlarning jami g\'alabalari'; };
var bo_s19 = function (match, outcome) { return 'Mehmonlarning jami g\'alabalari'; };
var bo_t19 = function (match, outcome) { return 'Durranglar jami soni'; };
var bo_u19 = function (match, outcome) { return "Jami: ".concat(outcome.playerName, " (").concat(match.homeTeam, ")"); };
var bo_v19 = function (match, outcome) { return "Jami: ".concat(outcome.playerName, " (").concat(match.awayTeam, ")"); };
var bo_w19 = function (match, outcome) { return 'Ikkala jamoa ham 1-bo\'lim / 2-bo\'limda to\'p kiritadi'; };
var bo_x19 = function (match, outcome) { return "Jami hisob ".concat(outcome.condition, " va ikkala jamoa to'p kiritadi"); };
var bo_y19 = function (match, outcome) { return "".concat(match.homeTeam, " to'p kiritadi va g'alaba qozonmaydi"); };
var bo_z19 = function (match, outcome) { return "(".concat(match.awayTeam, ") to'p kiritadi va g'alaba qozonmaydi"); };
var bo_a20 = function (match, outcome) { return 'O\'yinda g\'alaba qozonish usuli'; };
var bo_b20 = function (match, outcome) { return '1-bo\'limga qo\'shib berilgan vaqt'; };
var bo_c20 = function (match, outcome) { return '2-bo\'limga qo\'shib berilgan vaqt'; };
var bo_d20 = function (match, outcome) { return 'O\'yinda to\'sin / ustunga to\'p tegadimi'; };
var bo_e20 = function (match, outcome) { return 'Birinchi o\'yin almashtirilish vaqti'; };
var bo_f20 = function (match, outcome) { return "Qizil kartochkani ".concat(match.homeTeam, " jamoasi vakili oladi"); };
var bo_g20 = function (match, outcome) { return "Qizil kartochkani ".concat(match.awayTeam, " jamoasi vakili oladi"); };
var bo_h20 = function (match, outcome) { return 'Penalti va chetlatish bo\'ladimi'; };
var bo_i20 = function (match, outcome) { return 'Qo\'shimcha vaqtda gol'; };
var bo_j20 = function (match, outcome) { return 'Simulyatsiya uchun sariq kartochka'; };
var bo_k20 = function (match, outcome) { return 'Fudbolkani yechganlik uchun SK'; };
var bo_l20 = function (match, outcome) { return 'Har bir bayroqchadan burchak to\'pi'; };
var bo_m20 = function (match, outcome) { return 'Kim 3-o\'rinni egallaydi?'; };
var bo_n20 = function (match, outcome) { return "Jami: ".concat(match.awayTeam, "  (qo'shimcha bo'lim)"); };
var bo_o20 = function (match, outcome) { return "Jami: ".concat(match.homeTeam, "  (qo'shimcha bo'lim)"); };
var bo_p20 = function (match, outcome) { return 'Ikkilangan natija (qo\'shimcha vaqt)'; };
var bo_q20 = function (match, outcome) { return 'Aniq hisob  (qo\'shimcha bo\'lim)'; };
var bo_r20 = function (match, outcome) { return 'Fora (Qo\'shimcha bo\'lim)'; };
var bo_s20 = function (match, outcome) { return 'Jami hisob  (Qo\'shimcha bo\'lim)'; };
var bo_t20 = function (match, outcome) { return 'Natija (Qo\'shimcha bo\'lim)'; };
var bo_u20 = function (match, outcome) { return "Qo'shimcha bo'limda ".concat(numeralMaleEnding(outcome.condition), " golni kim kiritadi?"); };
var bo_v20 = function (match, outcome) { return '1-qo\'shimcha bo\'limdagi fora'; };
var bo_w20 = function (match, outcome) { return '1-qo\'shimcha bo\'limdagi jami hisob'; };
var bo_x20 = function (match, outcome) { return '1-qo\'shimcha bo\'limdagi natija'; };
var bo_y20 = function (match, outcome) { return '2-qo\'shimcha bo\'limdagi fora'; };
var bo_z20 = function (match, outcome) { return '2-qo\'shimcha bo\'limdagi jami hisob'; };
var bo_a21 = function (match, outcome) { return '2-qo\'shimcha bo\'limdagi natija'; };
var bo_b21 = function (match, outcome) { return 'Penaltilar seriyasidagi aniq hisob'; };
var bo_c21 = function (match, outcome) { return "Jami kiritilgan penaltilar soni: ".concat(match.awayTeam, " (penaltilar seriyasida)"); };
var bo_d21 = function (match, outcome) { return "Jami kiritilgan penaltilar soni: ".concat(match.homeTeam, " (penaltilar seriyasida)"); };
var bo_e21 = function (match, outcome) { return 'Jami kiritilgan penaltilar soni (penaltilar seriyasida)'; };
var bo_f21 = function (match, outcome) { return 'Jami kiritilmagan penaltilar soni (penaltilar seriyasida)'; };
var bo_g21 = function (match, outcome) { return "Yevropacha fora  ".concat(europeanHandicapCondition(outcome.condition)); };
var bo_h21 = function (match, outcome) { return "1-bo'limda yevropacha fora  ".concat(europeanHandicapCondition(outcome.condition)); };
var bo_i21 = function (match, outcome) { return "2-bo'limda yevropacha fora  ".concat(europeanHandicapCondition(outcome.condition)); };
var bo_j21 = function (match, outcome) { return "Birinchi bo'limda kim ".concat(numeralMaleEnding(outcome.condition), " golni kiritadi?"); };
var bo_k21 = function (match, outcome) { return "O'yinning qolgan vaqti (hozirgi hisob ".concat(outcome.condition, ":").concat(outcome.conditionTwo, ")"); };
var bo_l21 = function (match, outcome) { return "Birinchi bo'limning qolgan vaqti (hozirgi hisob ".concat(outcome.condition, ":").concat(outcome.conditionTwo, ")"); };
var bo_m21 = function (match, outcome) { return "".concat(match.homeTeam, " ning jami burchak zarbalari soni"); };
var bo_n21 = function (match, outcome) { return "".concat(match.awayTeam, " ning jami burchak zarbalari soni"); };
var bo_o21 = function (match, outcome) { return "".concat(match.homeTeam, " ning jami burchak to'plari soni"); };
var bo_p21 = function (match, outcome) { return "".concat(match.awayTeam, " ning jami burchak to'plari soni"); };
var bo_q21 = function (match, outcome) { return 'Birinchi golning daqiqasi'; };
var bo_r21 = function (match, outcome) { return 'Birinchi bo\'lim ikkilangan natija'; };
var bo_s21 = function (match, outcome) { return 'Ikkinchi bo\'lim ikkilangan natija'; };
var bo_t21 = function (match, outcome) { return 'Ikkalasi gor uradimi?'; };
var bo_u21 = function (match, outcome) { return "".concat(match.homeTeam, " ikkala bo'limda ham g'alaba qozonadi"); };
var bo_v21 = function (match, outcome) { return "".concat(match.awayTeam, " ikkala bo'limda ham g'alaba qozonadi"); };
var bo_w21 = function (match, outcome) { return 'O\'yin hisobi jamisi'; };
var bo_x21 = function (match, outcome) { return 'Gollar vaqtlari yig\'indisi'; };
var bo_y21 = function (match, outcome) { return "".concat(match.homeTeam, " g'alaba qozonadi va to'p o'tqazmaydi"); };
var bo_z21 = function (match, outcome) { return "".concat(match.awayTeam, " g'alaba qozonadi va to'p o'tqazmaydi"); };
var bo_a22 = function (match, outcome) { return 'Ikkinchi bo\'lim jami hisobi'; };
var bo_b22 = function (match, outcome) { return 'Birinchi bo\'lim aniq jami hisobi'; };
var bo_c22 = function (match, outcome) { return 'Ikkinchi bo\'lim aniq jami hisobi'; };
var bo_d22 = function (match, outcome) { return "O'yinning jami hisobi ".concat(outcome.condition, " va g'alaba"); };
var bo_e22 = function (match, outcome) { return "".concat(match.homeTeam, " farq bilan birinchi bo'limdagi g'alabasi"); };
var bo_f22 = function (match, outcome) { return "".concat(match.homeTeam, " farq bilan ikkinchi bo'limdagi g'alabasi"); };
var bo_g22 = function (match, outcome) { return "".concat(match.awayTeam, " farq bilan birinchi bo'limdagi g'alabasi"); };
var bo_h22 = function (match, outcome) { return "".concat(match.awayTeam, " farq bilan ikkinchi bo'limdagi g'alabasi"); };
var bo_i22 = function (match, outcome) { return "Kim birinchi bo'lib ".concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " kiritadi"); };
var bo_j22 = function (match, outcome) { return 'Ikkinchi bo\'limda fora'; };
var bo_k22 = function (match, outcome) { return 'Xet-triklar (jami hisobi)'; };
var bo_l22 = function (match, outcome) { return 'O\'yin jami hisobi jami hisobi juft/toq'; };
var bo_m22 = function (match, outcome) { return "".concat(match.homeTeam, " g'alaba qozonadi va o'tkazib yubormaydi"); };
var bo_n22 = function (match, outcome) { return "".concat(match.awayTeam, " g'alaba qozonadi va o'tkazib yubormaydi"); };
var bo_o22 = function (match, outcome) { return 'Birinchi davr aniq jami hisobi'; };
var bo_p22 = function (match, outcome) { return 'Ikkinchi davr aniq jami hisobi'; };
var bo_q22 = function (match, outcome) { return 'Uchinchi davr aniq jami hisobi'; };
var bo_r22 = function (match, outcome) { return "Nechta jamoa  ".concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " kiritadi"); };
var bo_s22 = function (match, outcome) { return "".concat(match.homeTeam, " aniq ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " bilan g'alaba qozonadi"); };
var bo_t22 = function (match, outcome) { return "".concat(match.awayTeam, " aniq ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " bilan g'alaba qozonadi"); };
var bo_u22 = function (match, outcome) { return "Nechta jamoa ".concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " kiritadi"); };
var bo_v22 = function (match, outcome) { return 'Eng sermahsul jamoa (uning jami hisobi)'; };
var bo_w22 = function (match, outcome) { return 'Eng sermahsul bo\'lmagan jamoa (uning jami hisobi)'; };
var bo_x22 = function (match, outcome) { return 'Birinchi davr juft/toq'; };
var bo_y22 = function (match, outcome) { return 'Ikkinchi davr juft/toq'; };
var bo_z22 = function (match, outcome) { return 'Uchinchi davr juft/toq'; };
var bo_a23 = function (match, outcome) { return 'Eng sermahsul davr (jami hisob)'; };
var bo_b23 = function (match, outcome) { return 'Eng sermahsul bo\'lmagan davr (jami hisob)'; };
var bo_c23 = function (match, outcome) { return 'Birinchi davrning aniq jami hisobi'; };
var bo_d23 = function (match, outcome) { return 'Ikkinchi davrning aniq jami hisobi'; };
var bo_e23 = function (match, outcome) { return 'Uchinchi davrning aniq jami hisobi'; };
var bo_f23 = function (match, outcome) { return "".concat(match.homeTeam, " ning birinchi davrdagi jami hisobi"); };
var bo_g23 = function (match, outcome) { return "".concat(match.homeTeam, " ning ikkinchi davrdagi jami hisobi"); };
var bo_h23 = function (match, outcome) { return "".concat(match.homeTeam, " ning uchinchi davrdagi jami hisobi"); };
var bo_i23 = function (match, outcome) { return "".concat(match.awayTeam, " ning birinchi davrdagi jami hisobi"); };
var bo_j23 = function (match, outcome) { return "".concat(match.awayTeam, " ning ikkinchi davrdagi jami hisobi"); };
var bo_k23 = function (match, outcome) { return "".concat(match.awayTeam, " ning uchinchi davrdagi jami hisobi"); };
var bo_l23 = function (match, outcome) { return "G'alaba va o'yinning aniq hisobi ".concat(outcome.condition); };
var bo_m23 = function (match, outcome) { return 'Overtime bo\'lidimi'; };
var bo_n23 = function (match, outcome) { return 'Ikkala jamoa ham gol uradi'; };
var bo_o23 = function (match, outcome) { return "".concat(match.homeTeam, " ").concat(numeralMaleEnding(outcome.condition), "-bullitni kiritadimi?"); };
var bo_p23 = function (match, outcome) { return "".concat(match.awayTeam, " ").concat(numeralMaleEnding(outcome.condition), "-bullitni kiritadimi?"); };
var bo_q23 = function (match, outcome) { return 'OT ni hisobga olgandagi g\'alaba'; };
var bo_r23 = function (match, outcome) { return 'Davr-O\'yin'; };
var bo_s23 = function (match, outcome) { return "".concat(match.homeTeam, " har bir davrda gol uradi"); };
var bo_t23 = function (match, outcome) { return "".concat(match.awayTeam, " har bir davrda gol uradi"); };
var bo_u23 = function (match, outcome) { return 'Har bir davrda gol uriladi'; };
var bo_v23 = function (match, outcome) { return 'Birinchi va ikkinchi davrni taqqoslash'; };
var bo_w23 = function (match, outcome) { return 'Birinchi va uchinchi davrni taqqoslash'; };
var bo_x23 = function (match, outcome) { return 'Uchinchi va ikkinchi davrni taqqoslash'; };
var bo_y23 = function (match, outcome) { return "".concat(match.homeTeam, " davrlarning birida g'alaba qozonadi"); };
var bo_z23 = function (match, outcome) { return "".concat(match.awayTeam, " davrlarning birida g'alaba qozonadi"); };
var bo_a24 = function (match, outcome) { return 'Hech bo\'lmaganda bitta davrda durrang'; };
var bo_b24 = function (match, outcome) { return 'O\'yinning 1 dan 10-daqiqasigacha g\'alaba'; };
var bo_c24 = function (match, outcome) { return 'O\'yinning 11 dan 20-daqiqasigacha g\'alaba'; };
var bo_d24 = function (match, outcome) { return 'O\'yinning 21 dan 30-daqiqasigacha g\'alaba'; };
var bo_e24 = function (match, outcome) { return 'O\'yinning 31 dan 40-daqiqasigacha g\'alaba'; };
var bo_f24 = function (match, outcome) { return 'O\'yinning 41 dan 50-daqiqasigacha g\'alaba'; };
var bo_g24 = function (match, outcome) { return 'O\'yinning 51 dan 60-daqiqasigacha g\'alaba'; };
var bo_h24 = function (match, outcome) { return 'O\'yinning 1 dan 10-daqiqasigacha fora'; };
var bo_i24 = function (match, outcome) { return 'O\'yinning 11 dan 20-daqiqasigacha fora'; };
var bo_j24 = function (match, outcome) { return 'O\'yinning 21 dan 30-daqiqasigacha fora'; };
var bo_k24 = function (match, outcome) { return 'O\'yinning 31 dan 40-daqiqasigacha fora'; };
var bo_l24 = function (match, outcome) { return 'O\'yinning 41 dan 50-daqiqasigacha fora'; };
var bo_m24 = function (match, outcome) { return 'O\'yinning 51 dan 60-daqiqasigacha fora'; };
var bo_n24 = function (match, outcome) { return 'O\'yinning 1 dan 10-daqiqasigacha jami hisob'; };
var bo_o24 = function (match, outcome) { return 'O\'yinning 11 dan 20-daqiqasigacha jami hisob'; };
var bo_p24 = function (match, outcome) { return 'O\'yinning 21 dan 30-daqiqasigacha jami hisob'; };
var bo_q24 = function (match, outcome) { return 'O\'yinning 31 dan 40-daqiqasigacha jami hisob'; };
var bo_r24 = function (match, outcome) { return 'O\'yinning 41 dan 50-daqiqasigacha jami hisob'; };
var bo_s24 = function (match, outcome) { return 'O\'yinning 51 dan 60-daqiqasigacha jami hisob'; };
var bo_t24 = function (match, outcome) { return 'Nechta jamoa birinchi davrda gol uradi?'; };
var bo_u24 = function (match, outcome) { return 'Nechta jamoa ikkinchi davrda gol uradi?'; };
var bo_v24 = function (match, outcome) { return 'Nechta jamoa uchinchi davrda gol uradi?'; };
var bo_w24 = function (match, outcome) { return "".concat(match.homeTeam, " irodali g'alaba qozonadi"); };
var bo_x24 = function (match, outcome) { return "".concat(match.awayTeam, " irodali g'alaba qozonadi"); };
var bo_y24 = function (match, outcome) { return 'Tushgan eng katta shar juft/toq'; };
var bo_z24 = function (match, outcome) { return 'Tushgan eng kichik shar juft/toq'; };
var bo_a25 = function (match, outcome) { return 'Tushgan birinchi shar juft/toq'; };
var bo_b25 = function (match, outcome) { return 'Tushgan oxirgi shar juft/toq'; };
var bo_c25 = function (match, outcome) { return 'Birinchisi oxirgisidan kichik/katta'; };
var bo_d25 = function (match, outcome) { return 'Barcha sharlat juft'; };
var bo_e25 = function (match, outcome) { return 'Barcha sharlat toq'; };
var bo_f25 = function (match, outcome) { return 'Hech bo\'lmaganda ikkita shar qo\'shni raqamlar'; };
var bo_g25 = function (match, outcome) { return 'Tushgan eng kichik shar'; };
var bo_h25 = function (match, outcome) { return 'Tushgan eng katta shar'; };
var bo_i25 = function (match, outcome) { return 'Tushgan jami sharlar yig\'indisi'; };
var bo_j25 = function (match, outcome) { return "Hech bo'lmaganda bitta shar karrali ".concat(outcome.condition); };
var bo_k25 = function (match, outcome) { return 'Eng kichik va eng katta sharlar farqi'; };
var bo_l25 = function (match, outcome) { return 'Toq sharlar yig\'indisi'; };
var bo_m25 = function (match, outcome) { return 'Juft sharlar yig\'indisi'; };
var bo_n25 = function (match, outcome) { return 'Birinchi tushgan shar'; };
var bo_o25 = function (match, outcome) { return 'Ikkinchi tushgan shar'; };
var bo_p25 = function (match, outcome) { return 'Uchinchi tushgan shar'; };
var bo_q25 = function (match, outcome) { return 'To\'rtinchi tushgan shar'; };
var bo_r25 = function (match, outcome) { return 'Beshinchi tushgan shar'; };
var bo_s25 = function (match, outcome) { return 'Oltinchi tushgan shar'; };
var bo_t25 = function (match, outcome) { return 'Yettinchi tushgan shar'; };
var bo_u25 = function (match, outcome) { return "Hech bo'lmaganda bitta shar ".concat(outcome.condition, " dan ").concat(outcome.conditionTwo, " gacha oraliqda tushadi"); };
var bo_v25 = function (match, outcome) { return 'Eng katta va eng kichik sharlar yig\'indisi'; };
var bo_w25 = function (match, outcome) { return 'Match Total'; };
var bo_x25 = function (match, outcome) { return 'Round Betting'; };
var bo_y25 = function (match, outcome) { return 'Will Fight Go The Distance?'; };
var bo_z25 = function (match, outcome) { return "".concat(match.homeTeam, " to win by Submission"); };
var bo_a26 = function (match, outcome) { return "".concat(match.awayTeam, " to win by Submission"); };
var bo_b26 = function (match, outcome) { return "".concat(match.homeTeam, " to win by KO/TKO/DQ"); };
var bo_c26 = function (match, outcome) { return "".concat(match.awayTeam, " to win by KO/TKO/DQ"); };
var bo_d26 = function (match, outcome) { return 'Jami medallar soni'; };
var bo_e26 = function (match, outcome) { return 'Yigirma to\'qqizinchi partiya natijasi'; };
var bo_f26 = function (match, outcome) { return 'O\'ttizinchi partiya natijasi'; };
var bo_g26 = function (match, outcome) { return 'O\'ttiz birinchi partiya natijasi'; };
var bo_h26 = function (match, outcome) { return 'O\'ttiz ikkinchi partiya natijasi'; };
var bo_i26 = function (match, outcome) { return 'O\'ttiz uchinchi partiya natijasi'; };
var bo_j26 = function (match, outcome) { return 'O\'ttiz to\'rtinchi partiya natijasi'; };
var bo_k26 = function (match, outcome) { return 'O\'ttiz beshinchi partiya natijasi'; };
var bo_l26 = function (match, outcome) { return 'O\'ttiz oltinchi partiya natijasi'; };
var bo_m26 = function (match, outcome) { return 'O\'ttiz yettinchi partiya natijasi'; };
var bo_n26 = function (match, outcome) { return 'O\'n sakkizinchi partiya juft/toq'; };
var bo_o26 = function (match, outcome) { return 'O\'n to\'qqizinchi partiya juft/toq'; };
var bo_p26 = function (match, outcome) { return 'Yigirmanchi partiya juft/toq'; };
var bo_q26 = function (match, outcome) { return 'Yigirma birinchi partiya juft/toq'; };
var bo_r26 = function (match, outcome) { return 'Yigirma ikkinchi partiya juft/toq'; };
var bo_s26 = function (match, outcome) { return 'Yigirma uchinchi partiya juft/toq'; };
var bo_t26 = function (match, outcome) { return 'Yigirma to\'rtinchi partiya juft/toq'; };
var bo_u26 = function (match, outcome) { return 'Yigirma beshinchi partiya juft/toq'; };
var bo_v26 = function (match, outcome) { return 'Yigirma oltinchi partiya juft/toq'; };
var bo_w26 = function (match, outcome) { return 'Yigirma yettinchi partiya juft/toq'; };
var bo_x26 = function (match, outcome) { return 'Yigirma sakkizinchi partiya juft/toq'; };
var bo_y26 = function (match, outcome) { return 'Yigirma to\'qqizinchi partiya juft/toq'; };
var bo_z26 = function (match, outcome) { return 'O\'ttizinchi partiya juft/toq'; };
var bo_a27 = function (match, outcome) { return 'O\'ttiz birinchi partiya juft/toq'; };
var bo_b27 = function (match, outcome) { return 'O\'ttiz ikkinchi partiya juft/toq'; };
var bo_c27 = function (match, outcome) { return 'O\'ttiz uchinchi partiya juft/toq'; };
var bo_d27 = function (match, outcome) { return 'O\'ttiz to\'rtinchi partiya juft/toq'; };
var bo_e27 = function (match, outcome) { return 'O\'ttiz beshinchi partiya juft/toq'; };
var bo_f27 = function (match, outcome) { return 'O\'ttiz oltinchi partiya juft/toq'; };
var bo_g27 = function (match, outcome) { return 'O\'ttiz yettinchi partiya juft/toq'; };
var bo_h27 = function (match, outcome) { return 'Birinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_i27 = function (match, outcome) { return 'Ikkinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_j27 = function (match, outcome) { return 'Uchinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_k27 = function (match, outcome) { return 'To\'rtinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_l27 = function (match, outcome) { return 'Beshinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_m27 = function (match, outcome) { return 'Oltinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_n27 = function (match, outcome) { return 'Yettinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_o27 = function (match, outcome) { return 'Sakkizinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_p27 = function (match, outcome) { return 'To\'qqizinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_q27 = function (match, outcome) { return 'O\'ninchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_r27 = function (match, outcome) { return 'O\'n birinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_s27 = function (match, outcome) { return 'O\'n ikkinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_t27 = function (match, outcome) { return 'O\'n uchinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_u27 = function (match, outcome) { return 'O\'n to\'rtinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_v27 = function (match, outcome) { return 'O\'n beshinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_w27 = function (match, outcome) { return 'O\'n oltinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_x27 = function (match, outcome) { return 'O\'n yettinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_y27 = function (match, outcome) { return 'O\'n sakkizinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_z27 = function (match, outcome) { return 'O\'n to\'qqizinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_a28 = function (match, outcome) { return 'Yigirmanchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_b28 = function (match, outcome) { return 'Yigirma birinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_c28 = function (match, outcome) { return 'Yigirma ikkinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_d28 = function (match, outcome) { return 'Yigirma uchinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_e28 = function (match, outcome) { return 'Yigirma to\'rtinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_f28 = function (match, outcome) { return 'Yigirma beshinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_g28 = function (match, outcome) { return 'Yigirma oltinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_h28 = function (match, outcome) { return 'Yigirma yettinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_i28 = function (match, outcome) { return 'Yigirma sakkizinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_j28 = function (match, outcome) { return 'Yigirma to\'qqizinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_k28 = function (match, outcome) { return 'O\'ttizinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_l28 = function (match, outcome) { return 'O\'ttiz birinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_m28 = function (match, outcome) { return 'O\'ttiz ikkinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_n28 = function (match, outcome) { return 'O\'ttiz uchinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_o28 = function (match, outcome) { return 'O\'ttiz to\'rtinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_p28 = function (match, outcome) { return 'O\'ttiz beshinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_q28 = function (match, outcome) { return 'O\'ttiz oltinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_r28 = function (match, outcome) { return 'O\'ttiz yettinchi partiyada qanaqa rangli shar birinchi bo\'lib savatga tushiriladi?'; };
var bo_s28 = function (match, outcome) { return 'Birinchi partiya natijasi'; };
var bo_t28 = function (match, outcome) { return 'Ikkinchi partiya natijasi'; };
var bo_u28 = function (match, outcome) { return 'Uchinchi partiya natijasi'; };
var bo_v28 = function (match, outcome) { return 'To\'rtinchi partiya natijasi'; };
var bo_w28 = function (match, outcome) { return 'Beshinchi partiya natijasi'; };
var bo_x28 = function (match, outcome) { return 'Oltinchi partiya natijasi'; };
var bo_y28 = function (match, outcome) { return 'Yettinchi partiya natijasi'; };
var bo_z28 = function (match, outcome) { return 'Sakkizinchi partiya natijasi'; };
var bo_a29 = function (match, outcome) { return 'To\'qqizinchi partiya natijasi'; };
var bo_b29 = function (match, outcome) { return 'O\'ninchi partiya natijasi'; };
var bo_c29 = function (match, outcome) { return 'O\'n birinchi partiya natijasi'; };
var bo_d29 = function (match, outcome) { return 'O\'n ikkinchi partiya natijasi'; };
var bo_e29 = function (match, outcome) { return 'O\'n uchinchi partiya natijasi'; };
var bo_f29 = function (match, outcome) { return 'O\'n to\'rtinchi partiya natijasi'; };
var bo_g29 = function (match, outcome) { return 'O\'n beshinchi partiya natijasi'; };
var bo_h29 = function (match, outcome) { return 'O\'n oltinchi partiya natijasi'; };
var bo_i29 = function (match, outcome) { return 'O\'n yettinchi partiya natijasi'; };
var bo_j29 = function (match, outcome) { return 'O\'n sakkizinchi partiya natijasi'; };
var bo_k29 = function (match, outcome) { return 'O\'n to\'qqizinchi partiya natijasi'; };
var bo_l29 = function (match, outcome) { return 'Yigirmanchi partiya natijasi'; };
var bo_m29 = function (match, outcome) { return 'Yigirma birinchi partiya natijasi'; };
var bo_n29 = function (match, outcome) { return 'Yigirma ikkinchi partiya natijasi'; };
var bo_o29 = function (match, outcome) { return 'Yigirma uchinchi partiya natijasi'; };
var bo_p29 = function (match, outcome) { return 'Yigirma to\'rtinchi partiya natijasi'; };
var bo_q29 = function (match, outcome) { return 'Yigirma beshinchi partiya natijasi'; };
var bo_r29 = function (match, outcome) { return 'Yigirma oltinchi partiya natijasi'; };
var bo_s29 = function (match, outcome) { return 'Yigirma yettinchi partiya natijasi'; };
var bo_t29 = function (match, outcome) { return 'Yigirma sakkizinchi partiya natijasi'; };
var bo_u29 = function (match, outcome) { return 'Kim yettinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_v29 = function (match, outcome) { return 'Kim sakkizinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_w29 = function (match, outcome) { return 'Kim to\'qqizinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_x29 = function (match, outcome) { return 'Kim o\'ninchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_y29 = function (match, outcome) { return 'Kim o\'n birinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_z29 = function (match, outcome) { return 'Kim o\'n ikkinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_a30 = function (match, outcome) { return 'Kim o\'n uchinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_b30 = function (match, outcome) { return 'Kim o\'n to\'rtinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_c30 = function (match, outcome) { return 'Kim o\'n beshinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_d30 = function (match, outcome) { return 'Kim o\'n oltinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_e30 = function (match, outcome) { return 'Kim o\'n yettinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_f30 = function (match, outcome) { return 'Kim o\'n sakkizinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_g30 = function (match, outcome) { return 'Kim o\'n to\'qqizinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_h30 = function (match, outcome) { return 'Kim yigirmanchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_i30 = function (match, outcome) { return 'Kim yigirma birinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_j30 = function (match, outcome) { return 'Kim yigirma ikkinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_k30 = function (match, outcome) { return 'Kim yigirma uchinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_l30 = function (match, outcome) { return 'Kim yigirma to\'rtinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_m30 = function (match, outcome) { return 'Kim yigirma beshinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_n30 = function (match, outcome) { return 'Kim yigirma oltinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_o30 = function (match, outcome) { return 'Kim yigirma yettinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_p30 = function (match, outcome) { return 'Kim yigirma sakkizinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_q30 = function (match, outcome) { return 'Kim yigirma to\'qqizinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_r30 = function (match, outcome) { return 'Kim o\'ttizinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_s30 = function (match, outcome) { return 'Kim o\'ttiz birinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_t30 = function (match, outcome) { return 'Kim o\'ttiz ikkinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_u30 = function (match, outcome) { return 'Kim o\'ttiz uchinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_v30 = function (match, outcome) { return 'Kim o\'ttiz to\'rtinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_w30 = function (match, outcome) { return 'Kim o\'ttiz beshinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_x30 = function (match, outcome) { return 'Kim o\'ttiz oltinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_y30 = function (match, outcome) { return 'Kim o\'ttiz yettinchi partiyada birinchi bo\'lib savatchaga sharni tushiradi?'; };
var bo_z30 = function (match, outcome) { return "Kim birinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_a31 = function (match, outcome) { return "Kim ikkinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_b31 = function (match, outcome) { return "Kim uchinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_c31 = function (match, outcome) { return "Kim to'rtinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_d31 = function (match, outcome) { return "Kim beshinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_e31 = function (match, outcome) { return "Kim oltinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_f31 = function (match, outcome) { return "Kim yettinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_g31 = function (match, outcome) { return "Kim sakkizinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_h31 = function (match, outcome) { return "Kim to'qqizinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_i31 = function (match, outcome) { return "Kim o'ninchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_j31 = function (match, outcome) { return "Kim o'n birinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_k31 = function (match, outcome) { return "Kim o'n ikkinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_l31 = function (match, outcome) { return "Kim o'n uchinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_m31 = function (match, outcome) { return "Kim o'n to'rtinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_n31 = function (match, outcome) { return "Kim o'n beshinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_o31 = function (match, outcome) { return "Kim o'n oltinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_p31 = function (match, outcome) { return "Kim o'n yettinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_q31 = function (match, outcome) { return "Kim o'n sakkizinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_r31 = function (match, outcome) { return "Kim o'n to'qqizinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_s31 = function (match, outcome) { return "Kim yigirmanchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_t31 = function (match, outcome) { return "Kim yigirma birinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_u31 = function (match, outcome) { return "Kim yigirma ikkinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_v31 = function (match, outcome) { return "Kim yigirma uchinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_w31 = function (match, outcome) { return "Kim yigirma to'rtinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_x31 = function (match, outcome) { return "Kim yigirma beshinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_y31 = function (match, outcome) { return "Kim yigirma oltinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_z31 = function (match, outcome) { return "Kim yigirma yettinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_a32 = function (match, outcome) { return "Kim yigirma sakkizinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_b32 = function (match, outcome) { return "Kim yigirma to'qqizinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_c32 = function (match, outcome) { return "Kim o'ttizinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_d32 = function (match, outcome) { return "Kim o'ttiz birinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_e32 = function (match, outcome) { return "Kim o'ttiz ikkinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_f32 = function (match, outcome) { return "Kim o'ttiz uchinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_g32 = function (match, outcome) { return "Kim o'ttiz to'rtinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_h32 = function (match, outcome) { return "Kim o'ttiz beshinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_i32 = function (match, outcome) { return "Kim o'ttiz oltinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_j32 = function (match, outcome) { return "Kim o'ttiz yettinchi partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_k32 = function (match, outcome) { return 'Birinchi partiya juft/toq'; };
var bo_l32 = function (match, outcome) { return 'Ikkinchi partiya juft/toq'; };
var bo_m32 = function (match, outcome) { return 'Uchinchi partiya juft/toq'; };
var bo_n32 = function (match, outcome) { return 'To\'rtinchi partiya juft/toq'; };
var bo_o32 = function (match, outcome) { return 'Beshinchi partiya juft/toq'; };
var bo_p32 = function (match, outcome) { return 'Oltinchi partiya juft/toq'; };
var bo_q32 = function (match, outcome) { return 'Yettinchi partiya juft/toq'; };
var bo_r32 = function (match, outcome) { return 'Sakkizinchi partiya juft/toq'; };
var bo_s32 = function (match, outcome) { return 'To\'qqizinchi partiya juft/toq'; };
var bo_t32 = function (match, outcome) { return 'O\'ninchi partiya juft/toq'; };
var bo_u32 = function (match, outcome) { return 'O\'n birinchi partiya juft/toq'; };
var bo_v32 = function (match, outcome) { return 'O\'n ikkinchi partiya juft/toq'; };
var bo_w32 = function (match, outcome) { return 'O\'n uchinchi partiya juft/toq'; };
var bo_x32 = function (match, outcome) { return 'O\'n to\'rtinchi partiya juft/toq'; };
var bo_y32 = function (match, outcome) { return 'O\'n beshinchi partiya juft/toq'; };
var bo_z32 = function (match, outcome) { return 'O\'n oltinchi partiya juft/toq'; };
var bo_a33 = function (match, outcome) { return 'O\'n yettinchi partiya juft/toq'; };
var bo_b33 = function (match, outcome) { return 'O\'yindagi Asr breyklari jami hisobi'; };
var bo_c33 = function (match, outcome) { return 'Birinchi partiyadagi fora'; };
var bo_d33 = function (match, outcome) { return 'Ikkinchi partiyadagi fora'; };
var bo_e33 = function (match, outcome) { return 'Uchinchi partiyadagi fora'; };
var bo_f33 = function (match, outcome) { return 'To\'rtinchi partiyadagi fora'; };
var bo_g33 = function (match, outcome) { return 'Beshinchi partiyadagi fora'; };
var bo_h33 = function (match, outcome) { return 'Oltinchi partiyadagi fora'; };
var bo_i33 = function (match, outcome) { return 'Yettinchi partiyadagi fora'; };
var bo_j33 = function (match, outcome) { return 'Sakkizinchi partiyadagi fora'; };
var bo_k33 = function (match, outcome) { return 'To\'qqizinchi partiyadagi fora'; };
var bo_l33 = function (match, outcome) { return 'O\'ninchi partiyadagi fora'; };
var bo_m33 = function (match, outcome) { return 'O\'n birinchi partiyadagi fora'; };
var bo_n33 = function (match, outcome) { return 'O\'n ikkinchi partiyadagi fora'; };
var bo_o33 = function (match, outcome) { return 'O\'n uchinchi partiyadagi fora'; };
var bo_p33 = function (match, outcome) { return 'O\'n to\'rtinchi partiyadagi fora'; };
var bo_q33 = function (match, outcome) { return 'O\'n beshinchi partiyadagi fora'; };
var bo_r33 = function (match, outcome) { return 'O\'n oltinchi partiyadagi fora'; };
var bo_s33 = function (match, outcome) { return 'O\'n yettinchi partiyadagi fora'; };
var bo_t33 = function (match, outcome) { return 'O\'n sakkizinchi partiyadagi fora'; };
var bo_u33 = function (match, outcome) { return 'O\'n to\'qqizinchi partiyadagi fora'; };
var bo_v33 = function (match, outcome) { return 'Yigirmanchi partiyadagi fora'; };
var bo_w33 = function (match, outcome) { return 'Yigirma birinchi partiyadagi fora'; };
var bo_x33 = function (match, outcome) { return 'Yigirma ikkinchi partiyadagi fora'; };
var bo_y33 = function (match, outcome) { return 'Yigirma uchinchi partiyadagi fora'; };
var bo_z33 = function (match, outcome) { return 'Yigirma to\'rtinchi partiyadagi fora'; };
var bo_a34 = function (match, outcome) { return 'Yigirma beshinchi partiyadagi fora'; };
var bo_b34 = function (match, outcome) { return 'Yigirma oltinchi partiyadagi fora'; };
var bo_c34 = function (match, outcome) { return 'Yigirma yettinchi partiyadagi fora'; };
var bo_d34 = function (match, outcome) { return 'Yigirma sakkizinchi partiyadagi fora'; };
var bo_e34 = function (match, outcome) { return 'Yigirma to\'qqizinchi partiyadagi fora'; };
var bo_f34 = function (match, outcome) { return 'O\'ttizinchi partiyadagi fora'; };
var bo_g34 = function (match, outcome) { return 'O\'ttiz birinchi partiyadagi fora'; };
var bo_h34 = function (match, outcome) { return 'O\'ttiz ikkinchi partiyadagi fora'; };
var bo_i34 = function (match, outcome) { return 'O\'ttiz uchinchi partiyadagi fora'; };
var bo_j34 = function (match, outcome) { return 'O\'ttiz to\'rtinchi partiyadagi fora'; };
var bo_k34 = function (match, outcome) { return 'O\'ttiz beshinchi partiyadagi fora'; };
var bo_l34 = function (match, outcome) { return 'O\'ttiz oltinchi partiyadagi fora'; };
var bo_m34 = function (match, outcome) { return 'O\'ttiz yettinchi partiyadagi fora'; };
var bo_n34 = function (match, outcome) { return 'Birinchi partiya jami hisobi'; };
var bo_o34 = function (match, outcome) { return 'Ikkinchi partiya jami hisobi'; };
var bo_p34 = function (match, outcome) { return 'Uchinchi partiya jami hisobi'; };
var bo_q34 = function (match, outcome) { return 'To\'rtinchi partiya jami hisobi'; };
var bo_r34 = function (match, outcome) { return 'Beshinchi partiya jami hisobi'; };
var bo_s34 = function (match, outcome) { return 'Oltinchi partiya jami hisobi'; };
var bo_t34 = function (match, outcome) { return 'Yettinchi partiya jami hisobi'; };
var bo_u34 = function (match, outcome) { return 'Sakkizinchi partiya jami hisobi'; };
var bo_v34 = function (match, outcome) { return 'To\'qqizinchi partiya jami hisobi'; };
var bo_w34 = function (match, outcome) { return 'O\'ninchi partiya jami hisobi'; };
var bo_x34 = function (match, outcome) { return 'O\'n birinchi partiya jami hisobi'; };
var bo_y34 = function (match, outcome) { return 'O\'n ikkinchi partiya jami hisobi'; };
var bo_z34 = function (match, outcome) { return 'O\'n uchinchi partiya jami hisobi'; };
var bo_a35 = function (match, outcome) { return 'O\'n to\'rtinchi partiya jami hisobi'; };
var bo_b35 = function (match, outcome) { return 'O\'n beshinchi partiya jami hisobi'; };
var bo_c35 = function (match, outcome) { return 'O\'n oltinchi partiya jami hisobi'; };
var bo_d35 = function (match, outcome) { return 'O\'n yettinchi partiya jami hisobi'; };
var bo_e35 = function (match, outcome) { return 'O\'n sakkizinchi partiya jami hisobi'; };
var bo_f35 = function (match, outcome) { return 'O\'n to\'qqizinchi partiya jami hisobi'; };
var bo_g35 = function (match, outcome) { return 'Yigirmanchi partiya jami hisobi'; };
var bo_h35 = function (match, outcome) { return 'Yigirma birinchi partiya jami hisobi'; };
var bo_i35 = function (match, outcome) { return 'Yigirma ikkinchi partiya jami hisobi'; };
var bo_j35 = function (match, outcome) { return 'Yigirma uchinchi partiya jami hisobi'; };
var bo_k35 = function (match, outcome) { return 'Yigirma to\'rtinchi partiya jami hisobi'; };
var bo_l35 = function (match, outcome) { return 'Yigirma beshinchi partiya jami hisobi'; };
var bo_m35 = function (match, outcome) { return 'Yigirma oltinchi partiya jami hisobi'; };
var bo_n35 = function (match, outcome) { return 'Yigirma yettinchi partiya jami hisobi'; };
var bo_o35 = function (match, outcome) { return 'Yigirma sakkizinchi partiya jami hisobi'; };
var bo_p35 = function (match, outcome) { return 'Yigirma to\'qqizinchi partiya jami hisobi'; };
var bo_q35 = function (match, outcome) { return 'O\'ttizinchi partiya jami hisobi'; };
var bo_r35 = function (match, outcome) { return 'O\'ttiz birinchi partiya jami hisobi'; };
var bo_s35 = function (match, outcome) { return 'O\'ttiz ikkinchi partiya jami hisobi'; };
var bo_t35 = function (match, outcome) { return 'O\'ttiz uchinchi partiya jami hisobi'; };
var bo_u35 = function (match, outcome) { return 'O\'ttiz to\'rtinchi partiya jami hisobi'; };
var bo_v35 = function (match, outcome) { return 'O\'ttiz beshinchi partiya jami hisobi'; };
var bo_w35 = function (match, outcome) { return 'O\'ttiz oltinchi partiya jami hisobi'; };
var bo_x35 = function (match, outcome) { return 'O\'ttiz yettinchi partiya jami hisobi'; };
var bo_y35 = function (match, outcome) { return 'Kim birinchi partiyada birinchi bo\'lib sharni savatga tushiradi?'; };
var bo_z35 = function (match, outcome) { return 'Kim ikkinchi partiyada birinchi bo\'lib sharni savatga tushiradi?'; };
var bo_a36 = function (match, outcome) { return 'Kim uchinchi partiyada birinchi bo\'lib sharni savatga tushiradi?'; };
var bo_b36 = function (match, outcome) { return 'Kim to\'rtinchi partiyada birinchi bo\'lib sharni savatga tushiradi?'; };
var bo_c36 = function (match, outcome) { return 'Kim beshinchi partiyada birinchi bo\'lib sharni savatga tushiradi?'; };
var bo_d36 = function (match, outcome) { return 'Kim oltinchi partiyada birinchi bo\'lib sharni savatga tushiradi?'; };
var bo_e36 = function (match, outcome) { return 'Birinchi partiyadagi Fora'; };
var bo_f36 = function (match, outcome) { return 'Ikkinchi partiyadagi Fora'; };
var bo_g36 = function (match, outcome) { return 'Uchinchi partiyadagi Fora'; };
var bo_h36 = function (match, outcome) { return 'To\'rtinchi partiyadagi Fora'; };
var bo_i36 = function (match, outcome) { return 'Beshinchi partiyadagi Fora'; };
var bo_j36 = function (match, outcome) { return 'Oltinchi partiyadagi Fora'; };
var bo_k36 = function (match, outcome) { return 'Yettinchi partiyadagi Fora'; };
var bo_l36 = function (match, outcome) { return 'O\'yindagi jami partiyalar soni'; };
var bo_m36 = function (match, outcome) { return "".concat(match.homeTeam, " ning birinchi partiyadagi jami hisobi"); };
var bo_n36 = function (match, outcome) { return "".concat(match.homeTeam, " ning ikkinchi partiyadagi jami hisobi"); };
var bo_o36 = function (match, outcome) { return "".concat(match.homeTeam, " ning uchinchi partiyadagi jami hisobi"); };
var bo_p36 = function (match, outcome) { return "".concat(match.homeTeam, " ning to'rtinchi partiyadagi jami hisobi"); };
var bo_q36 = function (match, outcome) { return "".concat(match.homeTeam, " ning beshinchi partiyadagi jami hisobi"); };
var bo_r36 = function (match, outcome) { return "".concat(match.homeTeam, " ning oltinchi partiyadagi jami hisobi"); };
var bo_s36 = function (match, outcome) { return "".concat(match.homeTeam, " ning yettinchi partiyadagi jami hisobi"); };
var bo_t36 = function (match, outcome) { return "".concat(match.awayTeam, " ning birinchi partiyadagi jami hisobi"); };
var bo_u36 = function (match, outcome) { return "".concat(match.awayTeam, " ning ikkinchi partiyadagi jami hisobi"); };
var bo_v36 = function (match, outcome) { return "".concat(match.awayTeam, " ning uchinchi partiyadagi jami hisobi"); };
var bo_w36 = function (match, outcome) { return "".concat(match.awayTeam, " ning to'rtinchi partiyadagi jami hisobi"); };
var bo_x36 = function (match, outcome) { return "".concat(match.awayTeam, " ning beshinchi partiyadagi jami hisobi"); };
var bo_y36 = function (match, outcome) { return "".concat(match.awayTeam, " ning oltinchi partiyadagi jami hisobi"); };
var bo_z36 = function (match, outcome) { return "".concat(match.awayTeam, " ning yettinchi partiyadagi jami hisobi"); };
var bo_a37 = function (match, outcome) { return "Kim 1-partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_b37 = function (match, outcome) { return "Kim 2-partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_c37 = function (match, outcome) { return "Kim 3-partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_d37 = function (match, outcome) { return "Kim 4-partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_e37 = function (match, outcome) { return "Kim 5-partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_f37 = function (match, outcome) { return "Kim 6-partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_g37 = function (match, outcome) { return "Kim 7-partiyada birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_h37 = function (match, outcome) { return "Birinchi partiyada ".concat(match.homeTeam, " aniq ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " bilan g'alaba qozonadi"); };
var bo_i37 = function (match, outcome) { return "Ikkinchi partiyada ".concat(match.homeTeam, " aniq ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " bilan g'alaba qozonadi"); };
var bo_j37 = function (match, outcome) { return "Uchinchi partiyada ".concat(match.homeTeam, " aniq ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " bilan g'alaba qozonadi"); };
var bo_k37 = function (match, outcome) { return "To'rtinchi partiyada ".concat(match.homeTeam, " aniq ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " bilan g'alaba qozonadi"); };
var bo_l37 = function (match, outcome) { return "Beshinchi partiyada ".concat(match.homeTeam, " aniq ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " bilan g'alaba qozonadi"); };
var bo_m37 = function (match, outcome) { return "Oltinchi partiyada ".concat(match.homeTeam, " aniq ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " bilan g'alaba qozonadi"); };
var bo_n37 = function (match, outcome) { return "Yettinchi partiyada ".concat(match.homeTeam, " aniq ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " bilan g'alaba qozonadi"); };
var bo_o37 = function (match, outcome) { return "Birinchi partiyada ".concat(match.awayTeam, " aniq ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " bilan g'alaba qozonadi"); };
var bo_p37 = function (match, outcome) { return "Ikkinchi partiyada ".concat(match.awayTeam, " aniq ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " bilan g'alaba qozonadi"); };
var bo_q37 = function (match, outcome) { return "Uchinchi partiyada ".concat(match.awayTeam, " aniq ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " bilan g'alaba qozonadi"); };
var bo_r37 = function (match, outcome) { return "To'rtinchi partiyada ".concat(match.awayTeam, " aniq ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " bilan g'alaba qozonadi"); };
var bo_s37 = function (match, outcome) { return "Beshinchi partiyada ".concat(match.awayTeam, " aniq ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " bilan g'alaba qozonadi"); };
var bo_t37 = function (match, outcome) { return "Oltinchi partiyada ".concat(match.awayTeam, " aniq ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " bilan g'alaba qozonadi"); };
var bo_u37 = function (match, outcome) { return "Yettinchi partiyada ".concat(match.awayTeam, " aniq ").concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " bilan g'alaba qozonadi"); };
var bo_v37 = function (match, outcome) { return 'Birinchi partiya aniq jami hisobi'; };
var bo_w37 = function (match, outcome) { return 'Ikkinchi partiya aniq jami hisobi'; };
var bo_x37 = function (match, outcome) { return 'Uchinchi partiya aniq jami hisobi'; };
var bo_y37 = function (match, outcome) { return 'To\'rtinchi partiya aniq jami hisobi'; };
var bo_z37 = function (match, outcome) { return 'Beshinchi partiya aniq jami hisobi'; };
var bo_a38 = function (match, outcome) { return 'Oltinchi partiya aniq jami hisobi'; };
var bo_b38 = function (match, outcome) { return 'Yettinchi partiya aniq jami hisobi'; };
var bo_c38 = function (match, outcome) { return "Kim birinchi partiyada ".concat(numeralNeuterEnding(outcome.condition), " ochkoni yutadi"); };
var bo_d38 = function (match, outcome) { return "Kim ikkinchi partiyada ".concat(numeralNeuterEnding(outcome.condition), " ochkoni yutadi"); };
var bo_e38 = function (match, outcome) { return "Kim uchinchi partiyada ".concat(numeralNeuterEnding(outcome.condition), " ochkoni yutadi"); };
var bo_f38 = function (match, outcome) { return "Kim to'rtinchi partiyada ".concat(numeralNeuterEnding(outcome.condition), " ochkoni yutadi"); };
var bo_g38 = function (match, outcome) { return "Kim beshinchi partiyada ".concat(numeralNeuterEnding(outcome.condition), " ochkoni yutadi"); };
var bo_h38 = function (match, outcome) { return "Kim oltinchi partiyada ".concat(numeralNeuterEnding(outcome.condition), " ochkoni yutadi"); };
var bo_i38 = function (match, outcome) { return "Kim yettinchi partiyada ".concat(numeralNeuterEnding(outcome.condition), " ochkoni yutadi"); };
var bo_j38 = function (match, outcome) { return 'Birinchi partiyada aniq jami hisob'; };
var bo_k38 = function (match, outcome) { return 'Ikkinchi partiyada aniq jami hisob'; };
var bo_l38 = function (match, outcome) { return 'Uchinchi partiyada aniq jami hisob'; };
var bo_m38 = function (match, outcome) { return 'To\'rtinchi partiyada aniq jami hisob'; };
var bo_n38 = function (match, outcome) { return 'Beshinchi partiyada aniq jami hisob'; };
var bo_o38 = function (match, outcome) { return 'Oltinchi partiyada aniq jami hisob'; };
var bo_p38 = function (match, outcome) { return 'Yettinchi partiyada aniq jami hisob'; };
var bo_q38 = function (match, outcome) { return 'Birinchi davr aniq jami hisobi juft/toq'; };
var bo_r38 = function (match, outcome) { return 'Ikkinchi davr aniq jami hisobi juft/toq'; };
var bo_s38 = function (match, outcome) { return 'Uchinchi davr aniq jami hisobi juft/toq'; };
var bo_t38 = function (match, outcome) { return 'To\'rtinchi davr aniq jami hisobi juft/toq'; };
var bo_u38 = function (match, outcome) { return 'Beshinchi davr aniq jami hisobi juft/toq'; };
var bo_v38 = function (match, outcome) { return 'Oltinchi davr aniq jami hisobi juft/toq'; };
var bo_w38 = function (match, outcome) { return 'Yettinchi davr aniq jami hisobi juft/toq'; };
var bo_x38 = function (match, outcome) { return 'O\'yinning aniq hisobi'; };
var bo_y38 = function (match, outcome) { return "".concat(match.awayTeam, " 1 chi yoki 2 chi geymda breykni amalga oshiradi"); };
var bo_z38 = function (match, outcome) { return 'Tennischi tomonidan ketma-ket yutilgan geymlarning maksimal soni'; };
var bo_a39 = function (match, outcome) { return 'Breyklar bilan almashinadimi (ketma-ket ikki marta)?'; };
var bo_b39 = function (match, outcome) { return "".concat(match.homeTeam, " ning to'rtinchi setdagi jami hisobi"); };
var bo_c39 = function (match, outcome) { return "".concat(match.homeTeam, " ning beshinchi setdagi jami hisobi"); };
var bo_d39 = function (match, outcome) { return "".concat(match.awayTeam, " ning to'rtinchi setdagi jami hisobi"); };
var bo_e39 = function (match, outcome) { return "".concat(match.awayTeam, " ning beshinchi setdagi jami hisobi"); };
var bo_f39 = function (match, outcome) { return 'To\'rtinchi set juft/toq'; };
var bo_g39 = function (match, outcome) { return 'Beshinchi set juft/toq'; };
var bo_h39 = function (match, outcome) { return 'Birinchi set/o\'yin'; };
var bo_i39 = function (match, outcome) { return "".concat(outcome.condition, "-geymda breyk point amalga oshadi"); };
var bo_j39 = function (match, outcome) { return 'Ikkinchi setdagi jami breyklar soni'; };
var bo_k39 = function (match, outcome) { return 'Uchinchi setdagi jami breyklar soni'; };
var bo_l39 = function (match, outcome) { return 'To\'rtinchi setdagi jami breyklar soni'; };
var bo_m39 = function (match, outcome) { return 'Beshinchi setdagi jami breyklar soni'; };
var bo_n39 = function (match, outcome) { return "G'alaba va ikkinchi set jami hisobi ".concat(outcome.condition); };
var bo_o39 = function (match, outcome) { return "G'alaba va uchinchi set jami hisobi ".concat(outcome.condition); };
var bo_p39 = function (match, outcome) { return "G'alaba va to'rtinchi set jami hisobi ".concat(outcome.condition); };
var bo_q39 = function (match, outcome) { return "G'alaba va beshinchi set jami hisobi ".concat(outcome.condition); };
var bo_r39 = function (match, outcome) { return "".concat(match.homeTeam, " birinchi setdagi jami breyklar soni"); };
var bo_s39 = function (match, outcome) { return "".concat(match.homeTeam, " ikkinchi setdagi jami breyklar soni"); };
var bo_t39 = function (match, outcome) { return "".concat(match.homeTeam, " uchinchi setdagi jami breyklar soni"); };
var bo_u39 = function (match, outcome) { return "".concat(match.homeTeam, " to'rtinchi setdagi jami breyklar soni"); };
var bo_v39 = function (match, outcome) { return "".concat(match.homeTeam, " beshinchi setdagi jami breyklar soni"); };
var bo_w39 = function (match, outcome) { return "".concat(match.awayTeam, " birinchi setdagi jami breyklar soni"); };
var bo_x39 = function (match, outcome) { return "".concat(match.awayTeam, " ikkinchi setdagi jami breyklar soni"); };
var bo_y39 = function (match, outcome) { return "".concat(match.awayTeam, " uchinchi setdagi jami breyklar soni"); };
var bo_z39 = function (match, outcome) { return "".concat(match.awayTeam, " to'rtinchi setdagi jami breyklar soni"); };
var bo_a40 = function (match, outcome) { return "".concat(match.awayTeam, " beshinchi setdagi jami breyklar soni"); };
var bo_b40 = function (match, outcome) { return "Kimdir birinchi setda ketma-ket ".concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadimi?"); };
var bo_c40 = function (match, outcome) { return "Kimdir ikkinchi setda ketma-ket ".concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadimi?"); };
var bo_d40 = function (match, outcome) { return "Kimdir uchinchi setda ketma-ket ".concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadimi?"); };
var bo_e40 = function (match, outcome) { return "Kimdir to'rtinchi setda ketma-ket ".concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadimi?"); };
var bo_f40 = function (match, outcome) { return "Kimdir beshinchi setda ketma-ket ".concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadimi?"); };
var bo_g40 = function (match, outcome) { return "".concat(match.homeTeam, " birinchi setda ketma-ket ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadimi?"); };
var bo_h40 = function (match, outcome) { return "".concat(match.homeTeam, " ikkinchi setda ketma-ket ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadimi?"); };
var bo_i40 = function (match, outcome) { return "".concat(match.homeTeam, " uchinchi setda ketma-ket ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadimi?"); };
var bo_j40 = function (match, outcome) { return "".concat(match.homeTeam, " to'rtinchi setda ketma-ket ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadimi?"); };
var bo_k40 = function (match, outcome) { return "".concat(match.homeTeam, " beshinchi setda ketma-ket ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadimi?"); };
var bo_l40 = function (match, outcome) { return "".concat(match.awayTeam, " birinchi setda ketma-ket ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadimi?"); };
var bo_m40 = function (match, outcome) { return "".concat(match.awayTeam, " ikkinchi setda ketma-ket ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadimi?"); };
var bo_n40 = function (match, outcome) { return "".concat(match.awayTeam, " uchinchi setda ketma-ket ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadimi?"); };
var bo_o40 = function (match, outcome) { return "".concat(match.awayTeam, " to'rtinchi setda ketma-ket ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadimi?"); };
var bo_p40 = function (match, outcome) { return "".concat(match.awayTeam, " beshinchi setda ketma-ket ").concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadimi?"); };
var bo_q40 = function (match, outcome) { return 'To\'rtinchi setdagi Fora'; };
var bo_r40 = function (match, outcome) { return 'Beshinchi setdagi Fora'; };
var bo_s40 = function (match, outcome) { return 'To\'rtinchi set jami hisobi'; };
var bo_t40 = function (match, outcome) { return 'Beshinchi set jami hisobi'; };
var bo_u40 = function (match, outcome) { return "".concat(outcome.condition, "-geymning aniq hisobi"); };
var bo_v40 = function (match, outcome) { return "Kim ".concat(outcome.condition, "-geymni yutadi?"); };
var bo_w40 = function (match, outcome) { return 'Birinchi set aniq natijasi'; };
var bo_x40 = function (match, outcome) { return 'Ikkinchi set aniq natijasi'; };
var bo_y40 = function (match, outcome) { return 'Uchinchi set aniq natijasi'; };
var bo_z40 = function (match, outcome) { return 'To\'rtinchi set aniq natijasi'; };
var bo_a41 = function (match, outcome) { return 'Beshinchi set aniq natijasi'; };
var bo_b41 = function (match, outcome) { return "".concat(outcome.condition, "-geymda 15x15 bo'ladimi?"); };
var bo_c41 = function (match, outcome) { return "".concat(outcome.condition, "-geymda 30x30 bo'ladimi?"); };
var bo_d41 = function (match, outcome) { return "".concat(outcome.condition, "-geymda 40x40 bo'ladimi?"); };
var bo_e41 = function (match, outcome) { return "Kim 1-setda birinchi bo'lib ".concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadi"); };
var bo_f41 = function (match, outcome) { return "Kim 2-setda birinchi bo'lib ".concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadi"); };
var bo_g41 = function (match, outcome) { return "Kim 3-setda birinchi bo'lib ".concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadi"); };
var bo_h41 = function (match, outcome) { return "Kim 4-setda birinchi bo'lib ".concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadi"); };
var bo_i41 = function (match, outcome) { return "Kim 5-setda birinchi bo'lib ".concat(outcome.condition, " ta ").concat(plural(outcome.condition, ['geym', 'geym', 'geym']), " yutadi"); };
var bo_j41 = function (match, outcome) { return 'To\'rtinchi set natijasi'; };
var bo_k41 = function (match, outcome) { return 'Beshinchi set natijasi'; };
var bo_l41 = function (match, outcome) { return "".concat(outcome.condition, "-geymdagi birinchi ochko"); };
var bo_m41 = function (match, outcome) { return 'Birinchi setda tie-breyk bo\'ladimi?'; };
var bo_n41 = function (match, outcome) { return 'Ikkinchi setda tie-breyk bo\'ladimi?'; };
var bo_o41 = function (match, outcome) { return 'Uchinchi setda tie-breyk bo\'ladimi?'; };
var bo_p41 = function (match, outcome) { return 'To\'rtinchi setda tie-breyk bo\'ladimi?'; };
var bo_q41 = function (match, outcome) { return 'Beshinchi setda tie-breyk bo\'ladimi?'; };
var bo_r41 = function (match, outcome) { return 'O\'yinda tie-break bo\'ladimi?'; };
var bo_s41 = function (match, outcome) { return 'Birinchi setdagi jami tie-braeklar soni'; };
var bo_t41 = function (match, outcome) { return 'Ikkinchi setdagi jami tie-braeklar soni'; };
var bo_u41 = function (match, outcome) { return 'Uchinchi setdagi jami tie-braeklar soni'; };
var bo_v41 = function (match, outcome) { return 'To\'rtinchi setdagi jami tie-braeklar soni'; };
var bo_w41 = function (match, outcome) { return 'Beshinchi setdagi jami tie-braeklar soni'; };
var bo_x41 = function (match, outcome) { return 'Birinchi setdagi tie-breakning aniq hisobi'; };
var bo_y41 = function (match, outcome) { return 'Ikkinchi setdagi tie-breakning aniq hisobi'; };
var bo_z41 = function (match, outcome) { return 'Uchinchi setdagi tie-breakning aniq hisobi'; };
var bo_a42 = function (match, outcome) { return 'To\'rtinchi setdagi tie-breakning aniq hisobi'; };
var bo_b42 = function (match, outcome) { return 'Beshinchi setdagi tie-breakning aniq hisobi'; };
var bo_c42 = function (match, outcome) { return 'Birinchi setdagi tie-breaklarning aniq jami hisobi'; };
var bo_d42 = function (match, outcome) { return 'Ikkinchi setdagi tie-breaklarning aniq jami hisobi'; };
var bo_e42 = function (match, outcome) { return 'Uchinchi setdagi tie-breaklarning aniq jami hisobi'; };
var bo_f42 = function (match, outcome) { return 'To\'rtinchi setdagi tie-breaklarning aniq jami hisobi'; };
var bo_g42 = function (match, outcome) { return 'Beshinchi setdagi tie-breaklarning aniq jami hisobi'; };
var bo_h42 = function (match, outcome) { return 'Birinchi setdagi tie-breakda kim g\'alaba qozonadi?'; };
var bo_i42 = function (match, outcome) { return 'Ikkinchi setdagi tie-breakda kim g\'alaba qozonadi?'; };
var bo_j42 = function (match, outcome) { return 'Uchinchi setdagi tie-breakda kim g\'alaba qozonadi?'; };
var bo_k42 = function (match, outcome) { return 'To\'rtinchi setdagi tie-breakda kim g\'alaba qozonadi?'; };
var bo_l42 = function (match, outcome) { return 'Beshinchi setdagi tie-breakda kim g\'alaba qozonadi?'; };
var bo_m42 = function (match, outcome) { return 'Birinchi setdagi jami breyklar soni'; };
var bo_n42 = function (match, outcome) { return 'O\'yindagi jami breyklar soni'; };
var bo_o42 = function (match, outcome) { return "".concat(match.homeTeam, " o'yinda biror setda g'alaba qozonadi"); };
var bo_p42 = function (match, outcome) { return "".concat(match.awayTeam, " o'yinda biror setda g'alaba qozonadi"); };
var bo_q42 = function (match, outcome) { return "G'alaba va birinchi set jami hisobi ".concat(outcome.condition); };
var bo_r42 = function (match, outcome) { return 'Eng sermahsul bo\'lmagan setning jami hisobi'; };
var bo_s42 = function (match, outcome) { return 'O\'yinda kim birinchi bo\'lib eysni amalga oshiradi'; };
var bo_t42 = function (match, outcome) { return 'O\'yinda kim birinchi bo\'lib qo\'shxatoni amalga oshiradi?'; };
var bo_u42 = function (match, outcome) { return "".concat(match.homeTeam, ": to'p oshirilishing eng maksimal tezligi (km/s)"); };
var bo_v42 = function (match, outcome) { return "".concat(match.awayTeam, ": to'p oshirilishing eng maksimal tezligi (km/s)"); };
var bo_w42 = function (match, outcome) { return 'Birinchi setni yutqazib o\'yinda g\'alaba qozonish'; };
var bo_x42 = function (match, outcome) { return "".concat(match.homeTeam, ": birinchi to'p oshirish %"); };
var bo_y42 = function (match, outcome) { return "".concat(match.awayTeam, ": birinchi to'p oshirish %"); };
var bo_z42 = function (match, outcome) { return 'O\'yindagi breyklar bo\'yicha natija'; };
var bo_a43 = function (match, outcome) { return "Jami brayklar soni: ".concat(match.homeTeam); };
var bo_b43 = function (match, outcome) { return "Jami brayklar soni: ".concat(match.awayTeam); };
var bo_c43 = function (match, outcome) { return 'O\'yinda kim birinchi breyk qiladi'; };
var bo_d43 = function (match, outcome) { return "".concat(match.homeTeam, " 1- yoki 2-setlarda breyk qiladi"); };
var bo_e43 = function (match, outcome) { return 'O\'yinda 6:0 yoki 0:6 hisobli set bo\'ladimi?'; };
var bo_f43 = function (match, outcome) { return "".concat(outcome.condition, "-geym aniq hisobi"); };
var bo_g43 = function (match, outcome) { return 'O\'yindagi eyslarning jami hisobi'; };
var bo_h43 = function (match, outcome) { return "O'yindagi eyslarning jami hisobi: ".concat(match.homeTeam); };
var bo_i43 = function (match, outcome) { return "O'yindagi eyslarning jami hisobi: ".concat(match.awayTeam); };
var bo_j43 = function (match, outcome) { return 'O\'yindagi qo\'shxatolarning jami hisobi'; };
var bo_k43 = function (match, outcome) { return "O'yindagi qo'shxatolarning jami hisobi: ".concat(match.homeTeam); };
var bo_l43 = function (match, outcome) { return "O'yindagi qo'shxatolarning jami hisobi: ".concat(match.awayTeam); };
var bo_m43 = function (match, outcome) { return 'Setlar sermahsulligi (Jami hisob)'; };
var bo_n43 = function (match, outcome) { return 'O\'yin to\'pni maydondan to\'g\'ridan-to\'g\'ri chiqarib yuborish orqali g\'alaba qozoniladi'; };
var bo_o43 = function (match, outcome) { return "1- yoki 2- geymda eys: ".concat(match.homeTeam); };
var bo_p43 = function (match, outcome) { return "1- yoki 2- geymda eys: ".concat(match.awayTeam); };
var bo_q43 = function (match, outcome) { return "1- yoki 2- geymda qo'shxato: ".concat(match.homeTeam); };
var bo_r43 = function (match, outcome) { return "1- yoki 2- geymda qo'shxato: ".concat(match.awayTeam); };
var bo_s43 = function (match, outcome) { return 'Birinchi setdagi jami eyslar soni'; };
var bo_t43 = function (match, outcome) { return 'O\'yinchi o\'yin davomida o\'yindan bosh tortadi (diskvalifikatsiya)'; };
var bo_u43 = function (match, outcome) { return "".concat(match.homeTeam, " ning birinchi to'p oshirilishi tushishi %"); };
var bo_v43 = function (match, outcome) { return "".concat(match.awayTeam, " ning birinchi to'p oshirilishi tushishi %"); };
var bo_w43 = function (match, outcome) { return 'Breyklar bo\'yicha birinchi set natijasi'; };
var bo_x43 = function (match, outcome) { return 'Breyklar bo\'yicha ikkinchi set natijasi'; };
var bo_y43 = function (match, outcome) { return 'Breyklar bo\'yicha uchinchi set natijasi'; };
var bo_z43 = function (match, outcome) { return 'Breyklar bo\'yicha to\'rtinchi set natijasi'; };
var bo_a44 = function (match, outcome) { return 'Breyklar bo\'yicha beshinchi set natijasi'; };
var bo_b44 = function (match, outcome) { return 'O\'yindagi breyklar bo\'yicha fora'; };
var bo_c44 = function (match, outcome) { return 'Birinchi setdagi breyklar bo\'yicha fora'; };
var bo_d44 = function (match, outcome) { return 'Ikkinchi setdagi breyklar bo\'yicha fora'; };
var bo_e44 = function (match, outcome) { return 'Uchinchi setdagi breyklar bo\'yicha fora'; };
var bo_f44 = function (match, outcome) { return 'To\'rtinchi setdagi breyklar bo\'yicha fora'; };
var bo_g44 = function (match, outcome) { return 'Beshinchi setdagi breyklar bo\'yicha fora'; };
var bo_h44 = function (match, outcome) { return "".concat(outcome.condition, "-geymda ").concat(outcome.conditionTwo, " ochkoni kim yutadi"); };
var bo_i44 = function (match, outcome) { return "".concat(outcome.conditionTwo, "- va ").concat(outcome.condition, "-geym natijasi"); };
var bo_j44 = function (match, outcome) { return "".concat(outcome.conditionTwo, "-geymda fora"); };
var bo_k44 = function (match, outcome) { return "".concat(outcome.conditionTwo, "-geymda jami hisob"); };
var bo_l44 = function (match, outcome) { return "Kim 1-setda birinchi bo'lib  ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_m44 = function (match, outcome) { return "Kim 2-setda birinchi bo'lib  ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_n44 = function (match, outcome) { return "Kim 3-setda birinchi bo'lib  ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_o44 = function (match, outcome) { return "Kim 4-setda birinchi bo'lib  ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_p44 = function (match, outcome) { return "Kim 5-setda birinchi bo'lib  ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_q44 = function (match, outcome) { return 'O\'yindagi partiyalar bo\'yicha fora'; };
var bo_r44 = function (match, outcome) { return 'Birinchi set aniq jami hisobi'; };
var bo_s44 = function (match, outcome) { return 'Ikkinchi set aniq jami hisobi'; };
var bo_t44 = function (match, outcome) { return 'Uchinchi set aniq jami hisobi'; };
var bo_u44 = function (match, outcome) { return 'To\'rtinchi set aniq jami hisobi'; };
var bo_v44 = function (match, outcome) { return 'Beshinchi set aniq jami hisobi'; };
var bo_w44 = function (match, outcome) { return 'To\'rtinchi setning aniq jami hisobi'; };
var bo_x44 = function (match, outcome) { return 'Beshinchi setning aniq jami hisobi'; };
var bo_y44 = function (match, outcome) { return "".concat(match.homeTeam, " to'rtinchi setda farq bilan g'alaba qozonadi"); };
var bo_z44 = function (match, outcome) { return "".concat(match.homeTeam, " beshinchi setda farq bilan g'alaba qozonadi"); };
var bo_a45 = function (match, outcome) { return "".concat(match.awayTeam, " to'rtinchi setda farq bilan g'alaba qozonadi"); };
var bo_b45 = function (match, outcome) { return "".concat(match.awayTeam, " beshinchi setda farq bilan g'alaba qozonadi"); };
var bo_c45 = function (match, outcome) { return 'Eng sermahsul set jami hisobi'; };
var bo_d45 = function (match, outcome) { return 'Eng sermahsul bo\'lmagan set jami hisobi'; };
var bo_e45 = function (match, outcome) { return 'To\'rtinchi setda farq bilan g\'alaba'; };
var bo_f45 = function (match, outcome) { return 'Beshinchi setda farq bilan g\'alaba'; };
var bo_g45 = function (match, outcome) { return 'Uchinchi setning 10 ochkogacha bo\'lgan kichik setida g\'alaba'; };
var bo_h45 = function (match, outcome) { return 'To\'rtinchi setning 10 ochkogacha bo\'lgan kichik setida g\'alaba'; };
var bo_i45 = function (match, outcome) { return 'Uchinchi setning 10 ochkogacha bo\'lgan kichik setida fora'; };
var bo_j45 = function (match, outcome) { return 'To\'rtinchi setning 10 ochkogacha bo\'lgan kichik setida fora'; };
var bo_k45 = function (match, outcome) { return 'Uchinchi setning 10 ochkogacha bo\'lgan kichik setida jami hisob'; };
var bo_l45 = function (match, outcome) { return 'To\'rtinchi setning 10 ochkogacha bo\'lgan kichik setida jami hisob'; };
var bo_m45 = function (match, outcome) { return 'Uchinchi setning 15 ochkogacha bo\'lgan kichik setida g\'alaba'; };
var bo_n45 = function (match, outcome) { return 'To\'rtinchi setning 15 ochkogacha bo\'lgan kichik setida g\'alaba'; };
var bo_o45 = function (match, outcome) { return 'Uchinchi setning 15 ochkogacha bo\'lgan kichik setida fora'; };
var bo_p45 = function (match, outcome) { return 'To\'rtinchi setning 15 ochkogacha bo\'lgan kichik setida fora'; };
var bo_q45 = function (match, outcome) { return 'Uchinchi setning 15 ochkogacha bo\'lgan kichik setida jami hisob'; };
var bo_r45 = function (match, outcome) { return 'To\'rtinchi setning 15 ochkogacha bo\'lgan kichik setida jami hisob'; };
var bo_s45 = function (match, outcome) { return "Kim to'rtinchi setda ".concat(numeralNeuterEnding(outcome.condition), " ochko yutadi"); };
var bo_t45 = function (match, outcome) { return "Kim beshinchi setda ".concat(numeralNeuterEnding(outcome.condition), " ochko yutadi"); };
var bo_u45 = function (match, outcome) { return 'Oltin setda fora'; };
var bo_v45 = function (match, outcome) { return 'Oltin set jami hisobi'; };
var bo_w45 = function (match, outcome) { return "".concat(match.homeTeam, " oltin set jami hisobi"); };
var bo_x45 = function (match, outcome) { return "".concat(match.awayTeam, " oltin set jami hisobi"); };
var bo_y45 = function (match, outcome) { return 'Oltin set natijasi'; };
var bo_z45 = function (match, outcome) { return "Oltin setda kim birinchi bo'lib ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['ochko', 'ochko', 'ochko']), " to'playdi"); };
var bo_a46 = function (match, outcome) { return 'Oltin set juft/toq'; };
var bo_b46 = function (match, outcome) { return "Oltin set jami hisobi ".concat(outcome.condition, " va g'alaba"); };
var bo_c46 = function (match, outcome) { return 'Oltin setda farq bilan g\'alaba'; };
var bo_d46 = function (match, outcome) { return 'Nechta setda mini tie-braek bo\'ladi?'; };
var bo_e46 = function (match, outcome) { return 'Birinchi chorak jami hisobi'; };
var bo_f46 = function (match, outcome) { return 'Ikkinchi chorak jami hisobi'; };
var bo_g46 = function (match, outcome) { return 'Uchinchi chorak jami hisobi'; };
var bo_h46 = function (match, outcome) { return 'To\'rtinchi chorak jami hisobi'; };
var bo_i46 = function (match, outcome) { return "".concat(outcome.condition, "-raundda kim g'alaba qozonadi?"); };
var bo_j46 = function (match, outcome) { return '13-sektor tushadimi?'; };
var bo_k46 = function (match, outcome) { return "".concat(outcome.condition, "-raundda 13-sektor tushadimi?"); };
var fa_b1 = function (match, outcome) { return "F1(".concat(signed(outcome.condition), ")"); };
var fa_c1 = function (match, outcome) { return "F2(".concat(signed(-outcome.condition), ")"); };
var fa_d1 = function (match, outcome) { return "".concat(outcome.condition, " dan kam"); };
var fa_e1 = function (match, outcome) { return "".concat(outcome.condition, " dan ko'p"); };
var fa_f1 = function (match, outcome) { return 'Juft'; };
var fa_g1 = function (match, outcome) { return 'Toq'; };
var fa_h1 = function (match, outcome) { return 'G\'1'; };
var fa_i1 = function (match, outcome) { return 'G\'2'; };
var fa_j1 = function (match, outcome) { return '1-si yuqoriroq'; };
var fa_k1 = function (match, outcome) { return '2-si yuqoriroq'; };
var fa_l1 = function (match, outcome) { return 'Ha'; };
var fa_m1 = function (match, outcome) { return 'Yo\'q'; };
var fa_n1 = function (match, outcome) { return '0-2'; };
var fa_o1 = function (match, outcome) { return '0-3'; };
var fa_p1 = function (match, outcome) { return '1-2'; };
var fa_q1 = function (match, outcome) { return '1-3'; };
var fa_r1 = function (match, outcome) { return '2-0'; };
var fa_s1 = function (match, outcome) { return '2-1'; };
var fa_t1 = function (match, outcome) { return '2-3'; };
var fa_u1 = function (match, outcome) { return '3-0'; };
var fa_v1 = function (match, outcome) { return '3-1'; };
var fa_w1 = function (match, outcome) { return '3-2'; };
var fa_x1 = function (match, outcome) { return "".concat(match.homeTeam); };
var fa_y1 = function (match, outcome) { return "".concat(match.awayTeam); };
var fa_z1 = function (match, outcome) { return 'Х'; };
var fa_a2 = function (match, outcome) { return 'Hechkim'; };
var fa_b2 = function (match, outcome) { return '1X'; };
var fa_c2 = function (match, outcome) { return '12'; };
var fa_d2 = function (match, outcome) { return '2X'; };
var fa_e2 = function (match, outcome) { return "G'1Jkam ".concat(outcome.condition); };
var fa_f2 = function (match, outcome) { return "G'1Jko'p ".concat(outcome.condition); };
var fa_g2 = function (match, outcome) { return "G'2Jkam ".concat(outcome.condition); };
var fa_h2 = function (match, outcome) { return "G'2Jko'p ".concat(outcome.condition); };
var fa_i2 = function (match, outcome) { return "\u0425Jkam ".concat(outcome.condition); };
var fa_j2 = function (match, outcome) { return "\u0425Jko'p ".concat(outcome.condition); };
var fa_k2 = function (match, outcome) { return '0'; };
var fa_l2 = function (match, outcome) { return '1'; };
var fa_m2 = function (match, outcome) { return '2'; };
var fa_n2 = function (match, outcome) { return '3'; };
var fa_o2 = function (match, outcome) { return '4'; };
var fa_p2 = function (match, outcome) { return '≥ 5'; };
var fa_q2 = function (match, outcome) { return 'Ikkala jamoa ham to\'p kiritadi'; };
var fa_r2 = function (match, outcome) { return 'Bitta jamoa to\'p kiritadi'; };
var fa_s2 = function (match, outcome) { return 'Ikkala jamoa to\'p kirita olmaydi'; };
var fa_t2 = function (match, outcome) { return '0-0'; };
var fa_u2 = function (match, outcome) { return '0-1'; };
var fa_v2 = function (match, outcome) { return '0-4'; };
var fa_w2 = function (match, outcome) { return '0-5'; };
var fa_x2 = function (match, outcome) { return '1-0'; };
var fa_y2 = function (match, outcome) { return '1-1'; };
var fa_z2 = function (match, outcome) { return '1-4'; };
var fa_a3 = function (match, outcome) { return '1-5'; };
var fa_b3 = function (match, outcome) { return '2-2'; };
var fa_c3 = function (match, outcome) { return '2-4'; };
var fa_d3 = function (match, outcome) { return '2-5'; };
var fa_e3 = function (match, outcome) { return '2-6'; };
var fa_f3 = function (match, outcome) { return '3-3'; };
var fa_g3 = function (match, outcome) { return '3-4'; };
var fa_h3 = function (match, outcome) { return '3-5'; };
var fa_i3 = function (match, outcome) { return '4-0'; };
var fa_j3 = function (match, outcome) { return '4-1'; };
var fa_k3 = function (match, outcome) { return '4-2'; };
var fa_l3 = function (match, outcome) { return '4-3'; };
var fa_m3 = function (match, outcome) { return '4-4'; };
var fa_n3 = function (match, outcome) { return '5-0'; };
var fa_o3 = function (match, outcome) { return '5-1'; };
var fa_p3 = function (match, outcome) { return '5-2'; };
var fa_q3 = function (match, outcome) { return '5-3'; };
var fa_r3 = function (match, outcome) { return 'Har qanday boshqa'; };
var fa_s3 = function (match, outcome) { return "\u2264 ".concat(outcome.condition); };
var fa_t3 = function (match, outcome) { return "".concat(outcome.condition + 1, " - ").concat(outcome.condition + 2); };
var fa_u3 = function (match, outcome) { return "".concat(outcome.condition + 3, " - ").concat(outcome.condition + 4); };
var fa_v3 = function (match, outcome) { return "".concat(outcome.condition + 5, " - ").concat(outcome.condition + 6); };
var fa_w3 = function (match, outcome) { return "".concat(outcome.condition + 7, " - ").concat(outcome.condition + 8); };
var fa_x3 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 9); };
var fa_y3 = function (match, outcome) { return '6-9'; };
var fa_z3 = function (match, outcome) { return '10-12'; };
var fa_a4 = function (match, outcome) { return '13-16'; };
var fa_b4 = function (match, outcome) { return '17-20'; };
var fa_c4 = function (match, outcome) { return '≥21'; };
var fa_d4 = function (match, outcome) { return "O'tish: ".concat(match.homeTeam); };
var fa_e4 = function (match, outcome) { return "O'tish: ".concat(match.awayTeam); };
var fa_f4 = function (match, outcome) { return '1-yarim'; };
var fa_g4 = function (match, outcome) { return '2-yarim'; };
var fa_h4 = function (match, outcome) { return '1-chorak'; };
var fa_i4 = function (match, outcome) { return '2-chorak'; };
var fa_j4 = function (match, outcome) { return '3-chorak'; };
var fa_k4 = function (match, outcome) { return '4-chorak'; };
var fa_l4 = function (match, outcome) { return 'G\'1: 1-2'; };
var fa_m4 = function (match, outcome) { return 'G\'1: 3-5'; };
var fa_n4 = function (match, outcome) { return 'G\'1: 6-9'; };
var fa_o4 = function (match, outcome) { return 'G\'1: 10-12'; };
var fa_p4 = function (match, outcome) { return 'G\'1: 13-16'; };
var fa_q4 = function (match, outcome) { return 'G\'1: 17-20'; };
var fa_r4 = function (match, outcome) { return 'G\'1: ≥21'; };
var fa_s4 = function (match, outcome) { return 'G\'2: 1-2'; };
var fa_t4 = function (match, outcome) { return 'G\'2: 3-5'; };
var fa_u4 = function (match, outcome) { return 'G\'2: 6-9'; };
var fa_v4 = function (match, outcome) { return 'G\'2: 10-12'; };
var fa_w4 = function (match, outcome) { return 'G\'2: 13-16'; };
var fa_x4 = function (match, outcome) { return 'G\'2: 17-20'; };
var fa_y4 = function (match, outcome) { return 'G\'2: ≥21'; };
var fa_z4 = function (match, outcome) { return 'G\'1: 3-4'; };
var fa_a5 = function (match, outcome) { return 'G\'1: 5-7'; };
var fa_b5 = function (match, outcome) { return 'G\'1: ≥8'; };
var fa_c5 = function (match, outcome) { return 'Х2'; };
var fa_d5 = function (match, outcome) { return 'G\'2: 3-4'; };
var fa_e5 = function (match, outcome) { return 'G\'2: 5-7'; };
var fa_f5 = function (match, outcome) { return 'G\'2: ≥8'; };
var fa_g5 = function (match, outcome) { return 'Х1'; };
var fa_h5 = function (match, outcome) { return 'Jarima'; };
var fa_i5 = function (match, outcome) { return '3 ochkolik'; };
var fa_j5 = function (match, outcome) { return '2 ochkolik'; };
var fa_k5 = function (match, outcome) { return "G'1 \u2265 ".concat(outcome.condition); };
var fa_l5 = function (match, outcome) { return "Farq ".concat(outcome.condition, " dan kam"); };
var fa_m5 = function (match, outcome) { return "G'2 \u2265 ".concat(outcome.condition); };
var fa_n5 = function (match, outcome) { return "G'1: ".concat(outcome.condition, "=21 dan katta"); };
var fa_o5 = function (match, outcome) { return "G'2: ".concat(outcome.condition, "=21 dan katta"); };
var fa_p5 = function (match, outcome) { return 'G\'1: 8 va undan ko\'p'; };
var fa_q5 = function (match, outcome) { return 'G\'2: 8 va undan ko\'p'; };
var fa_r5 = function (match, outcome) { return 'Hech qaysi'; };
var fa_s5 = function (match, outcome) { return 'G\'1: 1'; };
var fa_t5 = function (match, outcome) { return 'G\'1: 2'; };
var fa_u5 = function (match, outcome) { return 'G\'1: 3'; };
var fa_v5 = function (match, outcome) { return 'G\'1: 4'; };
var fa_w5 = function (match, outcome) { return 'G\'1: ≥ 5'; };
var fa_x5 = function (match, outcome) { return 'G\'2: 1'; };
var fa_y5 = function (match, outcome) { return 'G\'2: 2'; };
var fa_z5 = function (match, outcome) { return 'G\'2: 3'; };
var fa_a6 = function (match, outcome) { return 'G\'2: 4'; };
var fa_b6 = function (match, outcome) { return 'G\'2: ≥ 5'; };
var fa_c6 = function (match, outcome) { return 'Ikkala'; };
var fa_d6 = function (match, outcome) { return 'Bitta'; };
var fa_e6 = function (match, outcome) { return 'Birorta ham'; };
var fa_f6 = function (match, outcome) { return '0 yoki 1'; };
var fa_g6 = function (match, outcome) { return '5'; };
var fa_h6 = function (match, outcome) { return '6'; };
var fa_i6 = function (match, outcome) { return '7'; };
var fa_j6 = function (match, outcome) { return '≥ 8'; };
var fa_k6 = function (match, outcome) { return 'G\'1G\'1'; };
var fa_l6 = function (match, outcome) { return 'G\'1X'; };
var fa_m6 = function (match, outcome) { return 'G\'1G\'2'; };
var fa_n6 = function (match, outcome) { return 'XG\'1'; };
var fa_o6 = function (match, outcome) { return 'XX'; };
var fa_p6 = function (match, outcome) { return 'XG\'2'; };
var fa_q6 = function (match, outcome) { return 'G\'2G\'1'; };
var fa_r6 = function (match, outcome) { return 'G\'2X'; };
var fa_s6 = function (match, outcome) { return 'G\'2G\'2'; };
var fa_t6 = function (match, outcome) { return "".concat(outcome.condition + 1); };
var fa_u6 = function (match, outcome) { return "".concat(outcome.condition + 2); };
var fa_v6 = function (match, outcome) { return "".concat(outcome.condition + 3); };
var fa_w6 = function (match, outcome) { return "".concat(outcome.condition + 4); };
var fa_x6 = function (match, outcome) { return "".concat(outcome.condition + 5); };
var fa_y6 = function (match, outcome) { return "".concat(outcome.condition + 6); };
var fa_z6 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 7); };
var fa_a7 = function (match, outcome) { return "\u043E\u0442 ".concat(outcome.condition + 1, " \u0434\u043E ").concat(outcome.condition + 2); };
var fa_b7 = function (match, outcome) { return "\u043E\u0442 ".concat(outcome.condition + 3, " \u0434\u043E ").concat(outcome.condition + 4); };
var fa_c7 = function (match, outcome) { return "\u043E\u0442 ".concat(outcome.condition + 5, " \u0434\u043E ").concat(outcome.condition + 6); };
var fa_d7 = function (match, outcome) { return '4-6'; };
var fa_e7 = function (match, outcome) { return '7 va undan ko\'p'; };
var fa_f7 = function (match, outcome) { return 'G\'1Jkam'; };
var fa_g7 = function (match, outcome) { return 'G\'1Jko\'p'; };
var fa_h7 = function (match, outcome) { return 'G\'2Jkam'; };
var fa_i7 = function (match, outcome) { return 'G\'2Jko\'p'; };
var fa_j7 = function (match, outcome) { return 'G\'1: 2-3'; };
var fa_k7 = function (match, outcome) { return 'G\'1: 4-6'; };
var fa_l7 = function (match, outcome) { return 'G\'1: ≥7'; };
var fa_m7 = function (match, outcome) { return 'G\'2: 2-3'; };
var fa_n7 = function (match, outcome) { return 'G\'2: 4-6'; };
var fa_o7 = function (match, outcome) { return 'G\'2: ≥7'; };
var fa_p7 = function (match, outcome) { return "".concat(outcome.condition); };
var fa_q7 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 6); };
var fa_r7 = function (match, outcome) { return 'G\'1: muddatidan avval g\'alaba'; };
var fa_s7 = function (match, outcome) { return 'G\'1: ochkolar bo\'yicha g\'alaba'; };
var fa_t7 = function (match, outcome) { return 'Durrang'; };
var fa_u7 = function (match, outcome) { return 'G\'2: muddatidan avval g\'alaba'; };
var fa_v7 = function (match, outcome) { return 'G\'2: ochkolar bo\'yicha g\'alaba'; };
var fa_w7 = function (match, outcome) { return 'G\'1: 1 raund'; };
var fa_x7 = function (match, outcome) { return 'G\'1: 2 raund'; };
var fa_y7 = function (match, outcome) { return 'G\'1: 3 raund'; };
var fa_z7 = function (match, outcome) { return 'G\'1: 4 raund'; };
var fa_a8 = function (match, outcome) { return 'G\'1: 5 raund'; };
var fa_b8 = function (match, outcome) { return 'G\'1: 6 raund'; };
var fa_c8 = function (match, outcome) { return 'G\'1: 7 raund'; };
var fa_d8 = function (match, outcome) { return 'G\'1: 8 raund'; };
var fa_e8 = function (match, outcome) { return 'G\'1: 9 raund'; };
var fa_f8 = function (match, outcome) { return 'G\'1: 10 raund'; };
var fa_g8 = function (match, outcome) { return 'G\'1: 11 raund'; };
var fa_h8 = function (match, outcome) { return 'G\'1: 12 raund'; };
var fa_i8 = function (match, outcome) { return 'G\'2: 1 raund'; };
var fa_j8 = function (match, outcome) { return 'G\'2: 2 raund'; };
var fa_k8 = function (match, outcome) { return 'G\'2: 3 raund'; };
var fa_l8 = function (match, outcome) { return 'G\'2: 4 raund'; };
var fa_m8 = function (match, outcome) { return 'G\'2: 5 raund'; };
var fa_n8 = function (match, outcome) { return 'G\'2: 6 raund'; };
var fa_o8 = function (match, outcome) { return 'G\'2: 7 raund'; };
var fa_p8 = function (match, outcome) { return 'G\'2: 8 raund'; };
var fa_q8 = function (match, outcome) { return 'G\'2: 9 raund'; };
var fa_r8 = function (match, outcome) { return 'G\'2: 10 raund'; };
var fa_s8 = function (match, outcome) { return 'G\'2: 11 raund'; };
var fa_t8 = function (match, outcome) { return 'G\'2: 12 raund'; };
var fa_u8 = function (match, outcome) { return 'X'; };
var fa_v8 = function (match, outcome) { return "F\u04242(".concat(signed(-outcome.condition), ")"); };
var fa_w8 = function (match, outcome) { return '5 va undan ko\'p'; };
var fa_x8 = function (match, outcome) { return 'Ikkala jamoa'; };
var fa_y8 = function (match, outcome) { return 'Bitta jamoa'; };
var fa_z8 = function (match, outcome) { return 'Hechqaysi'; };
var fa_a9 = function (match, outcome) { return "Har bir jamoa  ".concat(outcome.condition + 1, " yoki undan ko'p to'p kiritadi"); };
var fa_b9 = function (match, outcome) { return "Faqat bitta jamoa ".concat(outcome.condition + 1, " yoki undan ko'p to'p kiritadi"); };
var fa_c9 = function (match, outcome) { return "Hechqaysi jamoa ".concat(outcome.condition + 1, " yoki undan ko'p to'p kiritmaydi"); };
var fa_d9 = function (match, outcome) { return 'Bosh bilan'; };
var fa_e9 = function (match, outcome) { return 'Oyoq bilan, o\'yindan'; };
var fa_f9 = function (match, outcome) { return 'Avtogol bilan'; };
var fa_g9 = function (match, outcome) { return 'Penaltidan'; };
var fa_h9 = function (match, outcome) { return 'Burchak zarbasi'; };
var fa_i9 = function (match, outcome) { return 'O\'yindan tashqari holat'; };
var fa_j9 = function (match, outcome) { return 'SK'; };
var fa_k9 = function (match, outcome) { return 'Gol'; };
var fa_l9 = function (match, outcome) { return 'Bo\'ladi'; };
var fa_m9 = function (match, outcome) { return 'Bo\'lmaydi'; };
var fa_n9 = function (match, outcome) { return "".concat(outcome.condition, " dan oldin"); };
var fa_o9 = function (match, outcome) { return "".concat(outcome.condition, " dan keyin"); };
var fa_p9 = function (match, outcome) { return 'Birinchi bo\'limda'; };
var fa_q9 = function (match, outcome) { return 'Ikkinchi bo\'limda'; };
var fa_r9 = function (match, outcome) { return 'Gol kiritilmaydi'; };
var fa_s9 = function (match, outcome) { return 'Kirita olmaydi'; };
var fa_t9 = function (match, outcome) { return 'G\'1D'; };
var fa_u9 = function (match, outcome) { return 'DG\'1'; };
var fa_v9 = function (match, outcome) { return 'DD'; };
var fa_w9 = function (match, outcome) { return 'DG\'2'; };
var fa_x9 = function (match, outcome) { return 'G\'2D'; };
var fa_y9 = function (match, outcome) { return '0-6'; };
var fa_z9 = function (match, outcome) { return '1-6'; };
var fa_a10 = function (match, outcome) { return '6-0'; };
var fa_b10 = function (match, outcome) { return '6-1'; };
var fa_c10 = function (match, outcome) { return 'Goli durrang'; };
var fa_d10 = function (match, outcome) { return 'Golsiz durrang'; };
var fa_e10 = function (match, outcome) { return "G'2ko'p ".concat(outcome.condition); };
var fa_f10 = function (match, outcome) { return 'Kiritadi'; };
var fa_g10 = function (match, outcome) { return 'Kiritmaydi'; };
var fa_h10 = function (match, outcome) { return 'Har qanday boshqa hisob'; };
var fa_i10 = function (match, outcome) { return 'Ikkala jamoa to\'p kiritadi'; };
var fa_j10 = function (match, outcome) { return 'Ikkala jamoa ham to\'p kiritmaydi'; };
var fa_k10 = function (match, outcome) { return 'Birinchisi kamroq'; };
var fa_l10 = function (match, outcome) { return 'Tenglik'; };
var fa_m10 = function (match, outcome) { return 'Birinchisi ko\'proq'; };
var fa_n10 = function (match, outcome) { return 'Ha/Ha'; };
var fa_o10 = function (match, outcome) { return 'Ha/Yo\'q'; };
var fa_p10 = function (match, outcome) { return 'Yo\'q/Ha'; };
var fa_q10 = function (match, outcome) { return 'Yo\'q/Yo\'q'; };
var fa_r10 = function (match, outcome) { return "Jko'p ".concat(outcome.condition, "/Ha"); };
var fa_s10 = function (match, outcome) { return "Jko'p ".concat(outcome.condition, "/Yo'q"); };
var fa_t10 = function (match, outcome) { return "Jkam ".concat(outcome.condition, "/Ha"); };
var fa_u10 = function (match, outcome) { return "Jkam ".concat(outcome.condition, "/Yo'q"); };
var fa_v10 = function (match, outcome) { return 'G\'1 asosiy vaqtda'; };
var fa_w10 = function (match, outcome) { return 'G\'2 asosiy vaqtda'; };
var fa_x10 = function (match, outcome) { return 'G\'1 qo\'shimcha vaqtda'; };
var fa_y10 = function (match, outcome) { return 'G\'2 qo\'shimcha vaqtda'; };
var fa_z10 = function (match, outcome) { return 'G\'1 penaltilar seriyasida'; };
var fa_a11 = function (match, outcome) { return 'G\'2 penaltilar seriyasida'; };
var fa_b11 = function (match, outcome) { return '1-bo\'lim'; };
var fa_c11 = function (match, outcome) { return 'Tanaffus'; };
var fa_d11 = function (match, outcome) { return '2-bo\'lim'; };
var fa_e11 = function (match, outcome) { return '5-4'; };
var fa_f11 = function (match, outcome) { return 'G\'1 har qanday boshqa hisob bilan'; };
var fa_g11 = function (match, outcome) { return '4-5'; };
var fa_h11 = function (match, outcome) { return 'G\'2  har qanday boshqa hisob bilan'; };
var fa_i11 = function (match, outcome) { return 'Hech kim'; };
var fa_j11 = function (match, outcome) { return '1-10'; };
var fa_k11 = function (match, outcome) { return '11-20'; };
var fa_l11 = function (match, outcome) { return '21-30'; };
var fa_m11 = function (match, outcome) { return '31-40'; };
var fa_n11 = function (match, outcome) { return '41-50'; };
var fa_o11 = function (match, outcome) { return '51-60'; };
var fa_p11 = function (match, outcome) { return '61-70'; };
var fa_q11 = function (match, outcome) { return '71-80'; };
var fa_r11 = function (match, outcome) { return '81-O\'yin asosiy vaqti oxirigacha'; };
var fa_s11 = function (match, outcome) { return 'Gol yo\'q'; };
var fa_t11 = function (match, outcome) { return 'G\'1: 8 va undan katta'; };
var fa_u11 = function (match, outcome) { return 'Ikkalasi ham kiritadi'; };
var fa_v11 = function (match, outcome) { return 'Bittasi kiritadi'; };
var fa_w11 = function (match, outcome) { return 'Ikklasi ham kiritolmaydi'; };
var fa_x11 = function (match, outcome) { return "Har bir jamoa ".concat(outcome.condition + 1, " ta va undan ko'p gol kiritadi"); };
var fa_y11 = function (match, outcome) { return "Faqat bitta jamoa ".concat(outcome.condition + 1, " ta va undan ko'p gol kiritadi"); };
var fa_z11 = function (match, outcome) { return "Hechqaysi jamoa ".concat(outcome.condition + 1, " ta va undan ko'p gol kirita olmaydi"); };
var fa_a12 = function (match, outcome) { return '1<2'; };
var fa_b12 = function (match, outcome) { return '1=2'; };
var fa_c12 = function (match, outcome) { return '1>2'; };
var fa_d12 = function (match, outcome) { return '1<3'; };
var fa_e12 = function (match, outcome) { return '1=3'; };
var fa_f12 = function (match, outcome) { return '1>3'; };
var fa_g12 = function (match, outcome) { return '2<3'; };
var fa_h12 = function (match, outcome) { return '2=3'; };
var fa_i12 = function (match, outcome) { return '2>3'; };
var fa_j12 = function (match, outcome) { return 'Birorta'; };
var fa_k12 = function (match, outcome) { return 'Birinchisi kichik'; };
var fa_l12 = function (match, outcome) { return 'Birinchisi katta'; };
var fa_m12 = function (match, outcome) { return 'W1'; };
var fa_n12 = function (match, outcome) { return 'W2'; };
var fa_o12 = function (match, outcome) { return "Under ".concat(outcome.condition); };
var fa_p12 = function (match, outcome) { return "Over ".concat(outcome.condition); };
var fa_q12 = function (match, outcome) { return 'W1: 1 round'; };
var fa_r12 = function (match, outcome) { return 'W1: 2 round'; };
var fa_s12 = function (match, outcome) { return 'W1: 3 round'; };
var fa_t12 = function (match, outcome) { return 'W1: 4 round'; };
var fa_u12 = function (match, outcome) { return 'W1: 5 round'; };
var fa_v12 = function (match, outcome) { return 'W1: Point Victory'; };
var fa_w12 = function (match, outcome) { return 'Draw'; };
var fa_x12 = function (match, outcome) { return 'W2: 1 round'; };
var fa_y12 = function (match, outcome) { return 'W2: 2 round'; };
var fa_z12 = function (match, outcome) { return 'W2: 3 round'; };
var fa_a13 = function (match, outcome) { return 'W2: 4 round'; };
var fa_b13 = function (match, outcome) { return 'W2: 5 round'; };
var fa_c13 = function (match, outcome) { return 'W2: Point Victory'; };
var fa_d13 = function (match, outcome) { return 'Yes'; };
var fa_e13 = function (match, outcome) { return 'No'; };
var fa_f13 = function (match, outcome) { return 'yes'; };
var fa_g13 = function (match, outcome) { return 'no'; };
var fa_h13 = function (match, outcome) { return 'Sariq shar'; };
var fa_i13 = function (match, outcome) { return 'Yashil shar'; };
var fa_j13 = function (match, outcome) { return 'Jigarrang shar'; };
var fa_k13 = function (match, outcome) { return 'Ko\'k shar'; };
var fa_l13 = function (match, outcome) { return 'Pushti shar'; };
var fa_m13 = function (match, outcome) { return 'Qora shar'; };
var fa_n13 = function (match, outcome) { return "\u2265 ".concat(outcome.condition + 5); };
var fa_o13 = function (match, outcome) { return '≤ 14'; };
var fa_p13 = function (match, outcome) { return '15 dan 17 gacha'; };
var fa_q13 = function (match, outcome) { return '18 dan 19 gacha'; };
var fa_r13 = function (match, outcome) { return '≥ 20'; };
var fa_s13 = function (match, outcome) { return '2--si yuqoriroq'; };
var fa_t13 = function (match, outcome) { return 'G\'1-0'; };
var fa_u13 = function (match, outcome) { return 'G\'1-15'; };
var fa_v13 = function (match, outcome) { return 'G\'1-30'; };
var fa_w13 = function (match, outcome) { return 'G\'1-40'; };
var fa_x13 = function (match, outcome) { return '0-G\'2'; };
var fa_y13 = function (match, outcome) { return '15-G\'2'; };
var fa_z13 = function (match, outcome) { return '30-G\'2'; };
var fa_a14 = function (match, outcome) { return '40-G\'2'; };
var fa_b14 = function (match, outcome) { return '3-6'; };
var fa_c14 = function (match, outcome) { return '5-7'; };
var fa_d14 = function (match, outcome) { return '6-2'; };
var fa_e14 = function (match, outcome) { return '6-3'; };
var fa_f14 = function (match, outcome) { return '6-4'; };
var fa_g14 = function (match, outcome) { return '6-7'; };
var fa_h14 = function (match, outcome) { return '7-5'; };
var fa_i14 = function (match, outcome) { return '7-6'; };
var fa_j14 = function (match, outcome) { return '7-0'; };
var fa_k14 = function (match, outcome) { return '7-1'; };
var fa_l14 = function (match, outcome) { return '7-2'; };
var fa_m14 = function (match, outcome) { return '7-3'; };
var fa_n14 = function (match, outcome) { return '7-4'; };
var fa_o14 = function (match, outcome) { return 'G\'1 boshqa harqanday hisob bilan'; };
var fa_p14 = function (match, outcome) { return '0-7'; };
var fa_q14 = function (match, outcome) { return '1-7'; };
var fa_r14 = function (match, outcome) { return '2-7'; };
var fa_s14 = function (match, outcome) { return '3-7'; };
var fa_t14 = function (match, outcome) { return '4-7'; };
var fa_u14 = function (match, outcome) { return 'G\'2 boshqa harqanday hisob bilan'; };
var fa_v14 = function (match, outcome) { return '8'; };
var fa_w14 = function (match, outcome) { return '9'; };
var fa_x14 = function (match, outcome) { return '10'; };
var fa_y14 = function (match, outcome) { return '11'; };
var fa_z14 = function (match, outcome) { return '≥ 13'; };
var fa_a15 = function (match, outcome) { return "".concat(match.homeTeam, " (O'.T.O)"); };
var fa_b15 = function (match, outcome) { return "".concat(match.awayTeam, " (O'.T.O)"); };
var fa_c15 = function (match, outcome) { return "".concat(match.homeTeam); };
var fa_d15 = function (match, outcome) { return 'Ikkalasi G\'1'; };
var fa_e15 = function (match, outcome) { return 'Ikkalasi G\'2'; };
var fa_f15 = function (match, outcome) { return '1-ая выше'; };
var fa_g15 = function (match, outcome) { return '2-ая выше'; };
var fa_h15 = function (match, outcome) { return "".concat(outcome.condition + 1, " dan ").concat(outcome.condition + 2, " gacha"); };
var fa_i15 = function (match, outcome) { return "".concat(outcome.condition + 3, " dan ").concat(outcome.condition + 4, " gacha"); };
var fa_j15 = function (match, outcome) { return "".concat(outcome.condition + 5, " dan ").concat(outcome.condition + 6, " gacha"); };
var fa_k15 = function (match, outcome) { return '7 va undan katta'; };
var fa_l15 = function (match, outcome) { return 'F1'; };
var fa_m15 = function (match, outcome) { return 'F2'; };
var fa_n15 = function (match, outcome) { return 'G\'1: 7 va undan ko\'p'; };
var fa_o15 = function (match, outcome) { return 'G\'2: 7 va undan ko\'p'; };
var fa_p15 = function (match, outcome) { return '6-5'; };
var fa_q15 = function (match, outcome) { return '5-6'; };
var baseOutcomeConfig = {
    11: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        403: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    32: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        195: bo_m1,
        196: bo_n1,
        197: bo_o1,
        352: bo_p1,
        748: bo_q1,
        102: bo_f1,
        403: bo_g1,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        138: bo_u1,
        139: bo_v1,
        140: bo_w1,
        182: bo_x1,
        183: bo_y1,
        184: bo_z1,
        122: bo_a2,
        123: bo_b2,
        124: bo_c2,
        129: bo_d2,
        130: bo_e2,
        131: bo_f2,
        566: bo_g2,
        567: bo_h2,
        568: bo_i2,
        616: bo_j2,
        617: bo_k2,
        618: bo_l2,
        257: bo_d1,
        307: bo_e1,
        443: bo_h1,
        608: bo_i1,
        362: bo_m2,
        363: bo_n2,
        364: bo_o2,
        17: bo_p2,
        18: bo_q2,
        19: bo_r2,
        176: bo_s2,
        177: bo_t2,
        178: bo_u2,
        358: bo_v2,
        359: bo_w2,
        360: bo_x2,
        13: bo_y2,
        14: bo_z2,
        15: bo_a3,
        172: bo_b3,
        173: bo_c3,
        174: bo_d3,
        256: bo_d1,
        306: bo_e1
    },
    35: {
        138: bo_e3,
        256: bo_d1,
        21: bo_f3,
        673: bo_g3,
        182: bo_h3,
        306: bo_e1,
        698: bo_g1,
        731: bo_i3,
        656: bo_j3,
        195: bo_k3,
        74: bo_b1,
        349: bo_c1,
        443: bo_h1,
        608: bo_i1,
        911: bo_l3,
        426: bo_m3,
        535: bo_n3,
        871: bo_o3,
        710: bo_p3,
        742: bo_q3
    },
    10: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_c1,
        403: bo_g1,
        1: bo_r3,
        443: bo_h1,
        608: bo_i1
    },
    31: {
        74: bo_b1,
        349: bo_c1,
        21: bo_s3,
        22: bo_t3,
        23: bo_u3,
        24: bo_v3,
        256: bo_d1,
        306: bo_e1,
        195: bo_w3,
        196: bo_x3,
        197: bo_y3,
        198: bo_z3,
        673: bo_a4,
        674: bo_b4,
        675: bo_c4,
        676: bo_d4,
        103: bo_f1,
        403: bo_g1,
        138: bo_e4,
        139: bo_f4,
        140: bo_g4,
        141: bo_h4,
        182: bo_i4,
        183: bo_j4,
        184: bo_k4,
        185: bo_l4,
        238: bo_m4,
        682: bo_n4,
        239: bo_o4,
        58: bo_p4,
        59: bo_q4,
        681: bo_r4,
        234: bo_s4,
        235: bo_t4,
        236: bo_u4,
        237: bo_v4,
        725: bo_w4,
        726: bo_x4,
        727: bo_y4,
        728: bo_z4,
        782: bo_a5,
        778: bo_b5,
        779: bo_c5,
        780: bo_d5,
        781: bo_e5,
        783: bo_f5,
        773: bo_g5,
        474: bo_h5,
        421: bo_i5,
        530: bo_j5,
        422: bo_k5,
        531: bo_l5,
        444: bo_m5,
        888: bo_n5,
        280: bo_o5,
        317: bo_p5,
        424: bo_q5,
        533: bo_r5,
        423: bo_s5,
        532: bo_t5,
        637: bo_u5,
        788: bo_v5,
        784: bo_w5,
        785: bo_x5,
        786: bo_y5,
        787: bo_z5,
        774: bo_w5,
        775: bo_x5,
        776: bo_y5,
        777: bo_z5,
        281: bo_a6,
        137: bo_b6,
        246: bo_c6,
        248: bo_d6,
        240: bo_e6,
        232: bo_f6,
        241: bo_g6,
        233: bo_h6,
        61: bo_i6,
        62: bo_j6,
        684: bo_k6,
        685: bo_l6,
        443: bo_h1,
        608: bo_i1,
        890: bo_m6,
        242: bo_n6,
        245: bo_o6,
        243: bo_p6,
        60: bo_q6,
        683: bo_r6,
        406: bo_s6,
        405: bo_t6,
        404: bo_u6,
        700: bo_v6,
        408: bo_w6,
        407: bo_x6,
        247: bo_y6,
        244: bo_z6,
        638: bo_a7,
        639: bo_b7,
        640: bo_c7,
        641: bo_d7,
        646: bo_e7,
        642: bo_f7,
        643: bo_g7,
        644: bo_h7,
        645: bo_i7
    },
    41: {
        74: bo_b1,
        349: bo_c1,
        21: bo_j7,
        22: bo_k7,
        403: bo_g1,
        673: bo_l7,
        674: bo_m7,
        195: bo_n7,
        196: bo_o7,
        791: bo_p7,
        792: bo_q7,
        637: bo_u5,
        796: bo_v5,
        794: bo_r7,
        795: bo_s7,
        789: bo_r7,
        790: bo_s7,
        725: bo_t7,
        726: bo_u7,
        793: bo_a5,
        411: bo_v7,
        701: bo_w7,
        251: bo_x7,
        252: bo_y7,
        409: bo_k5,
        430: bo_l5,
        410: bo_z7,
        431: bo_a8,
        281: bo_a6,
        137: bo_b6,
        249: bo_c6,
        250: bo_d6,
        63: bo_i6,
        64: bo_j6,
        686: bo_k6,
        687: bo_l6,
        103: bo_f1,
        256: bo_d1,
        306: bo_e1,
        138: bo_b8,
        139: bo_c8,
        182: bo_d8,
        183: bo_e8,
        443: bo_h1,
        608: bo_i1,
        648: bo_f8,
        649: bo_g8
    },
    18: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_h8,
        196: bo_i8,
        197: bo_j8,
        673: bo_k8,
        674: bo_l8,
        675: bo_m8,
        610: bo_n8,
        443: bo_h1,
        608: bo_i1,
        806: bo_o8,
        893: bo_p8,
        707: bo_q8,
        708: bo_r8,
        709: bo_s8,
        889: bo_o3,
        904: bo_t8,
        253: bo_u8,
        688: bo_v8,
        65: bo_w8,
        751: bo_q3,
        21: bo_x8,
        22: bo_y8,
        23: bo_z8,
        743: bo_a9,
        744: bo_b9,
        745: bo_c9,
        615: bo_d9,
        350: bo_u8
    },
    3: {
        73: bo_b1,
        318: bo_c1,
        21: bo_e9,
        22: bo_f9,
        23: bo_g9,
        195: bo_h9,
        196: bo_i9,
        197: bo_j9,
        352: bo_k9,
        746: bo_q3,
        102: bo_l9,
        403: bo_g1,
        138: bo_m9,
        139: bo_n9,
        140: bo_o9,
        182: bo_p9,
        183: bo_q9,
        184: bo_r9,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        566: bo_g2,
        567: bo_h2,
        568: bo_i2,
        74: bo_s9,
        854: bo_t9,
        855: bo_u9,
        856: bo_v9,
        857: bo_t9,
        858: bo_u9,
        859: bo_v9,
        797: bo_w9,
        798: bo_x9,
        799: bo_y9,
        851: bo_z9,
        852: bo_a10,
        853: bo_b10,
        83: bo_c10,
        84: bo_d10,
        85: bo_e10,
        905: bo_f10,
        906: bo_g10,
        907: bo_h10,
        443: bo_h1,
        608: bo_i1,
        362: bo_i10,
        363: bo_j10,
        17: bo_k10,
        18: bo_l10,
        176: bo_m10,
        177: bo_n10,
        358: bo_o10,
        359: bo_p10,
        13: bo_q10,
        14: bo_r10,
        172: bo_s10,
        173: bo_t10,
        616: bo_u10,
        617: bo_v10,
        618: bo_w10,
        891: bo_x10,
        257: bo_d1,
        307: bo_e1,
        800: bo_y10,
        801: bo_z10,
        802: bo_a11
    },
    20: {
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        698: bo_g1,
        195: bo_b11,
        196: bo_c11,
        197: bo_d11,
        198: bo_e11,
        199: bo_f11,
        200: bo_g11,
        201: bo_h11,
        202: bo_i11,
        138: bo_j11,
        139: bo_k11,
        140: bo_l11,
        141: bo_m11,
        142: bo_n11,
        143: bo_o11,
        144: bo_p11,
        145: bo_q11,
        182: bo_r11,
        183: bo_s11,
        184: bo_t11,
        185: bo_u11,
        186: bo_v11,
        187: bo_w11,
        188: bo_x11,
        189: bo_y11,
        21: bo_z11,
        22: bo_a12,
        23: bo_b12,
        24: bo_c12,
        25: bo_d12,
        26: bo_e12,
        27: bo_f12,
        28: bo_g12,
        673: bo_h12,
        674: bo_i12,
        675: bo_j12,
        676: bo_k12,
        677: bo_l12,
        678: bo_m12,
        679: bo_n12,
        680: bo_o12,
        860: bo_p12,
        861: bo_q12,
        862: bo_r12,
        863: bo_s12,
        864: bo_t12,
        865: bo_u12,
        866: bo_v12,
        867: bo_w12,
        443: bo_h1,
        608: bo_i1
    },
    5: {
        349: bo_c1,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1,
        945: bo_x12,
        948: bo_y12,
        949: bo_z12
    },
    40: {
        656: bo_j3,
        698: bo_g1,
        443: bo_h1,
        608: bo_i1
    },
    37: {
        443: bo_h1,
        608: bo_i1
    },
    38: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_c1,
        615: bo_a13,
        413: bo_b13,
        414: bo_c13
    },
    42: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        74: bo_b1,
        349: bo_c1,
        615: bo_d13,
        413: bo_b13,
        414: bo_e13,
        566: bo_f13,
        567: bo_g13,
        568: bo_h13,
        569: bo_i13,
        570: bo_j13,
        698: bo_k13,
        366: bo_l13,
        367: bo_m13,
        368: bo_n13,
        369: bo_o13,
        370: bo_p13,
        940: bo_q13,
        941: bo_r13,
        942: bo_s13,
        943: bo_t13,
        944: bo_u13
    },
    26: {
        443: bo_h1,
        608: bo_i1
    },
    25: {
        443: bo_h1,
        608: bo_i1
    },
    16: {
        443: bo_h1,
        608: bo_i1
    },
    12: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        443: bo_h1,
        608: bo_i1
    },
    36: {
        610: bo_v13,
        698: bo_g1,
        656: bo_j3,
        74: bo_b1,
        349: bo_c1,
        615: bo_d9,
        256: bo_d1,
        306: bo_e1,
        673: bo_k8,
        21: bo_x8,
        195: bo_h8,
        443: bo_h1,
        608: bo_i1
    },
    7: {
        425: bo_w13,
        534: bo_x13,
        540: bo_y13,
        343: bo_z13,
        345: bo_a14,
        260: bo_b14,
        261: bo_c14,
        83: bo_d14,
        84: bo_e14,
        803: bo_f14,
        868: bo_g14,
        869: bo_h14,
        870: bo_i14,
        805: bo_j14,
        892: bo_k14,
        346: bo_l14,
        419: bo_m14,
        528: bo_n14,
        420: bo_o14,
        529: bo_p14,
        707: bo_q14,
        708: bo_r14,
        706: bo_s14,
        804: bo_t14,
        474: bo_u14,
        614: bo_v14,
        609: bo_w14,
        416: bo_x14,
        732: bo_y14,
        525: bo_z14,
        850: bo_a15,
        473: bo_b15,
        442: bo_c15,
        729: bo_d15,
        538: bo_e15,
        542: bo_f15,
        730: bo_g15,
        471: bo_h15,
        635: bo_i15,
        714: bo_j15,
        624: bo_k15,
        625: bo_l15,
        715: bo_m15,
        650: bo_n15,
        651: bo_o15,
        652: bo_p15,
        653: bo_q15,
        654: bo_r15,
        655: bo_s15,
        634: bo_t15,
        626: bo_u15,
        733: bo_v15,
        734: bo_w15,
        258: bo_x15,
        259: bo_y15,
        66: bo_z15,
        67: bo_a16,
        81: bo_b16,
        68: bo_c16,
        689: bo_d16,
        690: bo_e16,
        699: bo_f16,
        691: bo_g16,
        723: bo_h16,
        633: bo_i16,
        74: bo_b1,
        349: bo_j16,
        656: bo_k16,
        698: bo_g1,
        322: bo_l16,
        904: bo_m16,
        1: bo_r3,
        136: bo_n16,
        747: bo_q3,
        871: bo_o16,
        255: bo_p16,
        705: bo_q16,
        323: bo_r16,
        324: bo_s16,
        702: bo_t16,
        278: bo_u16,
        256: bo_v16,
        306: bo_w16,
        195: bo_x16,
        196: bo_y16,
        21: bo_z16,
        22: bo_a17,
        282: bo_b17,
        911: bo_c17,
        353: bo_d17,
        673: bo_g3,
        674: bo_e17,
        2: bo_f17,
        5: bo_g17,
        7: bo_h17,
        939: bo_i17,
        9: bo_j17,
        12: bo_k17,
        417: bo_l17,
        526: bo_m17,
        325: bo_n17,
        103: bo_o17,
        160: bo_p17,
        163: bo_q17,
        165: bo_r17,
        166: bo_s17,
        168: bo_t17,
        171: bo_u17,
        148: bo_v17,
        149: bo_w17,
        150: bo_x17,
        151: bo_y17,
        152: bo_z17,
        153: bo_a18,
        154: bo_b18,
        155: bo_c18,
        156: bo_d18,
        157: bo_e18,
        158: bo_f18,
        159: bo_g18,
        731: bo_d9,
        765: bo_h18,
        766: bo_i18,
        415: bo_j18,
        524: bo_k18,
        418: bo_l18,
        527: bo_m18,
        743: bo_n18,
        744: bo_o18,
        710: bo_p3,
        321: bo_p18,
        326: bo_q18,
        327: bo_r18,
        724: bo_s18,
        661: bo_t18,
        664: bo_u18,
        666: bo_v18,
        667: bo_w18,
        669: bo_x18,
        672: bo_y18,
        426: bo_z18,
        535: bo_a19,
        537: bo_b19,
        541: bo_c19,
        539: bo_d19,
        138: bo_e19,
        139: bo_f19,
        182: bo_g19,
        183: bo_h19,
        437: bo_i19,
        436: bo_j19,
        694: bo_k13,
        71: bo_k19,
        271: bo_l19,
        268: bo_m19,
        265: bo_n19,
        267: bo_o19,
        270: bo_p19,
        272: bo_q19,
        269: bo_r19,
        266: bo_s19,
        264: bo_t19,
        281: bo_u19,
        137: bo_v19,
        660: bo_j3,
        880: bo_w19,
        879: bo_x19,
        429: bo_y19,
        433: bo_z19,
        443: bo_h1,
        608: bo_i1,
        881: bo_a20,
        273: bo_b20,
        274: bo_c20,
        435: bo_d20,
        704: bo_e20,
        432: bo_f20,
        428: bo_g20,
        434: bo_h20,
        439: bo_i20,
        440: bo_j20,
        441: bo_k20,
        438: bo_l20,
        623: bo_m20,
        180: bo_n20,
        146: bo_o20,
        659: bo_p20,
        749: bo_q20,
        69: bo_r20,
        262: bo_s20,
        692: bo_t20,
        703: bo_u20,
        70: bo_v20,
        263: bo_w20,
        693: bo_x20,
        72: bo_y20,
        277: bo_z20,
        695: bo_a21,
        750: bo_b21,
        181: bo_c21,
        147: bo_d21,
        276: bo_e21,
        275: bo_f21,
        735: bo_g21,
        736: bo_h21,
        737: bo_i21,
        738: bo_j21,
        739: bo_k21,
        740: bo_l21,
        356: bo_m21,
        357: bo_n21,
        354: bo_o21,
        355: bo_p21,
        937: bo_q21,
        657: bo_r21,
        658: bo_s21,
        412: bo_t21
    },
    14: {
        443: bo_h1,
        608: bo_i1
    },
    34: {
        425: bo_u21,
        534: bo_v21,
        540: bo_y13,
        343: bo_z13,
        345: bo_a14,
        260: bo_b14,
        261: bo_c14,
        83: bo_d14,
        84: bo_e14,
        803: bo_f14,
        868: bo_g14,
        869: bo_h14,
        870: bo_i14,
        346: bo_l14,
        419: bo_m14,
        528: bo_n14,
        420: bo_o14,
        529: bo_p14,
        707: bo_q14,
        708: bo_r14,
        706: bo_s14,
        538: bo_e15,
        74: bo_b1,
        349: bo_w21,
        656: bo_k16,
        698: bo_g1,
        322: bo_l16,
        904: bo_m16,
        1: bo_r3,
        136: bo_n16,
        747: bo_q3,
        871: bo_o16,
        255: bo_p16,
        705: bo_q16,
        323: bo_r16,
        324: bo_s16,
        702: bo_t16,
        278: bo_x21,
        256: bo_v16,
        306: bo_w16,
        195: bo_x16,
        196: bo_y16,
        21: bo_z16,
        22: bo_a17,
        282: bo_b17,
        911: bo_c17,
        353: bo_d17,
        673: bo_g3,
        674: bo_e17,
        2: bo_f17,
        5: bo_g17,
        7: bo_h17,
        939: bo_i17,
        9: bo_j17,
        12: bo_k17,
        417: bo_l17,
        526: bo_m17,
        325: bo_n17,
        103: bo_o17,
        160: bo_p17,
        163: bo_q17,
        165: bo_r17,
        166: bo_s17,
        168: bo_t17,
        171: bo_u17,
        148: bo_v17,
        149: bo_w17,
        150: bo_x17,
        151: bo_y17,
        152: bo_z17,
        153: bo_a18,
        154: bo_b18,
        155: bo_c18,
        156: bo_d18,
        157: bo_e18,
        158: bo_f18,
        159: bo_g18,
        731: bo_d9,
        765: bo_h18,
        766: bo_i18,
        415: bo_y21,
        524: bo_z21,
        418: bo_l18,
        527: bo_m18,
        743: bo_n18,
        744: bo_o18,
        710: bo_p3,
        321: bo_p18,
        326: bo_q18,
        327: bo_r18,
        724: bo_s18,
        661: bo_t18,
        664: bo_u18,
        666: bo_v18,
        667: bo_w18,
        669: bo_x18,
        672: bo_y18,
        426: bo_z18,
        535: bo_a19,
        537: bo_b19,
        541: bo_c19,
        539: bo_d19,
        138: bo_e19,
        139: bo_f19,
        182: bo_g19,
        183: bo_h19,
        443: bo_h1,
        608: bo_i1
    },
    19: {
        74: bo_b1,
        349: bo_c1,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_a22,
        103: bo_f1,
        615: bo_d9,
        886: bo_b22,
        887: bo_c22,
        911: bo_d22,
        884: bo_e22,
        885: bo_f22,
        882: bo_g22,
        883: bo_h22,
        723: bo_i22,
        673: bo_g3,
        674: bo_e17,
        21: bo_f3,
        22: bo_j22,
        138: bo_d1,
        182: bo_e1,
        443: bo_h1,
        608: bo_i1
    },
    30: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        21: bo_x8,
        22: bo_y8,
        23: bo_z8,
        279: bo_k22,
        610: bo_v13,
        256: bo_d1,
        306: bo_e1,
        195: bo_h8,
        196: bo_i8,
        197: bo_j8,
        673: bo_k8,
        674: bo_l8,
        675: bo_m8,
        350: bo_u8,
        103: bo_l22,
        415: bo_m22,
        524: bo_n22,
        743: bo_o22,
        744: bo_p22,
        745: bo_q22,
        710: bo_r22,
        403: bo_g1,
        426: bo_s22,
        535: bo_t22,
        706: bo_u22,
        343: bo_v22,
        346: bo_w22,
        83: bo_x22,
        84: bo_y22,
        85: bo_z22,
        344: bo_a23,
        347: bo_b23,
        765: bo_c23,
        766: bo_d23,
        767: bo_e23,
        138: bo_f23,
        139: bo_g23,
        140: bo_h23,
        182: bo_i23,
        183: bo_j23,
        184: bo_k23,
        751: bo_q3,
        911: bo_l23,
        889: bo_c1,
        637: bo_m23,
        615: bo_d9,
        412: bo_n23,
        634: bo_o23,
        626: bo_p23,
        611: bo_q23,
        443: bo_h1,
        608: bo_i1,
        904: bo_r23,
        449: bo_s23,
        446: bo_t23,
        451: bo_u23,
        711: bo_v23,
        712: bo_w23,
        713: bo_x23,
        450: bo_y23,
        447: bo_z23,
        448: bo_a24,
        662: bo_b24,
        663: bo_c24,
        665: bo_d24,
        668: bo_e24,
        670: bo_f24,
        671: bo_g24,
        3: bo_h24,
        4: bo_i24,
        6: bo_j24,
        8: bo_k24,
        10: bo_l24,
        11: bo_m24,
        161: bo_n24,
        162: bo_o24,
        164: bo_p24,
        167: bo_q24,
        169: bo_r24,
        170: bo_s24,
        707: bo_t24,
        708: bo_u24,
        709: bo_v24,
        946: bo_w24,
        947: bo_x24
    },
    23: {
        443: bo_h1,
        608: bo_i1
    },
    13: {
        468: bo_y24,
        470: bo_z24,
        467: bo_a25,
        469: bo_b25,
        464: bo_c25,
        466: bo_d25,
        465: bo_e25,
        463: bo_f25,
        289: bo_g25,
        288: bo_h25,
        292: bo_i25,
        461: bo_j25,
        283: bo_k25,
        295: bo_l25,
        293: bo_m25,
        284: bo_n25,
        285: bo_o25,
        316: bo_p25,
        286: bo_q25,
        287: bo_r25,
        290: bo_s25,
        291: bo_t25,
        462: bo_u25,
        294: bo_v25
    },
    39: {
        403: bo_g1,
        443: bo_h1,
        608: bo_i1,
        698: bo_g1,
        349: bo_w25,
        950: bo_x25,
        955: bo_y25,
        951: bo_z25,
        952: bo_a26,
        953: bo_b26,
        954: bo_c26
    },
    33: {
        348: bo_d26,
        443: bo_h1,
        608: bo_i1
    },
    24: {
        443: bo_h1,
        608: bo_i1
    },
    9: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_k3,
        196: bo_a22,
        673: bo_g3,
        674: bo_e17,
        443: bo_h1,
        608: bo_i1
    },
    21: {
        443: bo_h1,
        608: bo_i1
    },
    29: {
        394: bo_e26,
        395: bo_f26,
        396: bo_g26,
        397: bo_h26,
        398: bo_i26,
        399: bo_j26,
        400: bo_k26,
        401: bo_l26,
        402: bo_m26,
        100: bo_n26,
        101: bo_o26,
        104: bo_p26,
        105: bo_q26,
        106: bo_r26,
        107: bo_s26,
        108: bo_t26,
        109: bo_u26,
        110: bo_v26,
        111: bo_w26,
        112: bo_x26,
        113: bo_y26,
        114: bo_z26,
        115: bo_a27,
        116: bo_b27,
        117: bo_c27,
        118: bo_d27,
        119: bo_e27,
        120: bo_f27,
        121: bo_g27,
        808: bo_h27,
        809: bo_i27,
        810: bo_j27,
        811: bo_k27,
        812: bo_l27,
        813: bo_m27,
        814: bo_n27,
        815: bo_o27,
        816: bo_p27,
        817: bo_q27,
        818: bo_r27,
        819: bo_s27,
        820: bo_t27,
        821: bo_u27,
        822: bo_v27,
        823: bo_w27,
        824: bo_x27,
        825: bo_y27,
        826: bo_z27,
        827: bo_a28,
        828: bo_b28,
        829: bo_c28,
        830: bo_d28,
        831: bo_e28,
        832: bo_f28,
        833: bo_g28,
        834: bo_h28,
        835: bo_i28,
        836: bo_j28,
        837: bo_k28,
        838: bo_l28,
        839: bo_m28,
        840: bo_n28,
        841: bo_o28,
        842: bo_p28,
        843: bo_q28,
        844: bo_r28,
        366: bo_s28,
        367: bo_t28,
        368: bo_u28,
        369: bo_v28,
        370: bo_w28,
        371: bo_x28,
        372: bo_y28,
        373: bo_z28,
        374: bo_a29,
        375: bo_b29,
        376: bo_c29,
        377: bo_d29,
        378: bo_e29,
        379: bo_f29,
        380: bo_g29,
        381: bo_h29,
        382: bo_i29,
        383: bo_j29,
        384: bo_k29,
        385: bo_l29,
        386: bo_m29,
        387: bo_n29,
        388: bo_o29,
        389: bo_p29,
        390: bo_q29,
        391: bo_r29,
        392: bo_s29,
        393: bo_t29,
        481: bo_u29,
        482: bo_v29,
        483: bo_w29,
        484: bo_x29,
        485: bo_y29,
        486: bo_z29,
        487: bo_a30,
        488: bo_b30,
        489: bo_c30,
        490: bo_d30,
        491: bo_e30,
        492: bo_f30,
        493: bo_g30,
        494: bo_h30,
        495: bo_i30,
        496: bo_j30,
        497: bo_k30,
        498: bo_l30,
        499: bo_m30,
        500: bo_n30,
        501: bo_o30,
        502: bo_p30,
        503: bo_q30,
        504: bo_r30,
        505: bo_s30,
        506: bo_t30,
        507: bo_u30,
        508: bo_v30,
        509: bo_w30,
        510: bo_x30,
        511: bo_y30,
        566: bo_z30,
        567: bo_a31,
        568: bo_b31,
        569: bo_c31,
        570: bo_d31,
        571: bo_e31,
        572: bo_f31,
        573: bo_g31,
        574: bo_h31,
        575: bo_i31,
        576: bo_j31,
        577: bo_k31,
        578: bo_l31,
        579: bo_m31,
        580: bo_n31,
        581: bo_o31,
        582: bo_p31,
        583: bo_q31,
        584: bo_r31,
        585: bo_s31,
        586: bo_t31,
        587: bo_u31,
        588: bo_v31,
        589: bo_w31,
        590: bo_x31,
        591: bo_y31,
        592: bo_z31,
        593: bo_a32,
        594: bo_b32,
        595: bo_c32,
        596: bo_d32,
        597: bo_e32,
        598: bo_f32,
        599: bo_g32,
        600: bo_h32,
        601: bo_i32,
        602: bo_j32,
        83: bo_k32,
        84: bo_l32,
        85: bo_m32,
        86: bo_n32,
        87: bo_o32,
        88: bo_p32,
        89: bo_q32,
        90: bo_r32,
        91: bo_s32,
        92: bo_t32,
        93: bo_u32,
        94: bo_v32,
        95: bo_w32,
        96: bo_x32,
        97: bo_y32,
        98: bo_z32,
        99: bo_a33,
        74: bo_b1,
        349: bo_c1,
        254: bo_b33,
        403: bo_g1,
        21: bo_c33,
        22: bo_d33,
        23: bo_e33,
        24: bo_f33,
        25: bo_g33,
        26: bo_h33,
        27: bo_i33,
        28: bo_j33,
        29: bo_k33,
        30: bo_l33,
        31: bo_m33,
        32: bo_n33,
        33: bo_o33,
        34: bo_p33,
        35: bo_q33,
        36: bo_r33,
        37: bo_s33,
        38: bo_t33,
        39: bo_u33,
        40: bo_v33,
        41: bo_w33,
        42: bo_x33,
        43: bo_y33,
        44: bo_z33,
        45: bo_a34,
        46: bo_b34,
        47: bo_c34,
        48: bo_d34,
        49: bo_e34,
        50: bo_f34,
        51: bo_g34,
        52: bo_h34,
        53: bo_i34,
        54: bo_j34,
        55: bo_k34,
        56: bo_l34,
        57: bo_m34,
        195: bo_n34,
        196: bo_o34,
        197: bo_p34,
        198: bo_q34,
        199: bo_r34,
        200: bo_s34,
        201: bo_t34,
        202: bo_u34,
        203: bo_v34,
        204: bo_w34,
        205: bo_x34,
        206: bo_y34,
        207: bo_z34,
        208: bo_a35,
        209: bo_b35,
        210: bo_c35,
        211: bo_d35,
        212: bo_e35,
        213: bo_f35,
        214: bo_g35,
        215: bo_h35,
        216: bo_i35,
        217: bo_j35,
        218: bo_k35,
        219: bo_l35,
        220: bo_m35,
        221: bo_n35,
        222: bo_o35,
        223: bo_p35,
        224: bo_q35,
        225: bo_r35,
        226: bo_s35,
        227: bo_t35,
        228: bo_u35,
        229: bo_v35,
        230: bo_w35,
        231: bo_x35,
        475: bo_y35,
        476: bo_z35,
        477: bo_a36,
        478: bo_b36,
        479: bo_c36,
        480: bo_d36,
        443: bo_h1,
        608: bo_i1
    },
    15: {
        443: bo_h1,
        608: bo_i1
    },
    2: {
        73: bo_b1,
        318: bo_c1,
        21: bo_e36,
        22: bo_f36,
        23: bo_g36,
        24: bo_h36,
        25: bo_i36,
        26: bo_j36,
        27: bo_k36,
        195: bo_n34,
        196: bo_o34,
        197: bo_p34,
        198: bo_q34,
        199: bo_r34,
        200: bo_s34,
        201: bo_t34,
        352: bo_l36,
        102: bo_f1,
        403: bo_g1,
        138: bo_m36,
        139: bo_n36,
        140: bo_o36,
        141: bo_p36,
        142: bo_q36,
        143: bo_r36,
        144: bo_s36,
        182: bo_t36,
        183: bo_u36,
        184: bo_v36,
        185: bo_w36,
        186: bo_x36,
        187: bo_y36,
        188: bo_z36,
        566: bo_a37,
        567: bo_b37,
        568: bo_c37,
        569: bo_d37,
        570: bo_e37,
        571: bo_f37,
        572: bo_g37,
        366: bo_s28,
        367: bo_t28,
        368: bo_u28,
        369: bo_v28,
        370: bo_w28,
        371: bo_x28,
        372: bo_y28,
        122: bo_h37,
        123: bo_i37,
        124: bo_j37,
        125: bo_k37,
        126: bo_l37,
        127: bo_m37,
        128: bo_n37,
        129: bo_o37,
        130: bo_p37,
        131: bo_q37,
        132: bo_r37,
        133: bo_s37,
        134: bo_t37,
        135: bo_u37,
        872: bo_v37,
        873: bo_w37,
        874: bo_x37,
        875: bo_y37,
        876: bo_z37,
        877: bo_a38,
        878: bo_b38,
        616: bo_c38,
        617: bo_d38,
        618: bo_e38,
        619: bo_f38,
        620: bo_g38,
        621: bo_h38,
        622: bo_i38,
        894: bo_j38,
        895: bo_k38,
        896: bo_l38,
        897: bo_m38,
        898: bo_n38,
        899: bo_o38,
        900: bo_p38,
        443: bo_h1,
        608: bo_i1,
        83: bo_q38,
        84: bo_r38,
        85: bo_s38,
        86: bo_t38,
        87: bo_u38,
        88: bo_v38,
        89: bo_w38,
        257: bo_d1,
        307: bo_e1,
        752: bo_x38,
        753: bo_x38
    },
    6: {
        553: bo_y38,
        339: bo_z38,
        547: bo_a39,
        138: bo_m9,
        139: bo_n9,
        140: bo_o9,
        141: bo_b39,
        142: bo_c39,
        182: bo_p9,
        183: bo_q9,
        184: bo_r9,
        185: bo_d39,
        186: bo_e39,
        83: bo_c10,
        84: bo_d10,
        85: bo_e10,
        86: bo_f39,
        87: bo_g39,
        807: bo_h39,
        636: bo_i39,
        334: bo_j39,
        335: bo_k39,
        336: bo_l39,
        337: bo_m39,
        906: bo_n39,
        907: bo_o39,
        908: bo_p39,
        909: bo_q39,
        300: bo_r39,
        301: bo_s39,
        302: bo_t39,
        303: bo_u39,
        304: bo_v39,
        310: bo_w39,
        311: bo_x39,
        312: bo_y39,
        313: bo_z39,
        314: bo_a40,
        554: bo_b40,
        555: bo_c40,
        556: bo_d40,
        557: bo_e40,
        558: bo_f40,
        517: bo_g40,
        518: bo_h40,
        519: bo_i40,
        520: bo_j40,
        521: bo_k40,
        561: bo_l40,
        562: bo_m40,
        563: bo_n40,
        564: bo_o40,
        565: bo_p40,
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        24: bo_q40,
        25: bo_r40,
        195: bo_h9,
        196: bo_i9,
        197: bo_j9,
        198: bo_s40,
        199: bo_t40,
        352: bo_p1,
        748: bo_q1,
        102: bo_f1,
        403: bo_g1,
        903: bo_u40,
        445: bo_v40,
        754: bo_w40,
        755: bo_x40,
        756: bo_y40,
        757: bo_z40,
        758: bo_a41,
        452: bo_b41,
        453: bo_c41,
        454: bo_d41,
        566: bo_e41,
        567: bo_f41,
        568: bo_g41,
        569: bo_h41,
        570: bo_i41,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        369: bo_j41,
        370: bo_k41,
        522: bo_l41,
        627: bo_m41,
        628: bo_n41,
        629: bo_o41,
        630: bo_p41,
        631: bo_q41,
        632: bo_r41,
        190: bo_s41,
        191: bo_t41,
        192: bo_u41,
        193: bo_v41,
        194: bo_w41,
        759: bo_x41,
        760: bo_y41,
        761: bo_z41,
        762: bo_a42,
        763: bo_b42,
        768: bo_c42,
        769: bo_d42,
        770: bo_e42,
        771: bo_f42,
        772: bo_g42,
        603: bo_h42,
        604: bo_i42,
        605: bo_j42,
        606: bo_k42,
        607: bo_l42,
        257: bo_d1,
        307: bo_e1,
        696: bo_g1,
        333: bo_m42,
        341: bo_n42,
        427: bo_o42,
        536: bo_p42,
        905: bo_q42,
        320: bo_r42,
        514: bo_s42,
        516: bo_t42,
        305: bo_u42,
        315: bo_v42,
        523: bo_w42,
        299: bo_x42,
        309: bo_y42,
        697: bo_z42,
        298: bo_a43,
        308: bo_b43,
        515: bo_c43,
        549: bo_d43,
        548: bo_e43,
        443: bo_h1,
        608: bo_i1,
        550: bo_v40,
        551: bo_v40,
        455: bo_b41,
        456: bo_b41,
        457: bo_c41,
        458: bo_c41,
        459: bo_d41,
        460: bo_d41,
        512: bo_l41,
        513: bo_l41,
        901: bo_f43,
        902: bo_f43,
        340: bo_g43,
        328: bo_h43,
        329: bo_i43,
        342: bo_j43,
        330: bo_k43,
        331: bo_l43,
        722: bo_m43,
        560: bo_n43,
        543: bo_o43,
        544: bo_p43,
        545: bo_q43,
        546: bo_r43,
        332: bo_s43,
        559: bo_t43,
        296: bo_u43,
        297: bo_v43,
        717: bo_w43,
        718: bo_x43,
        719: bo_y43,
        720: bo_z43,
        721: bo_a44,
        552: bo_b44,
        76: bo_c44,
        77: bo_d44,
        78: bo_e44,
        79: bo_f44,
        80: bo_g44,
        647: bo_h44,
        741: bo_i44,
        82: bo_j44,
        338: bo_k44
    },
    17: {
        348: bo_d26,
        443: bo_h1,
        608: bo_i1
    },
    4: {
        73: bo_b1,
        318: bo_c1,
        21: bo_j1,
        22: bo_k1,
        23: bo_l1,
        24: bo_q40,
        25: bo_r40,
        195: bo_h9,
        196: bo_i9,
        197: bo_j9,
        198: bo_s40,
        199: bo_t40,
        352: bo_p1,
        764: bo_q3,
        102: bo_f1,
        403: bo_g1,
        138: bo_m9,
        139: bo_n9,
        140: bo_o9,
        141: bo_b39,
        142: bo_c39,
        182: bo_p9,
        183: bo_q9,
        184: bo_r9,
        185: bo_d39,
        186: bo_e39,
        366: bo_r1,
        367: bo_s1,
        368: bo_t1,
        369: bo_j41,
        370: bo_k41,
        566: bo_l44,
        567: bo_m44,
        568: bo_n44,
        569: bo_o44,
        570: bo_p44,
        74: bo_q44,
        923: bo_r44,
        924: bo_s44,
        925: bo_t44,
        926: bo_u44,
        927: bo_v44,
        929: bo_t9,
        930: bo_u9,
        931: bo_v9,
        932: bo_w44,
        933: bo_x44,
        845: bo_w9,
        846: bo_x9,
        847: bo_y9,
        848: bo_y44,
        849: bo_z44,
        918: bo_z9,
        919: bo_a10,
        920: bo_b10,
        921: bo_a45,
        922: bo_b45,
        83: bo_c10,
        84: bo_d10,
        85: bo_e10,
        86: bo_f39,
        87: bo_g39,
        905: bo_q42,
        906: bo_n39,
        907: bo_o39,
        908: bo_p39,
        909: bo_q39,
        807: bo_h39,
        319: bo_c45,
        320: bo_d45,
        912: bo_y10,
        913: bo_z10,
        914: bo_a11,
        915: bo_e45,
        916: bo_f45,
        443: bo_h1,
        608: bo_i1,
        257: bo_d1,
        307: bo_e1,
        362: bo_i10,
        363: bo_j10,
        364: bo_g45,
        365: bo_h45,
        17: bo_k10,
        18: bo_l10,
        19: bo_i45,
        20: bo_j45,
        176: bo_m10,
        177: bo_n10,
        178: bo_k45,
        179: bo_l45,
        358: bo_o10,
        359: bo_p10,
        360: bo_m45,
        361: bo_n45,
        13: bo_q10,
        14: bo_r10,
        15: bo_o45,
        16: bo_p45,
        172: bo_s10,
        173: bo_t10,
        174: bo_q45,
        175: bo_r45,
        281: bo_a6,
        137: bo_a6,
        616: bo_j2,
        617: bo_k2,
        618: bo_l2,
        619: bo_s45,
        620: bo_t45,
        891: bo_x10,
        26: bo_u45,
        200: bo_v45,
        143: bo_w45,
        187: bo_x45,
        371: bo_y45,
        571: bo_z45,
        928: bo_v45,
        934: bo_v45,
        88: bo_a46,
        910: bo_b46,
        917: bo_c46,
        936: bo_d46
    },
    8: {
        74: bo_b1,
        349: bo_c1,
        656: bo_j3,
        698: bo_g1,
        256: bo_d1,
        306: bo_e1,
        195: bo_e46,
        196: bo_f46,
        197: bo_g46,
        198: bo_h46,
        673: bo_a4,
        674: bo_b4,
        675: bo_c4,
        676: bo_d4,
        103: bo_f1,
        443: bo_h1,
        608: bo_i1
    },
    27: {
        443: bo_h1,
        608: bo_i1
    },
    28: {
        403: bo_g1,
        615: bo_i46,
        74: bo_b1,
        349: bo_c1,
        256: bo_d1,
        306: bo_e1,
        103: bo_f1,
        935: bo_q3,
        612: bo_j46,
        613: bo_k46,
        443: bo_h1,
        608: bo_i1
    }
};
var outcomeConfig = {
    7: {
        426: function (match, outcome) { return "Aniq ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " bilan"); },
        535: function (match, outcome) { return "Aniq ".concat(outcome.condition, " ").concat(plural(outcome.condition, ['gol', 'gol', 'gol']), " bilan"); }
    },
    6: {
        455: function (match, outcome) { return '15x15'; },
        456: function (match, outcome) { return '15x15'; },
        457: function (match, outcome) { return '30x30'; },
        458: function (match, outcome) { return '30x30'; },
        459: function (match, outcome) { return '40x40'; },
        460: function (match, outcome) { return '40x40'; }
    }
};
var baseFactorNameConfig = {
    11: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    32: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_n1,
            2: fa_o1,
            3: fa_p1,
            4: fa_q1,
            5: fa_r1,
            6: fa_s1,
            7: fa_t1,
            8: fa_u1,
            9: fa_v1,
            10: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        122: {
            1: fa_l1,
            2: fa_m1
        },
        123: {
            1: fa_l1,
            2: fa_m1
        },
        124: {
            1: fa_l1,
            2: fa_m1
        },
        129: {
            1: fa_l1,
            2: fa_m1
        },
        130: {
            1: fa_l1,
            2: fa_m1
        },
        131: {
            1: fa_l1,
            2: fa_m1
        },
        566: {
            1: fa_x1,
            2: fa_y1
        },
        567: {
            1: fa_x1,
            2: fa_y1
        },
        568: {
            1: fa_x1,
            2: fa_y1
        },
        616: {
            1: fa_x1,
            2: fa_y1
        },
        617: {
            1: fa_x1,
            2: fa_y1
        },
        618: {
            1: fa_x1,
            2: fa_y1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        362: {
            1: fa_h1,
            2: fa_i1
        },
        363: {
            1: fa_h1,
            2: fa_i1
        },
        364: {
            1: fa_h1,
            2: fa_i1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_h1,
            2: fa_i1
        },
        359: {
            1: fa_h1,
            2: fa_i1
        },
        360: {
            1: fa_h1,
            2: fa_i1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        }
    },
    35: {
        138: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        731: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        710: {
            1: fa_q2,
            2: fa_r2,
            3: fa_s2
        },
        742: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        }
    },
    10: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    31: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        675: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        676: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        238: {
            1: fa_d1,
            2: fa_e1
        },
        682: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        239: {
            1: fa_d1,
            2: fa_e1
        },
        58: {
            1: fa_b1,
            2: fa_c1
        },
        59: {
            1: fa_b1,
            2: fa_c1
        },
        681: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        234: {
            1: fa_d1,
            2: fa_e1
        },
        235: {
            1: fa_d1,
            2: fa_e1
        },
        236: {
            1: fa_d1,
            2: fa_e1
        },
        237: {
            1: fa_d1,
            2: fa_e1
        },
        725: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        726: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        727: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        728: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        782: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        778: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        779: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        780: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        781: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        783: {
            1: fa_p1,
            2: fa_h3,
            3: fa_y3,
            4: fa_z3,
            5: fa_a4,
            6: fa_b4,
            7: fa_c4,
            8: fa_i1
        },
        773: {
            1: fa_p1,
            2: fa_h3,
            3: fa_y3,
            4: fa_z3,
            5: fa_a4,
            6: fa_b4,
            7: fa_c4,
            8: fa_i1
        },
        474: {
            1: fa_d4,
            2: fa_e4
        },
        421: {
            1: fa_l1,
            2: fa_m1
        },
        530: {
            1: fa_l1,
            2: fa_m1
        },
        422: {
            1: fa_l1,
            2: fa_m1
        },
        531: {
            1: fa_l1,
            2: fa_m1
        },
        444: {
            1: fa_f4,
            2: fa_g4
        },
        888: {
            1: fa_h4,
            2: fa_i4,
            3: fa_j4,
            4: fa_k4
        },
        280: {
            1: fa_d1,
            2: fa_e1
        },
        317: {
            1: fa_d1,
            2: fa_e1
        },
        424: {
            1: fa_l1,
            2: fa_m1
        },
        533: {
            1: fa_l1,
            2: fa_m1
        },
        423: {
            1: fa_l1,
            2: fa_m1
        },
        532: {
            1: fa_l1,
            2: fa_m1
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        788: {
            1: fa_l4,
            2: fa_m4,
            3: fa_n4,
            4: fa_o4,
            5: fa_p4,
            6: fa_q4,
            7: fa_r4,
            8: fa_s4,
            9: fa_t4,
            10: fa_u4,
            11: fa_v4,
            12: fa_w4,
            13: fa_x4,
            14: fa_y4
        },
        784: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        785: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        786: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        787: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_b5,
            5: fa_c5
        },
        774: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        775: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        776: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        777: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_f5,
            5: fa_g5
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        246: {
            1: fa_d1,
            2: fa_e1
        },
        248: {
            1: fa_d1,
            2: fa_e1
        },
        240: {
            1: fa_d1,
            2: fa_e1
        },
        232: {
            1: fa_d1,
            2: fa_e1
        },
        241: {
            1: fa_d1,
            2: fa_e1
        },
        233: {
            1: fa_d1,
            2: fa_e1
        },
        61: {
            1: fa_b1,
            2: fa_c1
        },
        62: {
            1: fa_b1,
            2: fa_c1
        },
        684: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        685: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        890: {
            1: fa_h4,
            2: fa_i4,
            3: fa_j4,
            4: fa_k4
        },
        242: {
            1: fa_d1,
            2: fa_e1
        },
        245: {
            1: fa_d1,
            2: fa_e1
        },
        243: {
            1: fa_d1,
            2: fa_e1
        },
        60: {
            1: fa_b1,
            2: fa_c1
        },
        683: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        406: {
            1: fa_x1,
            2: fa_y1
        },
        405: {
            1: fa_x1,
            2: fa_y1
        },
        404: {
            1: fa_x1,
            2: fa_y1
        },
        700: {
            1: fa_h5,
            2: fa_i5,
            3: fa_j5
        },
        408: {
            1: fa_x1,
            2: fa_y1
        },
        407: {
            1: fa_x1,
            2: fa_y1
        },
        247: {
            1: fa_d1,
            2: fa_e1
        },
        244: {
            1: fa_d1,
            2: fa_e1
        },
        638: {
            1: fa_x1,
            2: fa_y1
        },
        639: {
            1: fa_x1,
            2: fa_y1
        },
        640: {
            1: fa_x1,
            2: fa_y1
        },
        641: {
            1: fa_x1,
            2: fa_y1
        },
        646: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        642: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        643: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        644: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        },
        645: {
            1: fa_k5,
            2: fa_l5,
            3: fa_m5
        }
    },
    41: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        791: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        792: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        796: {
            1: fa_l4,
            2: fa_m4,
            3: fa_n4,
            4: fa_o4,
            5: fa_p4,
            6: fa_q4,
            7: fa_n5,
            8: fa_s4,
            9: fa_t4,
            10: fa_u4,
            11: fa_v4,
            12: fa_w4,
            13: fa_x4,
            14: fa_o5
        },
        794: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_p5,
            5: fa_c5
        },
        795: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_p5,
            5: fa_c5
        },
        789: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_q5,
            5: fa_g5
        },
        790: {
            1: fa_s4,
            2: fa_d5,
            3: fa_e5,
            4: fa_q5,
            5: fa_g5
        },
        725: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        726: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        793: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        411: {
            1: fa_x1,
            2: fa_y1
        },
        701: {
            1: fa_f4,
            2: fa_g4,
            3: fa_r5
        },
        251: {
            1: fa_d1,
            2: fa_e1
        },
        252: {
            1: fa_d1,
            2: fa_e1
        },
        409: {
            1: fa_l1,
            2: fa_m1
        },
        430: {
            1: fa_l1,
            2: fa_m1
        },
        410: {
            1: fa_l1,
            2: fa_m1
        },
        431: {
            1: fa_l1,
            2: fa_m1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        249: {
            1: fa_d1,
            2: fa_e1
        },
        250: {
            1: fa_d1,
            2: fa_e1
        },
        63: {
            1: fa_b1,
            2: fa_c1
        },
        64: {
            1: fa_b1,
            2: fa_c1
        },
        686: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        687: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        648: {
            1: fa_x1,
            2: fa_y1
        },
        649: {
            1: fa_x1,
            2: fa_y1
        }
    },
    18: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        675: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        610: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        806: {
            1: fa_s5,
            2: fa_t5,
            3: fa_u5,
            4: fa_v5,
            5: fa_w5,
            6: fa_c5
        },
        893: {
            1: fa_x5,
            2: fa_y5,
            3: fa_z5,
            4: fa_a6,
            5: fa_b6,
            6: fa_c5
        },
        707: {
            1: fa_c6,
            2: fa_d6,
            3: fa_e6
        },
        708: {
            1: fa_c6,
            2: fa_d6,
            3: fa_e6
        },
        709: {
            1: fa_c6,
            2: fa_d6,
            3: fa_e6
        },
        889: {
            1: fa_f6,
            2: fa_m2,
            3: fa_n2,
            4: fa_o2,
            5: fa_g6,
            6: fa_h6,
            7: fa_i6,
            8: fa_j6
        },
        904: {
            1: fa_k6,
            2: fa_l6,
            3: fa_m6,
            4: fa_n6,
            5: fa_o6,
            6: fa_p6,
            7: fa_q6,
            8: fa_r6,
            9: fa_s6
        },
        253: {
            1: fa_d1,
            2: fa_e1
        },
        688: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        65: {
            1: fa_b1,
            2: fa_c1
        },
        751: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_r3
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        745: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        615: {
            1: fa_x1,
            2: fa_y1
        },
        350: {
            1: fa_d1,
            2: fa_e1
        }
    },
    3: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        746: {
            1: fa_r1,
            2: fa_s1,
            3: fa_p1,
            4: fa_n1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        566: {
            1: fa_x1,
            2: fa_y1
        },
        567: {
            1: fa_x1,
            2: fa_y1
        },
        568: {
            1: fa_x1,
            2: fa_y1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        854: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        855: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        856: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        857: {
            1: fa_s3,
            2: fa_a7,
            3: fa_b7,
            4: fa_c7,
            5: fa_z6
        },
        858: {
            1: fa_s3,
            2: fa_a7,
            3: fa_b7,
            4: fa_c7,
            5: fa_z6
        },
        859: {
            1: fa_s3,
            2: fa_a7,
            3: fa_b7,
            4: fa_c7,
            5: fa_z6
        },
        797: {
            1: fa_t1,
            2: fa_d7,
            3: fa_e7,
            4: fa_i1
        },
        798: {
            1: fa_t1,
            2: fa_d7,
            3: fa_e7,
            4: fa_i1
        },
        799: {
            1: fa_t1,
            2: fa_d7,
            3: fa_e7,
            4: fa_i1
        },
        851: {
            1: fa_t1,
            2: fa_d7,
            3: fa_e7,
            4: fa_h1
        },
        852: {
            1: fa_t1,
            2: fa_d7,
            3: fa_e7,
            4: fa_h1
        },
        853: {
            1: fa_t1,
            2: fa_d7,
            3: fa_e7,
            4: fa_h1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        905: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        906: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        907: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        362: {
            1: fa_h1,
            2: fa_i1
        },
        363: {
            1: fa_h1,
            2: fa_i1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_h1,
            2: fa_i1
        },
        359: {
            1: fa_h1,
            2: fa_i1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_x1,
            2: fa_y1
        },
        617: {
            1: fa_x1,
            2: fa_y1
        },
        618: {
            1: fa_x1,
            2: fa_y1
        },
        891: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        800: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        },
        801: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        },
        802: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        }
    },
    20: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        145: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        189: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        675: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        676: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        677: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        678: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        679: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        680: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        860: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        861: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        862: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        863: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        864: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        865: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        866: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        867: {
            1: fa_p7,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_q7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    5: {
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        945: {
            1: fa_l1,
            2: fa_m1
        },
        948: {
            1: fa_r7,
            2: fa_s7,
            3: fa_t7,
            4: fa_u7,
            5: fa_v7
        },
        949: {
            1: fa_w7,
            2: fa_x7,
            3: fa_y7,
            4: fa_z7,
            5: fa_a8,
            6: fa_b8,
            7: fa_c8,
            8: fa_d8,
            9: fa_e8,
            10: fa_f8,
            11: fa_g8,
            12: fa_h8,
            13: fa_s7,
            14: fa_t7,
            15: fa_i8,
            16: fa_j8,
            17: fa_k8,
            18: fa_l8,
            19: fa_m8,
            20: fa_n8,
            21: fa_o8,
            22: fa_p8,
            23: fa_q8,
            24: fa_r8,
            25: fa_s8,
            26: fa_t8,
            27: fa_v7
        }
    },
    40: {
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    37: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    38: {
        403: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_x1,
            2: fa_y1
        },
        413: {
            1: fa_x1,
            2: fa_y1
        },
        414: {
            1: fa_x1,
            2: fa_y1
        }
    },
    42: {
        403: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_x1,
            2: fa_y1
        },
        413: {
            1: fa_x1,
            2: fa_y1
        },
        414: {
            1: fa_x1,
            2: fa_y1
        },
        566: {
            1: fa_x1,
            2: fa_y1
        },
        567: {
            1: fa_x1,
            2: fa_y1
        },
        568: {
            1: fa_x1,
            2: fa_y1
        },
        569: {
            1: fa_x1,
            2: fa_y1
        },
        570: {
            1: fa_x1,
            2: fa_y1
        },
        698: {
            1: fa_h1,
            2: fa_u8,
            3: fa_i1
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        369: {
            1: fa_h1,
            2: fa_i1
        },
        370: {
            1: fa_h1,
            2: fa_i1
        },
        940: {
            1: fa_h1,
            2: fa_i1
        },
        941: {
            1: fa_h1,
            2: fa_i1
        },
        942: {
            1: fa_h1,
            2: fa_i1
        },
        943: {
            1: fa_h1,
            2: fa_i1
        },
        944: {
            1: fa_h1,
            2: fa_i1
        }
    },
    26: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    25: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    16: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    12: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    36: {
        610: {
            1: fa_h1,
            2: fa_i1
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        615: {
            1: fa_x1,
            2: fa_y1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        21: {
            1: fa_b1,
            2: fa_v8
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    7: {
        425: {
            1: fa_l1,
            2: fa_m1
        },
        534: {
            1: fa_l1,
            2: fa_m1
        },
        540: {
            1: fa_d1,
            2: fa_e1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_l1,
            2: fa_m1
        },
        261: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        803: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        868: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        869: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        870: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        805: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        892: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_l1,
            2: fa_m1
        },
        528: {
            1: fa_l1,
            2: fa_m1
        },
        420: {
            1: fa_l1,
            2: fa_m1
        },
        529: {
            1: fa_l1,
            2: fa_m1
        },
        707: {
            1: fa_x8,
            2: fa_y8,
            3: fa_z8
        },
        708: {
            1: fa_x8,
            2: fa_y8,
            3: fa_z8
        },
        706: {
            1: fa_a9,
            2: fa_b9,
            3: fa_c9
        },
        804: {
            1: fa_d9,
            2: fa_e9,
            3: fa_f9,
            4: fa_g9
        },
        474: {
            1: fa_d4,
            2: fa_e4
        },
        614: {
            1: fa_x1,
            2: fa_y1
        },
        609: {
            1: fa_l1,
            2: fa_m1
        },
        416: {
            1: fa_l1,
            2: fa_m1
        },
        732: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        525: {
            1: fa_l1,
            2: fa_m1
        },
        850: {
            1: fa_h9,
            2: fa_i9,
            3: fa_j9,
            4: fa_k9
        },
        473: {
            1: fa_l9,
            2: fa_m9
        },
        442: {
            1: fa_l9,
            2: fa_m9
        },
        729: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        542: {
            1: fa_l1,
            2: fa_m1
        },
        730: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        471: {
            1: fa_l9,
            2: fa_m9
        },
        635: {
            1: fa_l1,
            2: fa_m1
        },
        714: {
            1: fa_n9,
            2: fa_a2,
            3: fa_o9
        },
        624: {
            1: fa_x1,
            2: fa_y1
        },
        625: {
            1: fa_x1,
            2: fa_y1
        },
        715: {
            1: fa_p9,
            2: fa_q9,
            3: fa_r9
        },
        650: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        651: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        652: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        653: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        654: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        655: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        634: {
            1: fa_l1,
            2: fa_m1
        },
        626: {
            1: fa_l1,
            2: fa_m1
        },
        733: {
            1: fa_p9,
            2: fa_q9,
            3: fa_s9
        },
        734: {
            1: fa_p9,
            2: fa_q9,
            3: fa_s9
        },
        258: {
            1: fa_d1,
            2: fa_e1
        },
        259: {
            1: fa_d1,
            2: fa_e1
        },
        66: {
            1: fa_b1,
            2: fa_c1
        },
        67: {
            1: fa_b1,
            2: fa_c1
        },
        81: {
            1: fa_b1,
            2: fa_c1
        },
        68: {
            1: fa_b1,
            2: fa_c1
        },
        689: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        690: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        699: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        691: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        723: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        633: {
            1: fa_l1,
            2: fa_m1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_k6,
            2: fa_t9,
            3: fa_m6,
            4: fa_u9,
            5: fa_v9,
            6: fa_w9,
            7: fa_q6,
            8: fa_x9,
            9: fa_s6
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_y9,
            8: fa_x2,
            9: fa_y2,
            10: fa_p1,
            11: fa_q1,
            12: fa_z2,
            13: fa_a3,
            14: fa_z9,
            15: fa_r1,
            16: fa_s1,
            17: fa_b3,
            18: fa_t1,
            19: fa_c3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_i3,
            25: fa_j3,
            26: fa_k3,
            27: fa_n3,
            28: fa_o3,
            29: fa_a10,
            30: fa_b10,
            31: fa_r3
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        255: {
            1: fa_d1,
            2: fa_e1
        },
        705: {
            1: fa_c10,
            2: fa_d10,
            3: fa_t7
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_d1,
            2: fa_e1
        },
        702: {
            1: fa_n9,
            2: fa_a2,
            3: fa_o9
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_e10,
            5: fa_i2,
            6: fa_j2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_f10,
            2: fa_g10
        },
        526: {
            1: fa_f10,
            2: fa_g10
        },
        325: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_e1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        418: {
            1: fa_l1,
            2: fa_m1
        },
        527: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_h10
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_h10
        },
        710: {
            1: fa_i10,
            2: fa_r2,
            3: fa_j10
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_l1,
            2: fa_m1
        },
        327: {
            1: fa_l1,
            2: fa_m1
        },
        724: {
            1: fa_k10,
            2: fa_l10,
            3: fa_m10
        },
        661: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        664: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        666: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        667: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        669: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        672: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        537: {
            1: fa_l1,
            2: fa_m1
        },
        541: {
            1: fa_l1,
            2: fa_m1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        437: {
            1: fa_l1,
            2: fa_m1
        },
        436: {
            1: fa_l1,
            2: fa_m1
        },
        694: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        71: {
            1: fa_b1,
            2: fa_c1
        },
        271: {
            1: fa_d1,
            2: fa_e1
        },
        268: {
            1: fa_d1,
            2: fa_e1
        },
        265: {
            1: fa_d1,
            2: fa_e1
        },
        267: {
            1: fa_d1,
            2: fa_e1
        },
        270: {
            1: fa_d1,
            2: fa_e1
        },
        272: {
            1: fa_d1,
            2: fa_e1
        },
        269: {
            1: fa_d1,
            2: fa_e1
        },
        266: {
            1: fa_d1,
            2: fa_e1
        },
        264: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        660: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        880: {
            1: fa_n10,
            2: fa_o10,
            3: fa_p10,
            4: fa_q10
        },
        879: {
            1: fa_r10,
            2: fa_s10,
            3: fa_t10,
            4: fa_u10
        },
        429: {
            1: fa_l1,
            2: fa_m1
        },
        433: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        881: {
            1: fa_v10,
            2: fa_w10,
            3: fa_x10,
            4: fa_y10,
            5: fa_z10,
            6: fa_a11
        },
        273: {
            1: fa_d1,
            2: fa_e1
        },
        274: {
            1: fa_d1,
            2: fa_e1
        },
        435: {
            1: fa_l1,
            2: fa_m1
        },
        704: {
            1: fa_b11,
            2: fa_c11,
            3: fa_d11
        },
        432: {
            1: fa_l1,
            2: fa_m1
        },
        428: {
            1: fa_l1,
            2: fa_m1
        },
        434: {
            1: fa_l1,
            2: fa_m1
        },
        439: {
            1: fa_l1,
            2: fa_m1
        },
        440: {
            1: fa_l1,
            2: fa_m1
        },
        441: {
            1: fa_l1,
            2: fa_m1
        },
        438: {
            1: fa_l1,
            2: fa_m1
        },
        623: {
            1: fa_x1,
            2: fa_y1
        },
        180: {
            1: fa_d1,
            2: fa_e1
        },
        146: {
            1: fa_d1,
            2: fa_e1
        },
        659: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        749: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_r3
        },
        69: {
            1: fa_b1,
            2: fa_c1
        },
        262: {
            1: fa_d1,
            2: fa_e1
        },
        692: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        703: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        70: {
            1: fa_b1,
            2: fa_c1
        },
        263: {
            1: fa_d1,
            2: fa_e1
        },
        693: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        72: {
            1: fa_b1,
            2: fa_c1
        },
        277: {
            1: fa_d1,
            2: fa_e1
        },
        695: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        750: {
            1: fa_x2,
            2: fa_r1,
            3: fa_u1,
            4: fa_s1,
            5: fa_v1,
            6: fa_w1,
            7: fa_j3,
            8: fa_k3,
            9: fa_l3,
            10: fa_q3,
            11: fa_e11,
            12: fa_f11,
            13: fa_u2,
            14: fa_n1,
            15: fa_o1,
            16: fa_p1,
            17: fa_q1,
            18: fa_t1,
            19: fa_z2,
            20: fa_c3,
            21: fa_g3,
            22: fa_h3,
            23: fa_g11,
            24: fa_h11
        },
        181: {
            1: fa_d1,
            2: fa_e1
        },
        147: {
            1: fa_d1,
            2: fa_e1
        },
        276: {
            1: fa_d1,
            2: fa_e1
        },
        275: {
            1: fa_d1,
            2: fa_e1
        },
        735: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        736: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        737: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        738: {
            1: fa_x1,
            2: fa_i11,
            3: fa_y1
        },
        739: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        740: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        356: {
            1: fa_d1,
            2: fa_e1
        },
        357: {
            1: fa_d1,
            2: fa_e1
        },
        354: {
            1: fa_d1,
            2: fa_e1
        },
        355: {
            1: fa_d1,
            2: fa_e1
        },
        937: {
            1: fa_j11,
            2: fa_k11,
            3: fa_l11,
            4: fa_m11,
            5: fa_n11,
            6: fa_o11,
            7: fa_p11,
            8: fa_q11,
            9: fa_r11,
            10: fa_s11
        },
        657: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        658: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        412: {
            1: fa_l1,
            2: fa_m1
        }
    },
    14: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    34: {
        425: {
            1: fa_l1,
            2: fa_m1
        },
        534: {
            1: fa_l1,
            2: fa_m1
        },
        540: {
            1: fa_d1,
            2: fa_e1
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        345: {
            1: fa_d1,
            2: fa_e1
        },
        260: {
            1: fa_l1,
            2: fa_m1
        },
        261: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        803: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        868: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        869: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        870: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_w8
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        419: {
            1: fa_l1,
            2: fa_m1
        },
        528: {
            1: fa_l1,
            2: fa_m1
        },
        420: {
            1: fa_l1,
            2: fa_m1
        },
        529: {
            1: fa_l1,
            2: fa_m1
        },
        707: {
            1: fa_x8,
            2: fa_y8,
            3: fa_z8
        },
        708: {
            1: fa_x8,
            2: fa_y8,
            3: fa_z8
        },
        706: {
            1: fa_a9,
            2: fa_b9,
            3: fa_c9
        },
        538: {
            1: fa_d1,
            2: fa_e1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        322: {
            1: fa_d1,
            2: fa_e1
        },
        904: {
            1: fa_k6,
            2: fa_t9,
            3: fa_m6,
            4: fa_u9,
            5: fa_v9,
            6: fa_w9,
            7: fa_q6,
            8: fa_x9,
            9: fa_s6
        },
        1: {
            1: fa_b1,
            2: fa_c1
        },
        136: {
            1: fa_d1,
            2: fa_e1
        },
        747: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_y9,
            8: fa_x2,
            9: fa_y2,
            10: fa_p1,
            11: fa_q1,
            12: fa_z2,
            13: fa_a3,
            14: fa_z9,
            15: fa_r1,
            16: fa_s1,
            17: fa_b3,
            18: fa_t1,
            19: fa_c3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_i3,
            25: fa_j3,
            26: fa_k3,
            27: fa_n3,
            28: fa_o3,
            29: fa_a10,
            30: fa_b10,
            31: fa_r3
        },
        871: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        255: {
            1: fa_d1,
            2: fa_e1
        },
        705: {
            1: fa_c10,
            2: fa_d10,
            3: fa_t7
        },
        323: {
            1: fa_d1,
            2: fa_e1
        },
        324: {
            1: fa_d1,
            2: fa_e1
        },
        702: {
            1: fa_n9,
            2: fa_a2,
            3: fa_o9
        },
        278: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        282: {
            1: fa_d1,
            2: fa_e1
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_e10,
            5: fa_i2,
            6: fa_j2
        },
        353: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        2: {
            1: fa_b1,
            2: fa_c1
        },
        5: {
            1: fa_b1,
            2: fa_c1
        },
        7: {
            1: fa_b1,
            2: fa_c1
        },
        939: {
            1: fa_b1,
            2: fa_c1
        },
        9: {
            1: fa_b1,
            2: fa_c1
        },
        12: {
            1: fa_b1,
            2: fa_c1
        },
        417: {
            1: fa_f10,
            2: fa_g10
        },
        526: {
            1: fa_f10,
            2: fa_g10
        },
        325: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        160: {
            1: fa_d1,
            2: fa_e1
        },
        163: {
            1: fa_d1,
            2: fa_e1
        },
        165: {
            1: fa_d1,
            2: fa_e1
        },
        166: {
            1: fa_d1,
            2: fa_e1
        },
        168: {
            1: fa_d1,
            2: fa_e1
        },
        171: {
            1: fa_d1,
            2: fa_e1
        },
        148: {
            1: fa_d1,
            2: fa_e1
        },
        149: {
            1: fa_d1,
            2: fa_e1
        },
        150: {
            1: fa_d1,
            2: fa_e1
        },
        151: {
            1: fa_d1,
            2: fa_e1
        },
        152: {
            1: fa_d1,
            2: fa_e1
        },
        153: {
            1: fa_d1,
            2: fa_e1
        },
        154: {
            1: fa_d1,
            2: fa_e1
        },
        155: {
            1: fa_d1,
            2: fa_e1
        },
        156: {
            1: fa_d1,
            2: fa_e1
        },
        157: {
            1: fa_d1,
            2: fa_e1
        },
        158: {
            1: fa_d1,
            2: fa_e1
        },
        159: {
            1: fa_d1,
            2: fa_e1
        },
        731: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        418: {
            1: fa_l1,
            2: fa_m1
        },
        527: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_h10
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_h10
        },
        710: {
            1: fa_i10,
            2: fa_r2,
            3: fa_j10
        },
        321: {
            1: fa_d1,
            2: fa_e1
        },
        326: {
            1: fa_l1,
            2: fa_m1
        },
        327: {
            1: fa_l1,
            2: fa_m1
        },
        724: {
            1: fa_k10,
            2: fa_l10,
            3: fa_m10
        },
        661: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        664: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        666: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        667: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        669: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        672: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        537: {
            1: fa_l1,
            2: fa_m1
        },
        541: {
            1: fa_l1,
            2: fa_m1
        },
        539: {
            1: fa_d1,
            2: fa_e1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    19: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        615: {
            1: fa_x1,
            2: fa_y1
        },
        886: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        887: {
            1: fa_s3,
            2: fa_t3,
            3: fa_u3,
            4: fa_v3,
            5: fa_w3,
            6: fa_x3
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        884: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_t11,
            5: fa_c5
        },
        885: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_t11,
            5: fa_c5
        },
        882: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_t11,
            5: fa_c5
        },
        883: {
            1: fa_l4,
            2: fa_z4,
            3: fa_a5,
            4: fa_t11,
            5: fa_c5
        },
        723: {
            1: fa_x1,
            2: fa_a2,
            3: fa_y1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    30: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        21: {
            1: fa_b1,
            2: fa_v8
        },
        22: {
            1: fa_b1,
            2: fa_v8
        },
        23: {
            1: fa_b1,
            2: fa_v8
        },
        279: {
            1: fa_d1,
            2: fa_e1
        },
        610: {
            1: fa_h1,
            2: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        675: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        350: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        415: {
            1: fa_l1,
            2: fa_m1
        },
        524: {
            1: fa_l1,
            2: fa_m1
        },
        743: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_h10
        },
        744: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_h10
        },
        745: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_x2,
            6: fa_y2,
            7: fa_p1,
            8: fa_q1,
            9: fa_r1,
            10: fa_s1,
            11: fa_b3,
            12: fa_t1,
            13: fa_u1,
            14: fa_v1,
            15: fa_w1,
            16: fa_f3,
            17: fa_h10
        },
        710: {
            1: fa_u11,
            2: fa_v11,
            3: fa_w11
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        426: {
            1: fa_l1,
            2: fa_m1
        },
        535: {
            1: fa_l1,
            2: fa_m1
        },
        706: {
            1: fa_x11,
            2: fa_y11,
            3: fa_z11
        },
        343: {
            1: fa_d1,
            2: fa_e1
        },
        346: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        344: {
            1: fa_d1,
            2: fa_e1
        },
        347: {
            1: fa_d1,
            2: fa_e1
        },
        765: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        766: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        767: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_p2
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        751: {
            1: fa_t2,
            2: fa_u2,
            3: fa_n1,
            4: fa_o1,
            5: fa_v2,
            6: fa_w2,
            7: fa_x2,
            8: fa_y2,
            9: fa_p1,
            10: fa_q1,
            11: fa_z2,
            12: fa_a3,
            13: fa_r1,
            14: fa_s1,
            15: fa_b3,
            16: fa_t1,
            17: fa_c3,
            18: fa_d3,
            19: fa_e3,
            20: fa_u1,
            21: fa_v1,
            22: fa_w1,
            23: fa_f3,
            24: fa_g3,
            25: fa_h3,
            26: fa_i3,
            27: fa_j3,
            28: fa_k3,
            29: fa_l3,
            30: fa_m3,
            31: fa_n3,
            32: fa_o3,
            33: fa_p3,
            34: fa_q3,
            35: fa_h10
        },
        911: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2,
            5: fa_i2,
            6: fa_j2
        },
        889: {
            1: fa_f6,
            2: fa_m2,
            3: fa_n2,
            4: fa_o2,
            5: fa_g6,
            6: fa_h6,
            7: fa_i6,
            8: fa_j6
        },
        637: {
            1: fa_l1,
            2: fa_m1
        },
        615: {
            1: fa_x1,
            2: fa_y1
        },
        412: {
            1: fa_l1,
            2: fa_m1
        },
        634: {
            1: fa_l1,
            2: fa_m1
        },
        626: {
            1: fa_l1,
            2: fa_m1
        },
        611: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        904: {
            1: fa_k6,
            2: fa_t9,
            3: fa_m6,
            4: fa_u9,
            5: fa_v9,
            6: fa_w9,
            7: fa_q6,
            8: fa_x9,
            9: fa_s6
        },
        449: {
            1: fa_l1,
            2: fa_m1
        },
        446: {
            1: fa_l1,
            2: fa_m1
        },
        451: {
            1: fa_l1,
            2: fa_m1
        },
        711: {
            1: fa_a12,
            2: fa_b12,
            3: fa_c12
        },
        712: {
            1: fa_d12,
            2: fa_e12,
            3: fa_f12
        },
        713: {
            1: fa_g12,
            2: fa_h12,
            3: fa_i12
        },
        450: {
            1: fa_l1,
            2: fa_m1
        },
        447: {
            1: fa_l1,
            2: fa_m1
        },
        448: {
            1: fa_l1,
            2: fa_m1
        },
        662: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        663: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        665: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        668: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        670: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        671: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        3: {
            1: fa_b1,
            2: fa_c1
        },
        4: {
            1: fa_b1,
            2: fa_c1
        },
        6: {
            1: fa_b1,
            2: fa_c1
        },
        8: {
            1: fa_b1,
            2: fa_c1
        },
        10: {
            1: fa_b1,
            2: fa_c1
        },
        11: {
            1: fa_b1,
            2: fa_c1
        },
        161: {
            1: fa_d1,
            2: fa_e1
        },
        162: {
            1: fa_d1,
            2: fa_e1
        },
        164: {
            1: fa_d1,
            2: fa_e1
        },
        167: {
            1: fa_d1,
            2: fa_e1
        },
        169: {
            1: fa_d1,
            2: fa_e1
        },
        170: {
            1: fa_d1,
            2: fa_e1
        },
        707: {
            1: fa_c6,
            2: fa_d6,
            3: fa_j12
        },
        708: {
            1: fa_c6,
            2: fa_d6,
            3: fa_j12
        },
        709: {
            1: fa_c6,
            2: fa_d6,
            3: fa_j12
        },
        946: {
            1: fa_l1,
            2: fa_m1
        },
        947: {
            1: fa_l1,
            2: fa_m1
        }
    },
    23: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    13: {
        468: {
            1: fa_f1,
            2: fa_g1
        },
        470: {
            1: fa_f1,
            2: fa_g1
        },
        467: {
            1: fa_f1,
            2: fa_g1
        },
        469: {
            1: fa_f1,
            2: fa_g1
        },
        464: {
            1: fa_k12,
            2: fa_l12
        },
        466: {
            1: fa_l1,
            2: fa_m1
        },
        465: {
            1: fa_l1,
            2: fa_m1
        },
        463: {
            1: fa_l1,
            2: fa_m1
        },
        289: {
            1: fa_d1,
            2: fa_e1
        },
        288: {
            1: fa_d1,
            2: fa_e1
        },
        292: {
            1: fa_d1,
            2: fa_e1
        },
        461: {
            1: fa_l1,
            2: fa_m1
        },
        283: {
            1: fa_d1,
            2: fa_e1
        },
        295: {
            1: fa_d1,
            2: fa_e1
        },
        293: {
            1: fa_d1,
            2: fa_e1
        },
        284: {
            1: fa_d1,
            2: fa_e1
        },
        285: {
            1: fa_d1,
            2: fa_e1
        },
        316: {
            1: fa_d1,
            2: fa_e1
        },
        286: {
            1: fa_d1,
            2: fa_e1
        },
        287: {
            1: fa_d1,
            2: fa_e1
        },
        290: {
            1: fa_d1,
            2: fa_e1
        },
        291: {
            1: fa_d1,
            2: fa_e1
        },
        462: {
            1: fa_l1,
            2: fa_m1
        },
        294: {
            1: fa_d1,
            2: fa_e1
        }
    },
    39: {
        403: {
            1: fa_h1,
            2: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        698: {
            1: fa_m12,
            2: fa_z1,
            3: fa_n12
        },
        349: {
            1: fa_o12,
            2: fa_p12
        },
        950: {
            1: fa_q12,
            2: fa_r12,
            3: fa_s12,
            4: fa_t12,
            5: fa_u12,
            6: fa_v12,
            7: fa_w12,
            8: fa_x12,
            9: fa_y12,
            10: fa_z12,
            11: fa_a13,
            12: fa_b13,
            13: fa_c13
        },
        955: {
            1: fa_d13,
            2: fa_e13
        },
        951: {
            1: fa_f13,
            2: fa_g13
        },
        952: {
            1: fa_f13,
            2: fa_g13
        },
        953: {
            1: fa_f13,
            2: fa_g13
        },
        954: {
            1: fa_f13,
            2: fa_g13
        }
    },
    33: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    24: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    9: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    21: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    29: {
        394: {
            1: fa_h1,
            2: fa_i1
        },
        395: {
            1: fa_h1,
            2: fa_i1
        },
        396: {
            1: fa_h1,
            2: fa_i1
        },
        397: {
            1: fa_h1,
            2: fa_i1
        },
        398: {
            1: fa_h1,
            2: fa_i1
        },
        399: {
            1: fa_h1,
            2: fa_i1
        },
        400: {
            1: fa_h1,
            2: fa_i1
        },
        401: {
            1: fa_h1,
            2: fa_i1
        },
        402: {
            1: fa_h1,
            2: fa_i1
        },
        100: {
            1: fa_f1,
            2: fa_g1
        },
        101: {
            1: fa_f1,
            2: fa_g1
        },
        104: {
            1: fa_f1,
            2: fa_g1
        },
        105: {
            1: fa_f1,
            2: fa_g1
        },
        106: {
            1: fa_f1,
            2: fa_g1
        },
        107: {
            1: fa_f1,
            2: fa_g1
        },
        108: {
            1: fa_f1,
            2: fa_g1
        },
        109: {
            1: fa_f1,
            2: fa_g1
        },
        110: {
            1: fa_f1,
            2: fa_g1
        },
        111: {
            1: fa_f1,
            2: fa_g1
        },
        112: {
            1: fa_f1,
            2: fa_g1
        },
        113: {
            1: fa_f1,
            2: fa_g1
        },
        114: {
            1: fa_f1,
            2: fa_g1
        },
        115: {
            1: fa_f1,
            2: fa_g1
        },
        116: {
            1: fa_f1,
            2: fa_g1
        },
        117: {
            1: fa_f1,
            2: fa_g1
        },
        118: {
            1: fa_f1,
            2: fa_g1
        },
        119: {
            1: fa_f1,
            2: fa_g1
        },
        120: {
            1: fa_f1,
            2: fa_g1
        },
        121: {
            1: fa_f1,
            2: fa_g1
        },
        808: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        809: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        810: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        811: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        812: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        813: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        814: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        815: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        816: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        817: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        818: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        819: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        820: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        821: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        822: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        823: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        824: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        825: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        826: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        827: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        828: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        829: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        830: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        831: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        832: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        833: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        834: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        835: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        836: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        837: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        838: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        839: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        840: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        841: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        842: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        843: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        844: {
            1: fa_h13,
            2: fa_i13,
            3: fa_j13,
            4: fa_k13,
            5: fa_l13,
            6: fa_m13
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        369: {
            1: fa_h1,
            2: fa_i1
        },
        370: {
            1: fa_h1,
            2: fa_i1
        },
        371: {
            1: fa_h1,
            2: fa_i1
        },
        372: {
            1: fa_h1,
            2: fa_i1
        },
        373: {
            1: fa_h1,
            2: fa_i1
        },
        374: {
            1: fa_h1,
            2: fa_i1
        },
        375: {
            1: fa_h1,
            2: fa_i1
        },
        376: {
            1: fa_h1,
            2: fa_i1
        },
        377: {
            1: fa_h1,
            2: fa_i1
        },
        378: {
            1: fa_h1,
            2: fa_i1
        },
        379: {
            1: fa_h1,
            2: fa_i1
        },
        380: {
            1: fa_h1,
            2: fa_i1
        },
        381: {
            1: fa_h1,
            2: fa_i1
        },
        382: {
            1: fa_h1,
            2: fa_i1
        },
        383: {
            1: fa_h1,
            2: fa_i1
        },
        384: {
            1: fa_h1,
            2: fa_i1
        },
        385: {
            1: fa_h1,
            2: fa_i1
        },
        386: {
            1: fa_h1,
            2: fa_i1
        },
        387: {
            1: fa_h1,
            2: fa_i1
        },
        388: {
            1: fa_h1,
            2: fa_i1
        },
        389: {
            1: fa_h1,
            2: fa_i1
        },
        390: {
            1: fa_h1,
            2: fa_i1
        },
        391: {
            1: fa_h1,
            2: fa_i1
        },
        392: {
            1: fa_h1,
            2: fa_i1
        },
        393: {
            1: fa_h1,
            2: fa_i1
        },
        481: {
            1: fa_x1,
            2: fa_y1
        },
        482: {
            1: fa_x1,
            2: fa_y1
        },
        483: {
            1: fa_x1,
            2: fa_y1
        },
        484: {
            1: fa_x1,
            2: fa_y1
        },
        485: {
            1: fa_x1,
            2: fa_y1
        },
        486: {
            1: fa_x1,
            2: fa_y1
        },
        487: {
            1: fa_x1,
            2: fa_y1
        },
        488: {
            1: fa_x1,
            2: fa_y1
        },
        489: {
            1: fa_x1,
            2: fa_y1
        },
        490: {
            1: fa_x1,
            2: fa_y1
        },
        491: {
            1: fa_x1,
            2: fa_y1
        },
        492: {
            1: fa_x1,
            2: fa_y1
        },
        493: {
            1: fa_x1,
            2: fa_y1
        },
        494: {
            1: fa_x1,
            2: fa_y1
        },
        495: {
            1: fa_x1,
            2: fa_y1
        },
        496: {
            1: fa_x1,
            2: fa_y1
        },
        497: {
            1: fa_x1,
            2: fa_y1
        },
        498: {
            1: fa_x1,
            2: fa_y1
        },
        499: {
            1: fa_x1,
            2: fa_y1
        },
        500: {
            1: fa_x1,
            2: fa_y1
        },
        501: {
            1: fa_x1,
            2: fa_y1
        },
        502: {
            1: fa_x1,
            2: fa_y1
        },
        503: {
            1: fa_x1,
            2: fa_y1
        },
        504: {
            1: fa_x1,
            2: fa_y1
        },
        505: {
            1: fa_x1,
            2: fa_y1
        },
        506: {
            1: fa_x1,
            2: fa_y1
        },
        507: {
            1: fa_x1,
            2: fa_y1
        },
        508: {
            1: fa_x1,
            2: fa_y1
        },
        509: {
            1: fa_x1,
            2: fa_y1
        },
        510: {
            1: fa_x1,
            2: fa_y1
        },
        511: {
            1: fa_x1,
            2: fa_y1
        },
        566: {
            1: fa_x1,
            2: fa_y1
        },
        567: {
            1: fa_x1,
            2: fa_y1
        },
        568: {
            1: fa_x1,
            2: fa_y1
        },
        569: {
            1: fa_x1,
            2: fa_y1
        },
        570: {
            1: fa_x1,
            2: fa_y1
        },
        571: {
            1: fa_x1,
            2: fa_y1
        },
        572: {
            1: fa_x1,
            2: fa_y1
        },
        573: {
            1: fa_x1,
            2: fa_y1
        },
        574: {
            1: fa_x1,
            2: fa_y1
        },
        575: {
            1: fa_x1,
            2: fa_y1
        },
        576: {
            1: fa_x1,
            2: fa_y1
        },
        577: {
            1: fa_x1,
            2: fa_y1
        },
        578: {
            1: fa_x1,
            2: fa_y1
        },
        579: {
            1: fa_x1,
            2: fa_y1
        },
        580: {
            1: fa_x1,
            2: fa_y1
        },
        581: {
            1: fa_x1,
            2: fa_y1
        },
        582: {
            1: fa_x1,
            2: fa_y1
        },
        583: {
            1: fa_x1,
            2: fa_y1
        },
        584: {
            1: fa_x1,
            2: fa_y1
        },
        585: {
            1: fa_x1,
            2: fa_y1
        },
        586: {
            1: fa_x1,
            2: fa_y1
        },
        587: {
            1: fa_x1,
            2: fa_y1
        },
        588: {
            1: fa_x1,
            2: fa_y1
        },
        589: {
            1: fa_x1,
            2: fa_y1
        },
        590: {
            1: fa_x1,
            2: fa_y1
        },
        591: {
            1: fa_x1,
            2: fa_y1
        },
        592: {
            1: fa_x1,
            2: fa_y1
        },
        593: {
            1: fa_x1,
            2: fa_y1
        },
        594: {
            1: fa_x1,
            2: fa_y1
        },
        595: {
            1: fa_x1,
            2: fa_y1
        },
        596: {
            1: fa_x1,
            2: fa_y1
        },
        597: {
            1: fa_x1,
            2: fa_y1
        },
        598: {
            1: fa_x1,
            2: fa_y1
        },
        599: {
            1: fa_x1,
            2: fa_y1
        },
        600: {
            1: fa_x1,
            2: fa_y1
        },
        601: {
            1: fa_x1,
            2: fa_y1
        },
        602: {
            1: fa_x1,
            2: fa_y1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        89: {
            1: fa_f1,
            2: fa_g1
        },
        90: {
            1: fa_f1,
            2: fa_g1
        },
        91: {
            1: fa_f1,
            2: fa_g1
        },
        92: {
            1: fa_f1,
            2: fa_g1
        },
        93: {
            1: fa_f1,
            2: fa_g1
        },
        94: {
            1: fa_f1,
            2: fa_g1
        },
        95: {
            1: fa_f1,
            2: fa_g1
        },
        96: {
            1: fa_f1,
            2: fa_g1
        },
        97: {
            1: fa_f1,
            2: fa_g1
        },
        98: {
            1: fa_f1,
            2: fa_g1
        },
        99: {
            1: fa_f1,
            2: fa_g1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        254: {
            1: fa_d1,
            2: fa_e1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        28: {
            1: fa_b1,
            2: fa_c1
        },
        29: {
            1: fa_b1,
            2: fa_c1
        },
        30: {
            1: fa_b1,
            2: fa_c1
        },
        31: {
            1: fa_b1,
            2: fa_c1
        },
        32: {
            1: fa_b1,
            2: fa_c1
        },
        33: {
            1: fa_b1,
            2: fa_c1
        },
        34: {
            1: fa_b1,
            2: fa_c1
        },
        35: {
            1: fa_b1,
            2: fa_c1
        },
        36: {
            1: fa_b1,
            2: fa_c1
        },
        37: {
            1: fa_b1,
            2: fa_c1
        },
        38: {
            1: fa_b1,
            2: fa_c1
        },
        39: {
            1: fa_b1,
            2: fa_c1
        },
        40: {
            1: fa_b1,
            2: fa_c1
        },
        41: {
            1: fa_b1,
            2: fa_c1
        },
        42: {
            1: fa_b1,
            2: fa_c1
        },
        43: {
            1: fa_b1,
            2: fa_c1
        },
        44: {
            1: fa_b1,
            2: fa_c1
        },
        45: {
            1: fa_b1,
            2: fa_c1
        },
        46: {
            1: fa_b1,
            2: fa_c1
        },
        47: {
            1: fa_b1,
            2: fa_c1
        },
        48: {
            1: fa_b1,
            2: fa_c1
        },
        49: {
            1: fa_b1,
            2: fa_c1
        },
        50: {
            1: fa_b1,
            2: fa_c1
        },
        51: {
            1: fa_b1,
            2: fa_c1
        },
        52: {
            1: fa_b1,
            2: fa_c1
        },
        53: {
            1: fa_b1,
            2: fa_c1
        },
        54: {
            1: fa_b1,
            2: fa_c1
        },
        55: {
            1: fa_b1,
            2: fa_c1
        },
        56: {
            1: fa_b1,
            2: fa_c1
        },
        57: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        202: {
            1: fa_d1,
            2: fa_e1
        },
        203: {
            1: fa_d1,
            2: fa_e1
        },
        204: {
            1: fa_d1,
            2: fa_e1
        },
        205: {
            1: fa_d1,
            2: fa_e1
        },
        206: {
            1: fa_d1,
            2: fa_e1
        },
        207: {
            1: fa_d1,
            2: fa_e1
        },
        208: {
            1: fa_d1,
            2: fa_e1
        },
        209: {
            1: fa_d1,
            2: fa_e1
        },
        210: {
            1: fa_d1,
            2: fa_e1
        },
        211: {
            1: fa_d1,
            2: fa_e1
        },
        212: {
            1: fa_d1,
            2: fa_e1
        },
        213: {
            1: fa_d1,
            2: fa_e1
        },
        214: {
            1: fa_d1,
            2: fa_e1
        },
        215: {
            1: fa_d1,
            2: fa_e1
        },
        216: {
            1: fa_d1,
            2: fa_e1
        },
        217: {
            1: fa_d1,
            2: fa_e1
        },
        218: {
            1: fa_d1,
            2: fa_e1
        },
        219: {
            1: fa_d1,
            2: fa_e1
        },
        220: {
            1: fa_d1,
            2: fa_e1
        },
        221: {
            1: fa_d1,
            2: fa_e1
        },
        222: {
            1: fa_d1,
            2: fa_e1
        },
        223: {
            1: fa_d1,
            2: fa_e1
        },
        224: {
            1: fa_d1,
            2: fa_e1
        },
        225: {
            1: fa_d1,
            2: fa_e1
        },
        226: {
            1: fa_d1,
            2: fa_e1
        },
        227: {
            1: fa_d1,
            2: fa_e1
        },
        228: {
            1: fa_d1,
            2: fa_e1
        },
        229: {
            1: fa_d1,
            2: fa_e1
        },
        230: {
            1: fa_d1,
            2: fa_e1
        },
        231: {
            1: fa_d1,
            2: fa_e1
        },
        475: {
            1: fa_x1,
            2: fa_y1
        },
        476: {
            1: fa_x1,
            2: fa_y1
        },
        477: {
            1: fa_x1,
            2: fa_y1
        },
        478: {
            1: fa_x1,
            2: fa_y1
        },
        479: {
            1: fa_x1,
            2: fa_y1
        },
        480: {
            1: fa_x1,
            2: fa_y1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    15: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    2: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        26: {
            1: fa_b1,
            2: fa_c1
        },
        27: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        201: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        144: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        188: {
            1: fa_d1,
            2: fa_e1
        },
        566: {
            1: fa_x1,
            2: fa_y1
        },
        567: {
            1: fa_x1,
            2: fa_y1
        },
        568: {
            1: fa_x1,
            2: fa_y1
        },
        569: {
            1: fa_x1,
            2: fa_y1
        },
        570: {
            1: fa_x1,
            2: fa_y1
        },
        571: {
            1: fa_x1,
            2: fa_y1
        },
        572: {
            1: fa_x1,
            2: fa_y1
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        369: {
            1: fa_h1,
            2: fa_i1
        },
        370: {
            1: fa_h1,
            2: fa_i1
        },
        371: {
            1: fa_h1,
            2: fa_i1
        },
        372: {
            1: fa_h1,
            2: fa_i1
        },
        122: {
            1: fa_l1,
            2: fa_m1
        },
        123: {
            1: fa_l1,
            2: fa_m1
        },
        124: {
            1: fa_l1,
            2: fa_m1
        },
        125: {
            1: fa_l1,
            2: fa_m1
        },
        126: {
            1: fa_l1,
            2: fa_m1
        },
        127: {
            1: fa_l1,
            2: fa_m1
        },
        128: {
            1: fa_l1,
            2: fa_m1
        },
        129: {
            1: fa_l1,
            2: fa_m1
        },
        130: {
            1: fa_l1,
            2: fa_m1
        },
        131: {
            1: fa_l1,
            2: fa_m1
        },
        132: {
            1: fa_l1,
            2: fa_m1
        },
        133: {
            1: fa_l1,
            2: fa_m1
        },
        134: {
            1: fa_l1,
            2: fa_m1
        },
        135: {
            1: fa_l1,
            2: fa_m1
        },
        872: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_n13
        },
        873: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_n13
        },
        874: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_n13
        },
        875: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_n13
        },
        876: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_n13
        },
        877: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_n13
        },
        878: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_n13
        },
        616: {
            1: fa_x1,
            2: fa_y1
        },
        617: {
            1: fa_x1,
            2: fa_y1
        },
        618: {
            1: fa_x1,
            2: fa_y1
        },
        619: {
            1: fa_x1,
            2: fa_y1
        },
        620: {
            1: fa_x1,
            2: fa_y1
        },
        621: {
            1: fa_x1,
            2: fa_y1
        },
        622: {
            1: fa_x1,
            2: fa_y1
        },
        894: {
            1: fa_o13,
            2: fa_p13,
            3: fa_q13,
            4: fa_r13
        },
        895: {
            1: fa_o13,
            2: fa_p13,
            3: fa_q13,
            4: fa_r13
        },
        896: {
            1: fa_o13,
            2: fa_p13,
            3: fa_q13,
            4: fa_r13
        },
        897: {
            1: fa_o13,
            2: fa_p13,
            3: fa_q13,
            4: fa_r13
        },
        898: {
            1: fa_o13,
            2: fa_p13,
            3: fa_q13,
            4: fa_r13
        },
        899: {
            1: fa_o13,
            2: fa_p13,
            3: fa_q13,
            4: fa_r13
        },
        900: {
            1: fa_o13,
            2: fa_p13,
            3: fa_q13,
            4: fa_r13
        },
        443: {
            1: fa_j1,
            2: fa_s13
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        89: {
            1: fa_f1,
            2: fa_g1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        752: {
            1: fa_u1,
            2: fa_v1,
            3: fa_w1,
            4: fa_t1,
            5: fa_q1,
            6: fa_o1
        },
        753: {
            1: fa_i3,
            2: fa_j3,
            3: fa_k3,
            4: fa_l3,
            5: fa_g3,
            6: fa_c3,
            7: fa_z2,
            8: fa_v2
        }
    },
    6: {
        553: {
            1: fa_l1,
            2: fa_m1
        },
        339: {
            1: fa_d1,
            2: fa_e1
        },
        547: {
            1: fa_l1,
            2: fa_m1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        807: {
            1: fa_k6,
            2: fa_m6,
            3: fa_q6,
            4: fa_s6
        },
        636: {
            1: fa_l1,
            2: fa_m1
        },
        334: {
            1: fa_d1,
            2: fa_e1
        },
        335: {
            1: fa_d1,
            2: fa_e1
        },
        336: {
            1: fa_d1,
            2: fa_e1
        },
        337: {
            1: fa_d1,
            2: fa_e1
        },
        906: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        907: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        908: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        909: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        300: {
            1: fa_d1,
            2: fa_e1
        },
        301: {
            1: fa_d1,
            2: fa_e1
        },
        302: {
            1: fa_d1,
            2: fa_e1
        },
        303: {
            1: fa_d1,
            2: fa_e1
        },
        304: {
            1: fa_d1,
            2: fa_e1
        },
        310: {
            1: fa_d1,
            2: fa_e1
        },
        311: {
            1: fa_d1,
            2: fa_e1
        },
        312: {
            1: fa_d1,
            2: fa_e1
        },
        313: {
            1: fa_d1,
            2: fa_e1
        },
        314: {
            1: fa_d1,
            2: fa_e1
        },
        554: {
            1: fa_l1,
            2: fa_m1
        },
        555: {
            1: fa_l1,
            2: fa_m1
        },
        556: {
            1: fa_l1,
            2: fa_m1
        },
        557: {
            1: fa_l1,
            2: fa_m1
        },
        558: {
            1: fa_l1,
            2: fa_m1
        },
        517: {
            1: fa_l1,
            2: fa_m1
        },
        518: {
            1: fa_l1,
            2: fa_m1
        },
        519: {
            1: fa_l1,
            2: fa_m1
        },
        520: {
            1: fa_l1,
            2: fa_m1
        },
        521: {
            1: fa_l1,
            2: fa_m1
        },
        561: {
            1: fa_l1,
            2: fa_m1
        },
        562: {
            1: fa_l1,
            2: fa_m1
        },
        563: {
            1: fa_l1,
            2: fa_m1
        },
        564: {
            1: fa_l1,
            2: fa_m1
        },
        565: {
            1: fa_l1,
            2: fa_m1
        },
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        748: {
            1: fa_n1,
            2: fa_o1,
            3: fa_p1,
            4: fa_q1,
            5: fa_r1,
            6: fa_s1,
            7: fa_t1,
            8: fa_u1,
            9: fa_v1,
            10: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        903: {
            1: fa_t13,
            2: fa_u13,
            3: fa_v13,
            4: fa_w13,
            5: fa_x13,
            6: fa_y13,
            7: fa_z13,
            8: fa_a14
        },
        445: {
            1: fa_x1,
            2: fa_y1
        },
        754: {
            1: fa_y9,
            2: fa_z9,
            3: fa_e3,
            4: fa_b14,
            5: fa_d7,
            6: fa_c14,
            7: fa_a10,
            8: fa_b10,
            9: fa_d14,
            10: fa_e14,
            11: fa_f14,
            12: fa_g14,
            13: fa_h14,
            14: fa_i14
        },
        755: {
            1: fa_y9,
            2: fa_z9,
            3: fa_e3,
            4: fa_b14,
            5: fa_d7,
            6: fa_c14,
            7: fa_a10,
            8: fa_b10,
            9: fa_d14,
            10: fa_e14,
            11: fa_f14,
            12: fa_g14,
            13: fa_h14,
            14: fa_i14
        },
        756: {
            1: fa_y9,
            2: fa_z9,
            3: fa_e3,
            4: fa_b14,
            5: fa_d7,
            6: fa_c14,
            7: fa_a10,
            8: fa_b10,
            9: fa_d14,
            10: fa_e14,
            11: fa_f14,
            12: fa_g14,
            13: fa_h14,
            14: fa_i14
        },
        757: {
            1: fa_y9,
            2: fa_z9,
            3: fa_e3,
            4: fa_b14,
            5: fa_d7,
            6: fa_c14,
            7: fa_a10,
            8: fa_b10,
            9: fa_d14,
            10: fa_e14,
            11: fa_f14,
            12: fa_g14,
            13: fa_h14,
            14: fa_i14
        },
        758: {
            1: fa_y9,
            2: fa_z9,
            3: fa_e3,
            4: fa_b14,
            5: fa_d7,
            6: fa_c14,
            7: fa_a10,
            8: fa_b10,
            9: fa_d14,
            10: fa_e14,
            11: fa_f14,
            12: fa_g14,
            13: fa_h14,
            14: fa_i14
        },
        452: {
            1: fa_l1,
            2: fa_m1
        },
        453: {
            1: fa_l1,
            2: fa_m1
        },
        454: {
            1: fa_l1,
            2: fa_m1
        },
        566: {
            1: fa_x1,
            2: fa_y1
        },
        567: {
            1: fa_x1,
            2: fa_y1
        },
        568: {
            1: fa_x1,
            2: fa_y1
        },
        569: {
            1: fa_x1,
            2: fa_y1
        },
        570: {
            1: fa_x1,
            2: fa_y1
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        369: {
            1: fa_h1,
            2: fa_i1
        },
        370: {
            1: fa_h1,
            2: fa_i1
        },
        522: {
            1: fa_x1,
            2: fa_y1
        },
        627: {
            1: fa_l1,
            2: fa_m1
        },
        628: {
            1: fa_l1,
            2: fa_m1
        },
        629: {
            1: fa_l1,
            2: fa_m1
        },
        630: {
            1: fa_l1,
            2: fa_m1
        },
        631: {
            1: fa_l1,
            2: fa_m1
        },
        632: {
            1: fa_l1,
            2: fa_m1
        },
        190: {
            1: fa_d1,
            2: fa_e1
        },
        191: {
            1: fa_d1,
            2: fa_e1
        },
        192: {
            1: fa_d1,
            2: fa_e1
        },
        193: {
            1: fa_d1,
            2: fa_e1
        },
        194: {
            1: fa_d1,
            2: fa_e1
        },
        759: {
            1: fa_j14,
            2: fa_k14,
            3: fa_l14,
            4: fa_m14,
            5: fa_n14,
            6: fa_h14,
            7: fa_o14,
            8: fa_p14,
            9: fa_q14,
            10: fa_r14,
            11: fa_s14,
            12: fa_t14,
            13: fa_c14,
            14: fa_u14
        },
        760: {
            1: fa_j14,
            2: fa_k14,
            3: fa_l14,
            4: fa_m14,
            5: fa_n14,
            6: fa_h14,
            7: fa_o14,
            8: fa_p14,
            9: fa_q14,
            10: fa_r14,
            11: fa_s14,
            12: fa_t14,
            13: fa_c14,
            14: fa_u14
        },
        761: {
            1: fa_j14,
            2: fa_k14,
            3: fa_l14,
            4: fa_m14,
            5: fa_n14,
            6: fa_h14,
            7: fa_o14,
            8: fa_p14,
            9: fa_q14,
            10: fa_r14,
            11: fa_s14,
            12: fa_t14,
            13: fa_c14,
            14: fa_u14
        },
        762: {
            1: fa_j14,
            2: fa_k14,
            3: fa_l14,
            4: fa_m14,
            5: fa_n14,
            6: fa_h14,
            7: fa_o14,
            8: fa_p14,
            9: fa_q14,
            10: fa_r14,
            11: fa_s14,
            12: fa_t14,
            13: fa_c14,
            14: fa_u14
        },
        763: {
            1: fa_j14,
            2: fa_k14,
            3: fa_l14,
            4: fa_m14,
            5: fa_n14,
            6: fa_h14,
            7: fa_o14,
            8: fa_p14,
            9: fa_q14,
            10: fa_r14,
            11: fa_s14,
            12: fa_t14,
            13: fa_c14,
            14: fa_u14
        },
        768: {
            1: fa_i6,
            2: fa_v14,
            3: fa_w14,
            4: fa_x14,
            5: fa_y14,
            6: fa_c2,
            7: fa_z14
        },
        769: {
            1: fa_i6,
            2: fa_v14,
            3: fa_w14,
            4: fa_x14,
            5: fa_y14,
            6: fa_c2,
            7: fa_z14
        },
        770: {
            1: fa_i6,
            2: fa_v14,
            3: fa_w14,
            4: fa_x14,
            5: fa_y14,
            6: fa_c2,
            7: fa_z14
        },
        771: {
            1: fa_i6,
            2: fa_v14,
            3: fa_w14,
            4: fa_x14,
            5: fa_y14,
            6: fa_c2,
            7: fa_z14
        },
        772: {
            1: fa_i6,
            2: fa_v14,
            3: fa_w14,
            4: fa_x14,
            5: fa_y14,
            6: fa_c2,
            7: fa_z14
        },
        603: {
            1: fa_x1,
            2: fa_y1
        },
        604: {
            1: fa_x1,
            2: fa_y1
        },
        605: {
            1: fa_x1,
            2: fa_y1
        },
        606: {
            1: fa_x1,
            2: fa_y1
        },
        607: {
            1: fa_x1,
            2: fa_y1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        696: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        333: {
            1: fa_d1,
            2: fa_e1
        },
        341: {
            1: fa_d1,
            2: fa_e1
        },
        427: {
            1: fa_l1,
            2: fa_m1
        },
        536: {
            1: fa_l1,
            2: fa_m1
        },
        905: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        514: {
            1: fa_x1,
            2: fa_y1
        },
        516: {
            1: fa_x1,
            2: fa_y1
        },
        305: {
            1: fa_d1,
            2: fa_e1
        },
        315: {
            1: fa_d1,
            2: fa_e1
        },
        523: {
            1: fa_l1,
            2: fa_m1
        },
        299: {
            1: fa_d1,
            2: fa_e1
        },
        309: {
            1: fa_d1,
            2: fa_e1
        },
        697: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        298: {
            1: fa_d1,
            2: fa_e1
        },
        308: {
            1: fa_d1,
            2: fa_e1
        },
        515: {
            1: fa_x1,
            2: fa_y1
        },
        549: {
            1: fa_l1,
            2: fa_m1
        },
        548: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        550: {
            1: fa_a15,
            2: fa_y1
        },
        551: {
            1: fa_x1,
            2: fa_b15
        },
        455: {
            1: fa_l1,
            2: fa_m1
        },
        456: {
            1: fa_l1,
            2: fa_m1
        },
        457: {
            1: fa_l1,
            2: fa_m1
        },
        458: {
            1: fa_l1,
            2: fa_m1
        },
        459: {
            1: fa_l1,
            2: fa_m1
        },
        460: {
            1: fa_l1,
            2: fa_m1
        },
        512: {
            1: fa_a15,
            2: fa_y1
        },
        513: {
            1: fa_c15,
            2: fa_b15
        },
        901: {
            1: fa_t13,
            2: fa_u13,
            3: fa_v13,
            4: fa_w13,
            5: fa_x13,
            6: fa_y13,
            7: fa_z13,
            8: fa_a14
        },
        902: {
            1: fa_t13,
            2: fa_u13,
            3: fa_v13,
            4: fa_w13,
            5: fa_x13,
            6: fa_y13,
            7: fa_z13,
            8: fa_a14
        },
        340: {
            1: fa_d1,
            2: fa_e1
        },
        328: {
            1: fa_d1,
            2: fa_e1
        },
        329: {
            1: fa_d1,
            2: fa_e1
        },
        342: {
            1: fa_d1,
            2: fa_e1
        },
        330: {
            1: fa_d1,
            2: fa_e1
        },
        331: {
            1: fa_d1,
            2: fa_e1
        },
        722: {
            1: fa_k10,
            2: fa_l10,
            3: fa_m10
        },
        560: {
            1: fa_l1,
            2: fa_m1
        },
        543: {
            1: fa_l1,
            2: fa_m1
        },
        544: {
            1: fa_l1,
            2: fa_m1
        },
        545: {
            1: fa_l1,
            2: fa_m1
        },
        546: {
            1: fa_l1,
            2: fa_m1
        },
        332: {
            1: fa_d1,
            2: fa_e1
        },
        559: {
            1: fa_l1,
            2: fa_m1
        },
        296: {
            1: fa_d1,
            2: fa_e1
        },
        297: {
            1: fa_d1,
            2: fa_e1
        },
        717: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        718: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        719: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        720: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        721: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        552: {
            1: fa_b1,
            2: fa_c1
        },
        76: {
            1: fa_b1,
            2: fa_c1
        },
        77: {
            1: fa_b1,
            2: fa_c1
        },
        78: {
            1: fa_b1,
            2: fa_c1
        },
        79: {
            1: fa_b1,
            2: fa_c1
        },
        80: {
            1: fa_b1,
            2: fa_c1
        },
        647: {
            1: fa_x1,
            2: fa_y1
        },
        741: {
            1: fa_d15,
            2: fa_t7,
            3: fa_e15
        },
        82: {
            1: fa_b1,
            2: fa_c1
        },
        338: {
            1: fa_d1,
            2: fa_e1
        }
    },
    17: {
        348: {
            1: fa_d1,
            2: fa_e1
        },
        443: {
            1: fa_f15,
            2: fa_g15
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    4: {
        73: {
            1: fa_b1,
            2: fa_c1
        },
        318: {
            1: fa_d1,
            2: fa_e1
        },
        21: {
            1: fa_b1,
            2: fa_c1
        },
        22: {
            1: fa_b1,
            2: fa_c1
        },
        23: {
            1: fa_b1,
            2: fa_c1
        },
        24: {
            1: fa_b1,
            2: fa_c1
        },
        25: {
            1: fa_b1,
            2: fa_c1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        199: {
            1: fa_d1,
            2: fa_e1
        },
        352: {
            1: fa_d1,
            2: fa_e1
        },
        764: {
            1: fa_o1,
            2: fa_q1,
            3: fa_t1,
            4: fa_u1,
            5: fa_v1,
            6: fa_w1
        },
        102: {
            1: fa_f1,
            2: fa_g1
        },
        403: {
            1: fa_h1,
            2: fa_i1
        },
        138: {
            1: fa_d1,
            2: fa_e1
        },
        139: {
            1: fa_d1,
            2: fa_e1
        },
        140: {
            1: fa_d1,
            2: fa_e1
        },
        141: {
            1: fa_d1,
            2: fa_e1
        },
        142: {
            1: fa_d1,
            2: fa_e1
        },
        182: {
            1: fa_d1,
            2: fa_e1
        },
        183: {
            1: fa_d1,
            2: fa_e1
        },
        184: {
            1: fa_d1,
            2: fa_e1
        },
        185: {
            1: fa_d1,
            2: fa_e1
        },
        186: {
            1: fa_d1,
            2: fa_e1
        },
        366: {
            1: fa_h1,
            2: fa_i1
        },
        367: {
            1: fa_h1,
            2: fa_i1
        },
        368: {
            1: fa_h1,
            2: fa_i1
        },
        369: {
            1: fa_h1,
            2: fa_i1
        },
        370: {
            1: fa_h1,
            2: fa_i1
        },
        566: {
            1: fa_x1,
            2: fa_y1
        },
        567: {
            1: fa_x1,
            2: fa_y1
        },
        568: {
            1: fa_x1,
            2: fa_y1
        },
        569: {
            1: fa_x1,
            2: fa_y1
        },
        570: {
            1: fa_x1,
            2: fa_y1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        923: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        924: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        925: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        926: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        927: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        929: {
            1: fa_s3,
            2: fa_h15,
            3: fa_i15,
            4: fa_j15,
            5: fa_z6
        },
        930: {
            1: fa_s3,
            2: fa_h15,
            3: fa_i15,
            4: fa_j15,
            5: fa_z6
        },
        931: {
            1: fa_s3,
            2: fa_h15,
            3: fa_i15,
            4: fa_j15,
            5: fa_z6
        },
        932: {
            1: fa_s3,
            2: fa_h15,
            3: fa_i15,
            4: fa_j15,
            5: fa_z6
        },
        933: {
            1: fa_s3,
            2: fa_h15,
            3: fa_i15,
            4: fa_j15,
            5: fa_z6
        },
        845: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_i1
        },
        846: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_i1
        },
        847: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_i1
        },
        848: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_i1
        },
        849: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_i1
        },
        918: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_h1
        },
        919: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_h1
        },
        920: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_h1
        },
        921: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_h1
        },
        922: {
            1: fa_t1,
            2: fa_d7,
            3: fa_k15,
            4: fa_h1
        },
        83: {
            1: fa_f1,
            2: fa_g1
        },
        84: {
            1: fa_f1,
            2: fa_g1
        },
        85: {
            1: fa_f1,
            2: fa_g1
        },
        86: {
            1: fa_f1,
            2: fa_g1
        },
        87: {
            1: fa_f1,
            2: fa_g1
        },
        905: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        906: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        907: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        908: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        909: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        807: {
            1: fa_k6,
            2: fa_m6,
            3: fa_q6,
            4: fa_s6
        },
        319: {
            1: fa_d1,
            2: fa_e1
        },
        320: {
            1: fa_d1,
            2: fa_e1
        },
        912: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        },
        913: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        },
        914: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        },
        915: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        },
        916: {
            1: fa_j7,
            2: fa_k7,
            3: fa_l7,
            4: fa_m7,
            5: fa_n7,
            6: fa_o7
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        },
        257: {
            1: fa_d1,
            2: fa_e1
        },
        307: {
            1: fa_d1,
            2: fa_e1
        },
        362: {
            1: fa_h1,
            2: fa_i1
        },
        363: {
            1: fa_h1,
            2: fa_i1
        },
        364: {
            1: fa_h1,
            2: fa_i1
        },
        365: {
            1: fa_h1,
            2: fa_i1
        },
        17: {
            1: fa_b1,
            2: fa_c1
        },
        18: {
            1: fa_b1,
            2: fa_c1
        },
        19: {
            1: fa_b1,
            2: fa_c1
        },
        20: {
            1: fa_b1,
            2: fa_c1
        },
        176: {
            1: fa_d1,
            2: fa_e1
        },
        177: {
            1: fa_d1,
            2: fa_e1
        },
        178: {
            1: fa_d1,
            2: fa_e1
        },
        179: {
            1: fa_d1,
            2: fa_e1
        },
        358: {
            1: fa_h1,
            2: fa_i1
        },
        359: {
            1: fa_h1,
            2: fa_i1
        },
        360: {
            1: fa_h1,
            2: fa_i1
        },
        361: {
            1: fa_h1,
            2: fa_i1
        },
        13: {
            1: fa_b1,
            2: fa_c1
        },
        14: {
            1: fa_b1,
            2: fa_c1
        },
        15: {
            1: fa_b1,
            2: fa_c1
        },
        16: {
            1: fa_b1,
            2: fa_c1
        },
        172: {
            1: fa_d1,
            2: fa_e1
        },
        173: {
            1: fa_d1,
            2: fa_e1
        },
        174: {
            1: fa_d1,
            2: fa_e1
        },
        175: {
            1: fa_d1,
            2: fa_e1
        },
        281: {
            1: fa_d1,
            2: fa_e1
        },
        137: {
            1: fa_d1,
            2: fa_e1
        },
        616: {
            1: fa_x1,
            2: fa_y1
        },
        617: {
            1: fa_x1,
            2: fa_y1
        },
        618: {
            1: fa_x1,
            2: fa_y1
        },
        619: {
            1: fa_x1,
            2: fa_y1
        },
        620: {
            1: fa_x1,
            2: fa_y1
        },
        891: {
            1: fa_e2,
            2: fa_f2,
            3: fa_g2,
            4: fa_h2
        },
        26: {
            1: fa_l15,
            2: fa_m15
        },
        200: {
            1: fa_d1,
            2: fa_e1
        },
        143: {
            1: fa_d1,
            2: fa_e1
        },
        187: {
            1: fa_d1,
            2: fa_e1
        },
        371: {
            1: fa_h1,
            2: fa_i1
        },
        571: {
            1: fa_x1,
            2: fa_y1
        },
        928: {
            1: fa_s3,
            2: fa_t6,
            3: fa_u6,
            4: fa_v6,
            5: fa_w6,
            6: fa_x6,
            7: fa_y6,
            8: fa_z6
        },
        934: {
            1: fa_s3,
            2: fa_h15,
            3: fa_i15,
            4: fa_j15,
            5: fa_z6
        },
        88: {
            1: fa_f1,
            2: fa_g1
        },
        910: {
            1: fa_f7,
            2: fa_g7,
            3: fa_h7,
            4: fa_i7
        },
        917: {
            1: fa_j7,
            2: fa_k7,
            3: fa_n15,
            4: fa_m7,
            5: fa_n7,
            6: fa_o15
        },
        936: {
            1: fa_k2,
            2: fa_l2,
            3: fa_m2,
            4: fa_n2,
            5: fa_o2,
            6: fa_g6
        }
    },
    8: {
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        656: {
            1: fa_b2,
            2: fa_c2,
            3: fa_d2
        },
        698: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        195: {
            1: fa_d1,
            2: fa_e1
        },
        196: {
            1: fa_d1,
            2: fa_e1
        },
        197: {
            1: fa_d1,
            2: fa_e1
        },
        198: {
            1: fa_d1,
            2: fa_e1
        },
        673: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        674: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        675: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        676: {
            1: fa_h1,
            2: fa_z1,
            3: fa_i1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    27: {
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    },
    28: {
        403: {
            1: fa_h1,
            2: fa_i1
        },
        615: {
            1: fa_x1,
            2: fa_y1
        },
        74: {
            1: fa_b1,
            2: fa_c1
        },
        349: {
            1: fa_d1,
            2: fa_e1
        },
        256: {
            1: fa_d1,
            2: fa_e1
        },
        306: {
            1: fa_d1,
            2: fa_e1
        },
        103: {
            1: fa_f1,
            2: fa_g1
        },
        935: {
            1: fa_a10,
            2: fa_b10,
            3: fa_d14,
            4: fa_e14,
            5: fa_f14,
            6: fa_p15,
            7: fa_y9,
            8: fa_z9,
            9: fa_e3,
            10: fa_b14,
            11: fa_d7,
            12: fa_q15
        },
        612: {
            1: fa_l1,
            2: fa_m1
        },
        613: {
            1: fa_l1,
            2: fa_m1
        },
        443: {
            1: fa_j1,
            2: fa_k1
        },
        608: {
            1: fa_l1,
            2: fa_m1
        }
    }
};
var periodConfig = {
    2: {
        208: 'O`yin tugadi',
        207: 'Yettinchi partiya',
        206: 'Oltinchi partiya',
        205: 'Beshinchi partiya',
        200: 'O`yin hali boshlanmadi',
        203: 'Uchinchi partiya',
        202: 'Ikkinchi partiya',
        201: 'Birinchi partiya',
        204: 'To`rtinchi partiya'
    },
    3: {
        304: 'O`yin tugadi',
        303: 'Uchinchi set',
        302: 'Ikkinchi set',
        301: 'Birinchi set',
        300: 'O`yin hali boshlanmadi'
    },
    4: {
        406: 'O`yin tugadi',
        403: 'Uchinchi set',
        402: 'Ikkinchi set',
        401: 'Birinchi set',
        400: 'O`yin hali boshlanmadi',
        407: 'Oltin set',
        405: 'Beshinchi set',
        404: 'To`rtinchi set'
    },
    5: {
        510: 'O`ninchi raund',
        509: 'To`qqizinchi raund',
        508: 'Sakkizinchi raund',
        507: 'Yettinchi raund',
        506: 'Oltinchi raund',
        505: 'Beshinchi raund',
        513: 'O`yin tugadi',
        503: 'Uchinchi raund',
        500: 'O`yin hali boshlanmadi',
        501: 'Birinchi raund',
        502: 'Ikkinchi raund',
        511: 'O`n birinchi raund',
        512: 'O`n ikkinchi raund',
        504: 'To`rtinchi raund'
    },
    6: {
        600: 'O`yin hali boshlanmadi',
        601: 'Birinchi set',
        602: 'Ikkinchi set',
        603: 'Uchinchi set',
        604: 'To`rtinchi set',
        605: 'Beshinchi set',
        606: 'O`yin tugadi'
    },
    7: {
        701: 'Birinchi Bo`lim',
        700: 'O`yin hali boshlanmadi',
        703: 'Ikkinchi Bo`lim',
        704: 'Asosiy vaqt tugadi',
        705: 'Birinchi qo`shimcha bo`lim',
        702: 'Tanaffus',
        707: 'Ikkinchi qo`shimcha bo`lim',
        708: 'Ikkinchi qo`shimcha bo`lim tugadi',
        709: 'Penalti',
        710: 'O`yin tugadi',
        706: 'Birinchi qo`shimcha bo`lim tugadi'
    },
    8: {
        808: 'To`xtalish',
        807: 'To`rtinchi chorak',
        806: 'To`xtalish',
        805: 'Uchinchi chorak',
        804: 'Tanaffus',
        809: 'Overtime',
        802: 'To`xtalish',
        801: 'Birinchi chorak',
        800: 'O`yin hali boshlanmadi',
        810: 'O`yin tugadi',
        803: 'Ikkinchi chorak'
    },
    9: {
        903: 'Ikkinchi Bo`lim',
        902: 'Tanaffus',
        901: 'Birinchi Bo`lim',
        900: 'O`yin hali boshlanmadi',
        904: 'O`yin tugadi'
    },
    12: {
        1203: 'Ikkinchi Bo`lim',
        1202: 'Tanaffus',
        1201: 'Birinchi Bo`lim',
        1200: 'O`yin hali boshlanmadi',
        1204: 'O`yin tugadi'
    },
    18: {
        1808: 'Overtime tugadi',
        1807: 'Overtime',
        1806: 'Asosiy vaqt tugadi',
        1805: 'Uchinchi davr',
        1804: 'Ikkinchi Tanaffus',
        1809: 'Penalti',
        1802: 'Birinchi Tanaffus',
        1801: 'Birinchi davr',
        1800: 'O`yin hali boshlanmadi',
        1810: 'O`yin tugadi',
        1803: 'Ikkinchi davr'
    },
    19: {
        1904: 'Asosiy vaqt tugadi',
        1903: 'Ikkinchi Bo`lim',
        1902: 'Tanaffus',
        1901: 'Birinchi Bo`lim',
        1900: 'O`yin hali boshlanmadi',
        1905: 'O`yin tugadi'
    },
    20: {
        2016: 'Sakkizinchi o`t ochish marrasi',
        2017: 'O`yin tugadi',
        2000: 'O`yin hali boshlanmadi',
        2001: 'Birinchi aylana',
        2002: 'Birinchi o`t ochish marrasi',
        2003: 'Ikkinchi aylana',
        2004: 'Ikkinchi o`t ochish marrasi',
        2005: 'Uchinchi aylana',
        2006: 'Uchinchi o`t ochish marrasi',
        2007: 'To`rtinchi aylana',
        2008: 'To`rtinchi o`t ochish marrasi',
        2009: 'Beshinchi aylana',
        2010: 'Beshinchi o`t ochish marrasi',
        2011: 'Oltinchi aylana',
        2012: 'Oltinchi o`t ochish marrasi',
        2013: 'Yettinchi aylana',
        2014: 'Yettinchi o`t ochish marrasi',
        2015: 'Sakkizinchi aylana'
    },
    28: {
        2801: 'Asosiy vaqt',
        2802: 'O`yin tugadi',
        2800: 'O`yin hali boshlanmadi'
    },
    29: {
        2911: '6-partiya',
        2912: 'Tanaffus',
        2913: '7-partiya',
        2914: 'Tanaffus',
        2915: '8-partiya',
        2916: 'Tanaffus',
        2917: '9-partiya',
        2918: 'Tanaffus',
        2919: '10-partiya',
        2920: 'Tanaffus',
        2921: '11-partiya',
        2964: 'Tanaffus',
        2965: '33-partiya',
        2966: 'Tanaffus',
        2967: '34-partiya',
        2968: 'Tanaffus',
        2969: '35-partiya',
        2970: 'Tanaffus',
        2971: '36-partiya',
        2972: 'Tanaffus',
        2973: '37-partiya',
        2974: 'O`yin tugadi',
        2943: '22-partiya',
        2944: 'Tanaffus',
        2945: '23-partiya',
        2946: 'Tanaffus',
        2947: '24-partiya',
        2948: 'Tanaffus',
        2949: '25-partiya',
        2950: 'Tanaffus',
        2951: '26-partiya',
        2952: 'Tanaffus',
        2953: '27-partiya',
        2954: 'Tanaffus',
        2955: '28-partiya',
        2956: 'Tanaffus',
        2957: '29-partiya',
        2958: 'Tanaffus',
        2959: '30-partiya',
        2960: 'Tanaffus',
        2961: '31-partiya',
        2962: 'Tanaffus',
        2963: '32-partiya',
        2922: 'Tanaffus',
        2923: '12-partiya',
        2924: 'Tanaffus',
        2925: '13-partiya',
        2926: 'Tanaffus',
        2927: '14-partiya',
        2928: 'Tanaffus',
        2929: '15-partiya',
        2930: 'Tanaffus',
        2931: '16-partiya',
        2932: 'Tanaffus',
        2933: '17-partiya',
        2934: 'Tanaffus',
        2935: '18-partiya',
        2936: 'Tanaffus',
        2937: '19-partiya',
        2938: 'Tanaffus',
        2939: '20-partiya',
        2940: 'Tanaffus',
        2941: '21-partiya',
        2942: 'Tanaffus',
        2900: 'O`yin hali boshlanmadi',
        2901: '1-partiya',
        2902: 'Tanaffus',
        2903: '2-partiya',
        2904: 'Tanaffus',
        2905: '3-partiya',
        2906: 'Tanaffus',
        2907: '4-partiya',
        2908: 'Tanaffus',
        2909: '5-partiya',
        2910: 'Tanaffus'
    },
    30: {
        3008: 'Qo`shimcha vaqt tugadi',
        3007: 'Overtime',
        3006: 'Asosiy vaqt tugadi',
        3005: 'Uchinchi davr',
        3004: 'Ikkinchi Tanaffus',
        3009: 'Bullitlar',
        3002: 'Birinchi Tanaffus',
        3001: 'Birinchi davr',
        3000: 'O`yin hali boshlanmadi',
        3010: 'O`yin tugadi',
        3003: 'Ikkinchi davr'
    },
    31: {
        3108: 'To`xtalish',
        3107: 'To`rtinchi chorak',
        3106: 'To`xtalish',
        3105: 'Uchinchi chorak',
        3104: 'Tanaffus',
        3109: 'Overtime',
        3102: 'To`xtalish',
        3101: 'Birinchi chorak',
        3100: 'O`yin hali boshlanmadi',
        3110: 'O`yin tugadi',
        3103: 'Ikkinchi chorak'
    },
    32: {
        3203: 'Uchinchi set',
        3202: 'Ikkinchi set',
        3201: 'Birinchi set',
        3200: 'O`yin hali boshlanmadi',
        3204: 'O`yin tugadi'
    },
    34: {
        3400: 'O`yin hali boshlanmadi',
        3401: 'Birinchi bo`lim',
        3402: 'Tanaffus',
        3403: 'Ikkinchi bo`lim',
        3404: 'Asosiy vaqt tugadi',
        3410: 'O`yin tugadi',
        3406: 'Birinchi qo`shimcha bo`lim tugadi',
        3407: 'Ikkinchi qo`shimcha bo`lim',
        3408: 'Ikkinchi qo`shimcha bo`lim tugadi',
        3409: 'Penalti',
        3405: 'Birinchi qo`shimcha bo`lim'
    },
    35: {
        3500: 'O`yin hali boshlanmadi',
        3501: 'Birinchi Bo`lim',
        3502: 'Tanaffus',
        3503: 'Ikkinchi Bo`lim',
        3504: 'O`yin tugadi'
    },
    36: {
        3601: 'Birinchi davr',
        3602: 'Birinchi Tanaffus',
        3603: 'Ikkinchi davr',
        3604: 'Ikkinchi Tanaffus',
        3605: 'Uchinchi davr',
        3600: 'O`yin hali boshlanmadi',
        3607: 'Overtime',
        3608: 'Qo`shimcha vaqt tugadi',
        3609: 'Bullitlar',
        3610: 'O`yin tugadi',
        3606: 'Asosiy vaqt tugadi'
    },
    37: {
        3701: 'O`yin tugadi',
        3700: 'O`yin hali boshlanmadi'
    },
    38: {
        3801: 'O`yin tugadi',
        3800: 'O`yin hali boshlanmadi'
    },
    39: {
        3901: 'O`yin tugadi',
        3900: 'O`yin hali boshlanmadi',
        3902: 'Birinchi raund',
        3903: 'Ikkinchi raund',
        3904: 'Uchinchi raund',
        3905: 'To`rtinchi raund',
        3906: 'Beshinchi raund'
    },
    40: {
        4001: 'O`yin tugadi',
        4000: 'O`yin hali boshlanmadi'
    },
    41: {
        4102: 'Birinchi Tanaffus',
        4106: 'O`yin tugadi',
        4105: 'Overtime',
        4104: 'Ikkinchi Tanaffus',
        4103: 'O`yinning ikkinchi yarmi',
        4101: 'O`yinning birinchi yarmi',
        4100: 'O`yin hali boshlanmadi'
    },
    42: {
        4202: 'Ikkinchi xarita',
        4206: 'O`yin tugadi',
        4205: 'Beshinchi xarita',
        4204: 'To`rtinchi xarita',
        4203: 'Uchinchi xarita',
        4201: 'Birinchi xarita',
        4200: 'O`yin hali boshlanmadi'
    }
};
export function getOutcomeName(sportId, outcome, match) {
    var func;
    if (baseOutcomeConfig !== undefined &&
        baseOutcomeConfig[sportId] !== undefined &&
        baseOutcomeConfig[sportId]) {
        func = baseOutcomeConfig[sportId][outcome.type];
    }
    if (outcomeConfig !== undefined &&
        outcomeConfig[sportId] !== undefined &&
        outcomeConfig[sportId][outcome.type] !== undefined) {
        func = outcomeConfig[sportId][outcome.type];
    }
    if (func === undefined) {
        return undefined;
    }
    return func(match, outcome);
}
export function getRateName(sportId, outcome, factorType, match) {
    var func;
    if (baseFactorNameConfig !== undefined &&
        baseFactorNameConfig[sportId] !== undefined &&
        baseFactorNameConfig[sportId][outcome.type] !== undefined) {
        func = baseFactorNameConfig[sportId][outcome.type][factorType];
    }
    if (func === undefined) {
        return undefined;
    }
    return func(match, outcome);
}
export function getPeriodName(sportId, periodId) {
    if (periodConfig !== undefined && periodConfig[sportId] !== undefined) {
        return periodConfig[sportId][periodId];
    }
    return undefined;
}



// WEBPACK FOOTER //
// ./src/localization/uz.js